import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum AlignEnum {
  End = 'END',
  Start = 'START'
}

export enum AspectRatioEnum {
  Aspect_1_1 = 'ASPECT_1_1',
  Aspect_2_3 = 'ASPECT_2_3',
  Aspect_3_2 = 'ASPECT_3_2',
  Aspect_3_4 = 'ASPECT_3_4',
  Aspect_4_3 = 'ASPECT_4_3',
  Aspect_16_9 = 'ASPECT_16_9',
  Aspect_16_10 = 'ASPECT_16_10'
}

export enum AvailabilityEnum {
  Archived = 'ARCHIVED',
  Available = 'AVAILABLE',
  Reserved = 'RESERVED'
}

export enum BeforeAfterEnum {
  After = 'AFTER',
  Before = 'BEFORE'
}

export type BlockAccordionSectionInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};

export type BlockAppDownloadInput = {
  androidHref: Scalars['String']['input'];
  androidLabel: Scalars['String']['input'];
  iosHref: Scalars['String']['input'];
  iosLabel: Scalars['String']['input'];
};

export type BlockAutoplayInput = {
  fileHash: Scalars['String']['input'];
};

export type BlockAwardInput = {
  fileHash: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BlockBannerInput = {
  cta?: InputMaybe<BlockButtonInput>;
  fileHash: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BlockButtonInput =
  { btnCopy: CopyButtonInput; btnDoc?: never; btnDownload?: never; btnHref?: never; btnNestedContent?: never; }
  |  { btnCopy?: never; btnDoc: DocButtonInput; btnDownload?: never; btnHref?: never; btnNestedContent?: never; }
  |  { btnCopy?: never; btnDoc?: never; btnDownload: DownloadButtonInput; btnHref?: never; btnNestedContent?: never; }
  |  { btnCopy?: never; btnDoc?: never; btnDownload?: never; btnHref: HrefButtonInput; btnNestedContent?: never; }
  |  { btnCopy?: never; btnDoc?: never; btnDownload?: never; btnHref?: never; btnNestedContent: NestedContentButtonInput; };

export type BlockChapterOpenerInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  fileHash?: InputMaybe<Scalars['String']['input']>;
  fileHashMobile?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type BlockDataSheetInput = {
  config: DataSheetConfigInput;
  rawItems: Array<Scalars['JSON']['input']>;
  sections: Array<DataSheetSectionInput>;
};

export type BlockDocumentHeaderInput = {
  callout?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type BlockExternalLinkInput = {
  mediaHash?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type BlockHighlightInput = {
  cta: BlockButtonInput;
  description: Scalars['String']['input'];
  fileHash: Scalars['String']['input'];
  fileHashMobile?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  visualization: BlockHighlightVisualizationEnum;
};

export enum BlockHighlightVisualizationEnum {
  Default = 'DEFAULT',
  TextImage = 'TEXT_IMAGE',
  TextImageViceVersa = 'TEXT_IMAGE_VICE_VERSA',
  ViceVersa = 'VICE_VERSA'
}

export type BlockIntegrationInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  integrationType: OfficeIntegrationEnum;
};

/** file_hash must be set if visualization != WITHOUT_IMAGE */
export type BlockKeyFactInput = {
  aspectRatio?: InputMaybe<AspectRatioEnum>;
  items: Array<BlockKeyFactItemInput>;
  visualization: BlockKeyFactVisualizationEnum;
};

export type BlockKeyFactItemInput = {
  callout?: InputMaybe<Scalars['String']['input']>;
  cta?: InputMaybe<BlockButtonInput>;
  fileHash?: InputMaybe<Scalars['String']['input']>;
  mediaDivider: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type BlockKeyFactSmallInput = {
  callout?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  fileHash: Scalars['String']['input'];
  fileHashMobile?: InputMaybe<Scalars['String']['input']>;
  heading: Scalars['String']['input'];
};

export enum BlockKeyFactVisualizationEnum {
  WithoutImage = 'WITHOUT_IMAGE',
  WithImage = 'WITH_IMAGE'
}

export type BlockKeyValueTableInput = {
  alignValue: AlignEnum;
  keyValues: Array<KeyValueInput>;
};

export type BlockKpiInput =
  { numberValue: KpiNumberValueInput; stringValue?: never; }
  |  { numberValue?: never; stringValue: KpiStringValueInput; };

export type BlockMediaComparisonSliderInput = {
  fileHash1: Scalars['String']['input'];
  fileHash2: Scalars['String']['input'];
};

export type BlockMediaGalleryInput = {
  items: Array<FileHashTextInput>;
  visualization: BlockMediaGalleryVisualizationEnum;
};

export enum BlockMediaGalleryVisualizationEnum {
  Carousel = 'CAROUSEL',
  Gallery = 'GALLERY',
  MediaStream = 'MEDIA_STREAM',
  ThreeSixty = 'THREE_SIXTY',
  Thumbnails = 'THUMBNAILS'
}

export type BlockMediaSingleImageInput = {
  fileHash: Scalars['String']['input'];
  fileHashMobile?: InputMaybe<Scalars['String']['input']>;
};

export type BlockMetaInput = {
  countryCodes: Array<CountryCodeEnum>;
  /** @deprecated Currently not used, but needed for types */
  disclaimer?: InputMaybe<Scalars['ID']['input']>;
  documentVersionId: Scalars['ID']['input'];
  /** Block id */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** must be set if moved to a block */
  needleBlockId?: InputMaybe<Scalars['ID']['input']>;
  panelId: Scalars['ID']['input'];
  /** must be set if moved or created */
  position?: InputMaybe<BeforeAfterEnum>;
  pullout: Scalars['Boolean']['input'];
};

export type BlockRichTextInput = {
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum BlockStatusActionEnum {
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type BlockVehicleDataInput = {
  keyValues: Array<KeyValueInput>;
  name: Scalars['String']['input'];
};

export type BlockVideoInput = {
  /**
   * Prefill data with crawled data. Other attributes than url are ignored
   * @deprecated Ignored
   */
  prefill?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnailHash?: InputMaybe<Scalars['String']['input']>;
  videoUrl: Scalars['String']['input'];
};

export type BlockVideoWithDescriptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  openInNewTab: Scalars['Boolean']['input'];
  /**
   * Prefill data with crawled data. Other attributes than url are ignored
   * @deprecated Ignored
   */
  prefill?: InputMaybe<Scalars['Boolean']['input']>;
  thumbnailHash?: InputMaybe<Scalars['String']['input']>;
  videoUrl: Scalars['String']['input'];
};

export enum ButtonIconEnum {
  Admin = 'ADMIN',
  ArrowLeft = 'ARROW_LEFT',
  Car = 'CAR',
  ChevronDown = 'CHEVRON_DOWN',
  ChevronLeft = 'CHEVRON_LEFT',
  ChevronRight = 'CHEVRON_RIGHT',
  ChevronUp = 'CHEVRON_UP',
  Close = 'CLOSE',
  Co2 = 'CO2',
  Co2Large = 'CO2_LARGE',
  ContentManagement = 'CONTENT_MANAGEMENT',
  Copy = 'COPY',
  Document = 'DOCUMENT',
  Download = 'DOWNLOAD',
  DragHorizontal = 'DRAG_HORIZONTAL',
  Efficiency = 'EFFICIENCY',
  EfficiencyLarge = 'EFFICIENCY_LARGE',
  Electric = 'ELECTRIC',
  ElectricLarge = 'ELECTRIC_LARGE',
  Expand = 'EXPAND',
  ExternalLink = 'EXTERNAL_LINK',
  ExternalLinkLarge = 'EXTERNAL_LINK_LARGE',
  Eye = 'EYE',
  Filter = 'FILTER',
  Gas = 'GAS',
  GasLarge = 'GAS_LARGE',
  Info = 'INFO',
  InfoCircle = 'INFO_CIRCLE',
  InfoCircleFilled = 'INFO_CIRCLE_FILLED',
  LeadGenerator = 'LEAD_GENERATOR',
  Mail = 'MAIL',
  Minus = 'MINUS',
  Overflow = 'OVERFLOW',
  Phone = 'PHONE',
  Placeholder = 'PLACEHOLDER',
  Play = 'PLAY',
  Plus = 'PLUS',
  Sales = 'SALES',
  Search = 'SEARCH',
  Share = 'SHARE',
  Spinner = 'SPINNER',
  Support = 'SUPPORT',
  User = 'USER',
  Warning = 'WARNING'
}

export enum ButtonSizeEnum {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export enum ButtonVariantEnum {
  Filled = 'FILLED',
  FilledBrand = 'FILLED_BRAND',
  FilledInversed = 'FILLED_INVERSED',
  Flat = 'FLAT',
  Outline = 'OUTLINE',
  OutlineInversed = 'OUTLINE_INVERSED',
  Overlay = 'OVERLAY',
  OverlayBrand = 'OVERLAY_BRAND',
  OverlayInversed = 'OVERLAY_INVERSED',
  Secondary = 'SECONDARY'
}

export enum CcDataTypeEnum {
  TypeAudi = 'TYPE_AUDI',
  TypeCupra = 'TYPE_CUPRA',
  TypeSeat = 'TYPE_SEAT'
}

export enum CarTypeEnum {
  Anual = 'ANUAL',
  Company = 'COMPANY',
  Fallback = 'FALLBACK',
  New = 'NEW',
  Oldtimer = 'OLDTIMER',
  Presentation = 'PRESENTATION',
  Used = 'USED'
}

export type ComplexFilterInputType = {
  carType?: InputMaybe<Scalars['Int']['input']>;
  ez?: InputMaybe<MinMaxInputIntType>;
  getriebeart?: InputMaybe<Scalars['Int']['input']>;
  kilometer?: InputMaybe<MinMaxInputIntType>;
  kraftstoffart?: InputMaybe<Scalars['Int']['input']>;
  reducedCarType?: InputMaybe<ReducedCarType>;
  totalPrice?: InputMaybe<MinMaxInputIntType>;
};

export type ComplexModellFilterInputType = {
  brand?: InputMaybe<Scalars['String']['input']>;
  modell?: InputMaybe<Scalars['String']['input']>;
  series?: InputMaybe<Scalars['String']['input']>;
};

export type CopyButtonInput = {
  content: Scalars['String']['input'];
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  leadingIcon?: InputMaybe<ButtonIconEnum>;
  size: ButtonSizeEnum;
  trailingIcon?: InputMaybe<ButtonIconEnum>;
  variant: ButtonVariantEnum;
};

export enum CountryCodeEnum {
  At = 'AT',
  De = 'DE'
}

export type CreateUpdateDocumentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isLive: Scalars['Boolean']['input'];
  keyVisual: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  xcCollectionId: Scalars['ID']['input'];
};

export type CtaCallbackDataInput = {
  actions?: InputMaybe<Array<ExposeFolderCtaEnum>>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CtaResellDataInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  expectedPrice?: InputMaybe<Scalars['Int']['input']>;
  ez: Scalars['Date']['input'];
  fuelType: Scalars['String']['input'];
  gear: Scalars['String']['input'];
  hu: Scalars['String']['input'];
  km: Scalars['Int']['input'];
  manufactur: Scalars['String']['input'];
  name: Scalars['String']['input'];
  numberVehicleHolder: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  ps: Scalars['Int']['input'];
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type DataSheetConfigInput = {
  additionalFieldName?: InputMaybe<Scalars['String']['input']>;
  ctaFieldName: Scalars['String']['input'];
  descriptionFieldName?: InputMaybe<Scalars['String']['input']>;
  filterFieldName?: InputMaybe<Scalars['String']['input']>;
  keyVisualFieldName: Scalars['String']['input'];
  titleFieldName: Scalars['String']['input'];
};

export enum DataSheetLookupEnum {
  Lookup = 'LOOKUP',
  Static = 'STATIC'
}

export type DataSheetLookupInput = {
  lookupType: DataSheetLookupEnum;
  processors: Array<DataSheetProcessorInput>;
  value: Scalars['String']['input'];
};

export enum DataSheetProcessorEnum {
  ConvertToFloat = 'CONVERT_TO_FLOAT',
  ConvertToInt = 'CONVERT_TO_INT',
  Prefix = 'PREFIX',
  Suffix = 'SUFFIX'
}

export type DataSheetProcessorInput = {
  payload?: InputMaybe<DataSheetLookupInput>;
  processor: DataSheetProcessorEnum;
};

export type DataSheetSectionInput = {
  items: Array<DataSheetSectionItemInput>;
  sectionName: Scalars['String']['input'];
};

export type DataSheetSectionItemInput = {
  label: DataSheetLookupInput;
  value: DataSheetLookupInput;
};

export type DateRangeInput = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

export type DisclaimerInput =
  { xcDoc: XcDocDisclaimerInput; xcFile?: never; xcInfoFootnote?: never; xcRectangleFootnote?: never; }
  |  { xcDoc?: never; xcFile: Scalars['Upload']['input']; xcInfoFootnote?: never; xcRectangleFootnote?: never; }
  |  { xcDoc?: never; xcFile?: never; xcInfoFootnote: XcInfoFootnoteInput; xcRectangleFootnote?: never; }
  |  { xcDoc?: never; xcFile?: never; xcInfoFootnote?: never; xcRectangleFootnote: XcRectangleFootnoteInput; };

export enum DisclaimerVariantEnum {
  Brand = 'BRAND',
  InversedPrimary = 'INVERSED_PRIMARY',
  InversedTertiary = 'INVERSED_TERTIARY',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export type DocButtonInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['UUID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  leadingIcon?: InputMaybe<ButtonIconEnum>;
  size: ButtonSizeEnum;
  trailingIcon?: InputMaybe<ButtonIconEnum>;
  variant: ButtonVariantEnum;
};

export type DownloadButtonInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  fileHash: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  leadingIcon?: InputMaybe<ButtonIconEnum>;
  size: ButtonSizeEnum;
  trailingIcon?: InputMaybe<ButtonIconEnum>;
  variant: ButtonVariantEnum;
};

export enum DriveTypeEnum {
  All = 'ALL',
  Back = 'BACK',
  Front = 'FRONT'
}

export enum EnvkvTypeEnum {
  Co2Class = 'CO2_CLASS',
  Co2ClassEmptyBattery = 'CO2_CLASS_EMPTY_BATTERY',
  ConsumptionElectric = 'CONSUMPTION_ELECTRIC',
  ConsumptionGas = 'CONSUMPTION_GAS',
  ConsumptionGasEmptyBattery = 'CONSUMPTION_GAS_EMPTY_BATTERY',
  ConsumptionHybrid = 'CONSUMPTION_HYBRID',
  Emission = 'EMISSION'
}

export enum ErrorCodeEnum {
  BadRequest = 'BAD_REQUEST',
  NotFound = 'NOT_FOUND',
  Unauthorized = 'UNAUTHORIZED'
}

export type EufeRequestContactPersonCtaInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dksCampaignId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  exposeFolderSlug?: InputMaybe<Scalars['String']['input']>;
  extra?: InputMaybe<Scalars['JSON']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<SalutationEnum>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  xcCampaignId?: InputMaybe<Scalars['ID']['input']>;
};

export enum ExposeFolderCtaEnum {
  Buy = 'BUY',
  ConsultingSpeech = 'CONSULTING_SPEECH',
  ConsultingVideo = 'CONSULTING_VIDEO',
  TestDrive = 'TEST_DRIVE'
}

export type FileHashTextInput = {
  fileHash: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export enum FolderOrderByEnum {
  CreatedAsc = 'CREATED_ASC',
  CreatedDesc = 'CREATED_DESC',
  TrackingLastAccessAsc = 'TRACKING_LAST_ACCESS_ASC',
  TrackingLastAccessDesc = 'TRACKING_LAST_ACCESS_DESC',
  VisitTimeAsc = 'VISIT_TIME_ASC',
  VisitTimeDesc = 'VISIT_TIME_DESC'
}

export enum FuelTypeEnum {
  BiFuel = 'BI_FUEL',
  Diesel = 'DIESEL',
  Electric = 'ELECTRIC',
  Ethanol = 'ETHANOL',
  Hybrid = 'HYBRID',
  HybridDiesel = 'HYBRID_DIESEL',
  Hydrogen = 'HYDROGEN',
  Lpg = 'LPG',
  Methane = 'METHANE',
  Other = 'OTHER',
  Petrol = 'PETROL'
}

export type HrefButtonInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  leadingIcon?: InputMaybe<ButtonIconEnum>;
  size: ButtonSizeEnum;
  trailingIcon?: InputMaybe<ButtonIconEnum>;
  url: Scalars['String']['input'];
  variant: ButtonVariantEnum;
};

export type IntegrationClpInput = {
  bnr: Scalars['String']['input'];
  clpSlug: Scalars['String']['input'];
};

export type IntegrationFolderInput = {
  folderItemId?: InputMaybe<Scalars['ID']['input']>;
  folderSlug: Scalars['String']['input'];
};

export type IntegrationQueryInput =
  { clpInput: IntegrationClpInput; folderInput?: never; }
  |  { clpInput?: never; folderInput: IntegrationFolderInput; };

export type KeyValueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type KpiNumberValueInput = {
  prefix?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  suffix: Scalars['String']['input'];
  title: Scalars['String']['input'];
  value: Scalars['Float']['input'];
  variant?: InputMaybe<KpiNumberVariantEnum>;
};

export enum KpiNumberVariantEnum {
  CountDown = 'COUNT_DOWN',
  CountUp = 'COUNT_UP'
}

export type KpiStringValueInput = {
  prefix?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  suffix: Scalars['String']['input'];
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LockStatusInput = {
  action: BlockStatusActionEnum;
  memberId?: InputMaybe<Scalars['ID']['input']>;
};

export type MinMaxInputIntType = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type NestedContentButtonInput = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  leadingIcon?: InputMaybe<ButtonIconEnum>;
  size: ButtonSizeEnum;
  trailingIcon?: InputMaybe<ButtonIconEnum>;
  variant: ButtonVariantEnum;
};

export enum OfficeFeatureEnum {
  ApiV1 = 'API_V1',
  AppCms = 'APP_CMS',
  AppThemeEditor = 'APP_THEME_EDITOR',
  Attachment = 'ATTACHMENT',
  CcAudi = 'CC_AUDI',
  CcCupra = 'CC_CUPRA',
  CcPorsche = 'CC_PORSCHE',
  CcSeat = 'CC_SEAT',
  CcVw = 'CC_VW',
  CcVwn = 'CC_VWN',
  CollectionAutomotive = 'COLLECTION_AUTOMOTIVE',
  CollectionSe = 'COLLECTION_SE',
  CombinedDashboard = 'COMBINED_DASHBOARD',
  DgaAudi = 'DGA_AUDI',
  DgaVw = 'DGA_VW',
  DgaVwn = 'DGA_VWN',
  ExternalLink = 'EXTERNAL_LINK',
  GoogleRating = 'GOOGLE_RATING',
  GoogleRatingCustomSalutation = 'GOOGLE_RATING_CUSTOM_SALUTATION',
  GroupAnalysis = 'GROUP_ANALYSIS',
  InstagramFeed = 'INSTAGRAM_FEED',
  MediaGallery = 'MEDIA_GALLERY',
  PrintManager = 'PRINT_MANAGER',
  TrackingWithIdentity = 'TRACKING_WITH_IDENTITY',
  Unknown = 'UNKNOWN'
}

export enum OfficeIntegrationEnum {
  Instagram = 'INSTAGRAM',
  NwConsumptionValueDisclaimer = 'NW_CONSUMPTION_VALUE_DISCLAIMER',
  SeatCupraOfficeVCard = 'SEAT_CUPRA_OFFICE_V_CARD',
  SeStock = 'SE_STOCK'
}

export type PageInput = {
  callout?: InputMaybe<Scalars['String']['input']>;
  documentVersionId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  navLabel?: InputMaybe<Scalars['String']['input']>;
  /** must be set if moved or created */
  needlePageId?: InputMaybe<Scalars['ID']['input']>;
  /** must be set if moved or created */
  position?: InputMaybe<BeforeAfterEnum>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** reduced MobRecord.carType */
export enum ReducedCarType {
  New = 'NEW',
  Presentation = 'PRESENTATION',
  Used = 'USED'
}

export enum SalutationEnum {
  Frau = 'Frau',
  Herr = 'Herr'
}

export enum SalutationTypeEnum {
  TypeFormalSalutation = 'TYPE_FORMAL_SALUTATION',
  TypeInformalSalutation = 'TYPE_INFORMAL_SALUTATION'
}

export enum SealLogoPositionEnum {
  Bottom = 'BOTTOM',
  Left = 'LEFT'
}

export enum SocialEnum {
  GoogleMaps = 'GOOGLE_MAPS',
  Stock = 'STOCK'
}

export enum ThemeHeaderEnum {
  Audi = 'AUDI',
  Cupra = 'CUPRA',
  Custom = 'CUSTOM',
  Porsche = 'PORSCHE',
  Seat = 'SEAT',
  Skoda = 'SKODA',
  Vw = 'VW'
}

export type ThemeInput = {
  bodyFontId?: InputMaybe<Scalars['ID']['input']>;
  favicon?: InputMaybe<Scalars['Upload']['input']>;
  header?: InputMaybe<ThemeHeaderEnum>;
  headingFontId?: InputMaybe<Scalars['ID']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  themeVariables?: InputMaybe<Scalars['JSON']['input']>;
};

export enum ThumbnailHAlignEnum {
  /** Depending on the mimetype this will be middle, left or right */
  Auto = 'AUTO',
  Center = 'CENTER',
  Left = 'LEFT',
  Right = 'RIGHT'
}

export type ThumbnailInput = {
  filters?: InputMaybe<Array<Scalars['String']['input']>>;
  fitIn?: InputMaybe<Scalars['Boolean']['input']>;
  flip?: InputMaybe<Scalars['Boolean']['input']>;
  flop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only use in dashboard scope. This will use a focal point as crop */
  focalAsCrop?: InputMaybe<Scalars['Boolean']['input']>;
  halign?: InputMaybe<ThumbnailHAlignEnum>;
  height?: InputMaybe<Scalars['Int']['input']>;
  smart?: InputMaybe<ThumbnailSmartEnum>;
  valign?: InputMaybe<ThumbnailVAlignEnum>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export enum ThumbnailSizeEnum {
  M = 'M',
  Original = 'ORIGINAL',
  S = 'S',
  Xs = 'XS'
}

export enum ThumbnailSmartEnum {
  Auto = 'AUTO',
  False = 'FALSE',
  True = 'TRUE'
}

export enum ThumbnailVAlignEnum {
  /** Depending on the mimetype this will be middle, left or right */
  Auto = 'AUTO',
  Bottom = 'BOTTOM',
  Middle = 'MIDDLE',
  Top = 'TOP'
}

export enum ToastTypeEnum {
  Error = 'ERROR',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type UpdateMemberSelfInput = {
  croppedImage?: InputMaybe<Scalars['Upload']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  originalImage?: InputMaybe<Scalars['Upload']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<SalutationEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum VideoProviderEnum {
  Html5 = 'HTML5',
  Other = 'OTHER',
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE'
}

export type XcCampaignAnalyticsFilterInput = {
  /** If set this stats only return stats for this campaign */
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter for end time. Default: now */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter for end hour. Default: unset */
  endHour?: InputMaybe<Scalars['Int']['input']>;
  /** Filter for weekend only. Default: unset */
  onlyWeekend?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for start time. Default: now - 30d */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter for start hour. Default: unset */
  startHour?: InputMaybe<Scalars['Int']['input']>;
};

export type XcDocDisclaimerInput = {
  disclaimerId?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
  textContent: Scalars['String']['input'];
  variant: DisclaimerVariantEnum;
  xcCollectionId: Scalars['ID']['input'];
};

export type XcFileDataInput = {
  displayName: Scalars['String']['input'];
  fileHash: Scalars['String']['input'];
};

export type XcFileUploadInput = {
  attachments: Array<XcFileDataInput>;
  folderDocumentId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type XcInfoFootnoteInput = {
  disclaimerId?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
  textClick: Scalars['String']['input'];
  variant: DisclaimerVariantEnum;
  xcCollectionId: Scalars['ID']['input'];
};

export type XcRectangleFootnoteInput = {
  colorBackground?: InputMaybe<Scalars['String']['input']>;
  colorBorder?: InputMaybe<Scalars['String']['input']>;
  colorFont?: InputMaybe<Scalars['String']['input']>;
  disclaimerId?: InputMaybe<Scalars['ID']['input']>;
  key: Scalars['String']['input'];
  textContent?: InputMaybe<Scalars['String']['input']>;
  textHover?: InputMaybe<Scalars['String']['input']>;
  variant: DisclaimerVariantEnum;
  xcCollectionId: Scalars['ID']['input'];
};

export type XcRecordInput = {
  featureType: OfficeFeatureEnum;
  id: Scalars['ID']['input'];
};

export type XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType = {
  __typename: 'DimensionsType',
  height: number,
  width: number,
  aspect: number
};

export type XcMediaRefFragment = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcThemeFragment_XCThemeType_headerFont_KeyValueType = {
  __typename: 'KeyValueType',
  id: string,
  key: string,
  value: string
};

export type XcThemeFragment_XCThemeType_bodyFont_KeyValueType = {
  __typename: 'KeyValueType',
  id: string,
  key: string,
  value: string
};

export type XcThemeFragment_XCThemeType_favicon_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcThemeFragment_XCThemeType_logo_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcThemeFragment = {
  __typename: 'XCThemeType',
  id: string,
  cssVariablesStr: string,
  cssVariables: any,
  cssHeader: string,
  faviconUrl: string | null,
  header: ThemeHeaderEnum,
  name?: string | null,
  headerFont?: XcThemeFragment_XCThemeType_headerFont_KeyValueType | null,
  bodyFont?: XcThemeFragment_XCThemeType_bodyFont_KeyValueType | null,
  favicon: XcThemeFragment_XCThemeType_favicon_XCMediaRefType | null,
  logo: XcThemeFragment_XCThemeType_logo_XCMediaRefType | null
};

export type XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  altText: string | null,
  thumbnailUrl: string
};

export type XcRecordBase_XcccCupraDataType_Fragment = {
  __typename: 'XCCCCupraDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcccSeatDataType_Fragment = {
  __typename: 'XCCCSeatDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcDgaDataAudiType_Fragment = {
  __typename: 'XCDgaDataAudiType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcDgaDataVwType_Fragment = {
  __typename: 'XCDgaDataVwType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcDgaDataVwnType_Fragment = {
  __typename: 'XCDgaDataVwnType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcExternalLinkDataType_Fragment = {
  __typename: 'XCExternalLinkDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcGenericCodeDataType_Fragment = {
  __typename: 'XCGenericCodeDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcNwDataType_Fragment = {
  __typename: 'XCNwDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcPricingTableType_Fragment = {
  __typename: 'XCPricingTableType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcSeDataType_Fragment = {
  __typename: 'XCSeDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcUploadDataAttachmentType_Fragment = {
  __typename: 'XCUploadDataAttachmentType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBase_XcUploadDataImageGalleryType_Fragment = {
  __typename: 'XCUploadDataImageGalleryType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type XcRecordBaseFragment = XcRecordBase_XcccCupraDataType_Fragment | XcRecordBase_XcccSeatDataType_Fragment | XcRecordBase_XcDgaDataAudiType_Fragment | XcRecordBase_XcDgaDataVwType_Fragment | XcRecordBase_XcDgaDataVwnType_Fragment | XcRecordBase_XcExternalLinkDataType_Fragment | XcRecordBase_XcGenericCodeDataType_Fragment | XcRecordBase_XcNwDataType_Fragment | XcRecordBase_XcPricingTableType_Fragment | XcRecordBase_XcSeDataType_Fragment | XcRecordBase_XcUploadDataAttachmentType_Fragment | XcRecordBase_XcUploadDataImageGalleryType_Fragment;

export type BlockRichTextFragment = {
  __typename: 'BlockRichTextType',
  id: string,
  text: string
};

export type ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType = {
  __typename: 'MboAttrsType',
  prefix: string,
  piece: string
};

export type ButtonInterfaceFragment_DocButtonType_document_MobRecordType_mediaRef_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type ButtonInterfaceFragment_DocButtonType_document_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  displayName: string,
  keyVisualUrl: string
};

export type ButtonInterfaceFragment_DocButtonType_document_ErrorType = {
  __typename: 'ErrorType',
  message: string,
  code: ErrorCodeEnum,
  rawCode: number
};

export type ButtonInterfaceFragment_DocButtonType_document_MobRecordType = {
  __typename: 'MobRecordType',
  id: string,
  identifier: any,
  fullName: string,
  mediaRef: ButtonInterfaceFragment_DocButtonType_document_MobRecordType_mediaRef_XCMediaRefType | null
};

export type ButtonInterfaceFragment_DocButtonType_document = ButtonInterfaceFragment_DocButtonType_document_DocumentType | ButtonInterfaceFragment_DocButtonType_document_ErrorType | ButtonInterfaceFragment_DocButtonType_document_MobRecordType;

export type ButtonInterfaceFragment_DownloadButtonType_media_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string
};

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks = ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_AwardTypeBlockRowType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockAccordionType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockAppDownloadType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockAutoplayType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockBannerType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockChapterOpenerType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockDataSheetType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockDividerType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockDocumentHeaderType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockErrorType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockExternalLinkType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockHighlightType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockInstagramType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockIntegrationType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockJsonType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockKeyValueTableType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockMediaComparisonSliderType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockMediaGalleryType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockMediaSingleImageType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockOfficeVCardType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockPdfPreviewType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockPricingTableType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockQuotesType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockRichTextType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockSeEekType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockSeFeatureImagesType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockSePriceType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockSeQualityDescriptionType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockVideoType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_BlockVideoWithDescriptionType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_ButtonTypeBlockRowType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_ConsumptionValueTypeBlockRowType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_KeyFactSmallBlockRowType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_KeyFactTypeBlockRowType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_KpiTypeBlockRowType | ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType;

export type ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType = {
  __typename: 'PanelType',
  id: string,
  blocks: Array<ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType_blocks>
};

export type ButtonInterface_ContactFormTriggerButtonType_Fragment = {
  __typename: 'ContactFormTriggerButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type ButtonInterface_CopyButtonType_Fragment = {
  __typename: 'CopyButtonType',
  content: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type ButtonInterface_DialogButtonType_Fragment = {
  __typename: 'DialogButtonType',
  panelId: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type ButtonInterface_DocButtonType_Fragment = {
  __typename: 'DocButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  docIdentifier: any,
  document: ButtonInterfaceFragment_DocButtonType_document,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type ButtonInterface_DownloadButtonType_Fragment = {
  __typename: 'DownloadButtonType',
  fileName: string | null,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  media: ButtonInterfaceFragment_DownloadButtonType_media_XCMediaRefType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type ButtonInterface_HrefButtonType_Fragment = {
  __typename: 'HrefButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  href: string,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type ButtonInterface_NestedContentButtonType_Fragment = {
  __typename: 'NestedContentButtonType',
  panelId: string,
  identifier: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  panel?: ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type ButtonInterfaceFragment = ButtonInterface_ContactFormTriggerButtonType_Fragment | ButtonInterface_CopyButtonType_Fragment | ButtonInterface_DialogButtonType_Fragment | ButtonInterface_DocButtonType_Fragment | ButtonInterface_DownloadButtonType_Fragment | ButtonInterface_HrefButtonType_Fragment | ButtonInterface_NestedContentButtonType_Fragment;

export type BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockExternalLinkFragment = {
  __typename: 'BlockExternalLinkType',
  id: string,
  title: string,
  externalLinkUrl: string,
  media: BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType
};

export type BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockVideoWithDescriptionFragment = {
  __typename: 'BlockVideoWithDescriptionType',
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  publishingDate: any | null,
  optionalTitle: string | null,
  duration: number | null,
  provider: VideoProviderEnum,
  videoDescription: string | null,
  thumbnail: BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType | null
};

export type BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockVideoFragment = {
  __typename: 'BlockVideoType',
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  duration: number | null,
  autoplay: boolean,
  provider: VideoProviderEnum,
  thumbnail: BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType | null
};

export type KeyFactFragment_KeyFactType_image_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type KeyFactFragment_KeyFactType_cta_ContactFormTriggerButtonType = {
  __typename: 'ContactFormTriggerButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactFragment_KeyFactType_cta_CopyButtonType = {
  __typename: 'CopyButtonType',
  content: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactFragment_KeyFactType_cta_DialogButtonType = {
  __typename: 'DialogButtonType',
  panelId: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactFragment_KeyFactType_cta_DocButtonType = {
  __typename: 'DocButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  docIdentifier: any,
  document: ButtonInterfaceFragment_DocButtonType_document,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactFragment_KeyFactType_cta_DownloadButtonType = {
  __typename: 'DownloadButtonType',
  fileName: string | null,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  media: ButtonInterfaceFragment_DownloadButtonType_media_XCMediaRefType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactFragment_KeyFactType_cta_HrefButtonType = {
  __typename: 'HrefButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  href: string,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactFragment_KeyFactType_cta_NestedContentButtonType = {
  __typename: 'NestedContentButtonType',
  panelId: string,
  identifier: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  panel?: ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactFragment_KeyFactType_cta = KeyFactFragment_KeyFactType_cta_ContactFormTriggerButtonType | KeyFactFragment_KeyFactType_cta_CopyButtonType | KeyFactFragment_KeyFactType_cta_DialogButtonType | KeyFactFragment_KeyFactType_cta_DocButtonType | KeyFactFragment_KeyFactType_cta_DownloadButtonType | KeyFactFragment_KeyFactType_cta_HrefButtonType | KeyFactFragment_KeyFactType_cta_NestedContentButtonType;

export type KeyFactFragment = {
  __typename: 'KeyFactType',
  title: string,
  mediaDivider: boolean,
  callOut: string | null,
  description: string | null,
  image: KeyFactFragment_KeyFactType_image_XCMediaRefType | null,
  cta: KeyFactFragment_KeyFactType_cta | null
};

export type KeyFactSmallFragment_KeyFactSmallType_image_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type KeyFactSmallFragment_KeyFactSmallType_cta_ContactFormTriggerButtonType = {
  __typename: 'ContactFormTriggerButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactSmallFragment_KeyFactSmallType_cta_CopyButtonType = {
  __typename: 'CopyButtonType',
  content: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactSmallFragment_KeyFactSmallType_cta_DialogButtonType = {
  __typename: 'DialogButtonType',
  panelId: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactSmallFragment_KeyFactSmallType_cta_DocButtonType = {
  __typename: 'DocButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  docIdentifier: any,
  document: ButtonInterfaceFragment_DocButtonType_document,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactSmallFragment_KeyFactSmallType_cta_DownloadButtonType = {
  __typename: 'DownloadButtonType',
  fileName: string | null,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  media: ButtonInterfaceFragment_DownloadButtonType_media_XCMediaRefType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactSmallFragment_KeyFactSmallType_cta_HrefButtonType = {
  __typename: 'HrefButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  href: string,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactSmallFragment_KeyFactSmallType_cta_NestedContentButtonType = {
  __typename: 'NestedContentButtonType',
  panelId: string,
  identifier: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  panel?: ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type KeyFactSmallFragment_KeyFactSmallType_cta = KeyFactSmallFragment_KeyFactSmallType_cta_ContactFormTriggerButtonType | KeyFactSmallFragment_KeyFactSmallType_cta_CopyButtonType | KeyFactSmallFragment_KeyFactSmallType_cta_DialogButtonType | KeyFactSmallFragment_KeyFactSmallType_cta_DocButtonType | KeyFactSmallFragment_KeyFactSmallType_cta_DownloadButtonType | KeyFactSmallFragment_KeyFactSmallType_cta_HrefButtonType | KeyFactSmallFragment_KeyFactSmallType_cta_NestedContentButtonType;

export type KeyFactSmallFragment = {
  __typename: 'KeyFactSmallType',
  heading: string,
  callout: string | null,
  description: string | null,
  image: KeyFactSmallFragment_KeyFactSmallType_image_XCMediaRefType | null,
  cta: KeyFactSmallFragment_KeyFactSmallType_cta | null
};

export type ConsumptionValueFragment = {
  __typename: 'ConsumptionValueType',
  type: EnvkvTypeEnum,
  consumptionLabel: string,
  consumptionValue: string
};

export type KeyValueFragment = {
  __typename: 'KeyValueType',
  id: string,
  key: string,
  value: string
};

export type BlockPricingTableFragment_BlockPricingTableType_units_KeyValueType = {
  __typename: 'KeyValueType',
  id: string,
  key: string,
  value: string
};

export type BlockPricingTableFragment_BlockPricingTableType_total_KeyValueType = {
  __typename: 'KeyValueType',
  id: string,
  key: string,
  value: string
};

export type BlockPricingTableFragment = {
  __typename: 'BlockPricingTableType',
  id: string,
  description: string | null,
  pricingTableTitle: string | null,
  units: Array<BlockPricingTableFragment_BlockPricingTableType_units_KeyValueType>,
  total: BlockPricingTableFragment_BlockPricingTableType_total_KeyValueType
};

export type BlockQuotesFragment = {
  __typename: 'BlockQuotesType',
  quotes: Array<string>
};

export type VehicleDataTableSectionFragment_VehicleDataTableSectionType_items_KeyValueType = {
  __typename: 'KeyValueType',
  id: string,
  key: string,
  value: string
};

export type VehicleDataTableSectionFragment = {
  __typename: 'VehicleDataTableSectionType',
  title: string,
  items: Array<VehicleDataTableSectionFragment_VehicleDataTableSectionType_items_KeyValueType>
};

export type Kpi_KpiNumberType_Fragment = {
  __typename: 'KpiNumberType',
  title: string,
  prefix: string | null,
  suffix: string | null,
  subtitle: string | null,
  numberValue: number,
  kpiVariant: KpiNumberVariantEnum | null
};

export type Kpi_KpiTextType_Fragment = {
  __typename: 'KpiTextType',
  title: string,
  prefix: string | null,
  suffix: string | null,
  subtitle: string | null,
  stringValue: string
};

export type KpiFragment = Kpi_KpiNumberType_Fragment | Kpi_KpiTextType_Fragment;

export type BlockDocumentHeaderFragment = {
  __typename: 'BlockDocumentHeaderType',
  title: string,
  callout: string | null
};

export type AwardItemFragment_AwardType_awardImage_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type AwardItemFragment = {
  __typename: 'AwardType',
  title: string,
  text: string,
  awardImage: AwardItemFragment_AwardType_awardImage_XCMediaRefType
};

export type BlockSePriceFragment = {
  __typename: 'BlockSePriceType',
  internalNumber: string | null,
  availability: AvailabilityEnum,
  price: number | null,
  tax: boolean | null,
  loanPageId: string | null,
  loan: string | null,
  leasingPageId: string | null,
  leasing: string | null
};

export type BlockSeEekFragment = {
  __typename: 'BlockSeEekType',
  co2Class: string | null
};

export type BlockSeQualityDescriptionFragment_BlockSeQualityDescriptionType_logo_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockSeQualityDescriptionFragment = {
  __typename: 'BlockSeQualityDescriptionType',
  logoPosition: SealLogoPositionEnum | null,
  description: string | null,
  logo: BlockSeQualityDescriptionFragment_BlockSeQualityDescriptionType_logo_XCMediaRefType | null
};

export type BlockSeFeatureImagesFragment_BlockSeFeatureImagesType_images_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockSeFeatureImagesFragment = {
  __typename: 'BlockSeFeatureImagesType',
  images: Array<BlockSeFeatureImagesFragment_BlockSeFeatureImagesType_images_XCMediaRefType>
};

export type XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType_currentEditor_MemberType = {
  __typename: 'MemberType',
  id: string,
  fullName: string
};

export type XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType = {
  __typename: 'LockStatusType',
  action: BlockStatusActionEnum,
  currentEditor: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType_currentEditor_MemberType
};

export type XcNwBlockLockStatus_AwardTypeBlockRowType_Fragment = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockAccordionType_Fragment = {
  __typename: 'BlockAccordionType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockAppDownloadType_Fragment = {
  __typename: 'BlockAppDownloadType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockAutoplayType_Fragment = {
  __typename: 'BlockAutoplayType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockBannerType_Fragment = {
  __typename: 'BlockBannerType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockChapterOpenerType_Fragment = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockDataSheetType_Fragment = {
  __typename: 'BlockDataSheetType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockDividerType_Fragment = {
  __typename: 'BlockDividerType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockDocumentHeaderType_Fragment = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockErrorType_Fragment = {
  __typename: 'BlockErrorType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockExternalLinkType_Fragment = {
  __typename: 'BlockExternalLinkType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockHighlightType_Fragment = {
  __typename: 'BlockHighlightType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockInstagramType_Fragment = {
  __typename: 'BlockInstagramType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockIntegrationType_Fragment = {
  __typename: 'BlockIntegrationType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockJsonType_Fragment = {
  __typename: 'BlockJsonType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockKeyValueTableType_Fragment = {
  __typename: 'BlockKeyValueTableType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockMediaComparisonSliderType_Fragment = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockMediaGalleryType_Fragment = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockMediaSingleImageType_Fragment = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockOfficeVCardType_Fragment = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockPdfPreviewType_Fragment = {
  __typename: 'BlockPdfPreviewType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockPricingTableType_Fragment = {
  __typename: 'BlockPricingTableType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockQuotesType_Fragment = {
  __typename: 'BlockQuotesType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockRichTextType_Fragment = {
  __typename: 'BlockRichTextType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockSeEekType_Fragment = {
  __typename: 'BlockSeEekType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockSeFeatureImagesType_Fragment = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockSePriceType_Fragment = {
  __typename: 'BlockSePriceType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockSeQualityDescriptionType_Fragment = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockVideoType_Fragment = {
  __typename: 'BlockVideoType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_BlockVideoWithDescriptionType_Fragment = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_ButtonTypeBlockRowType_Fragment = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_ConsumptionValueTypeBlockRowType_Fragment = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_KeyFactSmallBlockRowType_Fragment = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_KeyFactTypeBlockRowType_Fragment = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_KpiTypeBlockRowType_Fragment = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatus_VehicleDataTableSectionTypeBlockRowType_Fragment = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type XcNwBlockLockStatusFragment = XcNwBlockLockStatus_AwardTypeBlockRowType_Fragment | XcNwBlockLockStatus_BlockAccordionType_Fragment | XcNwBlockLockStatus_BlockAppDownloadType_Fragment | XcNwBlockLockStatus_BlockAutoplayType_Fragment | XcNwBlockLockStatus_BlockBannerType_Fragment | XcNwBlockLockStatus_BlockChapterOpenerType_Fragment | XcNwBlockLockStatus_BlockDataSheetType_Fragment | XcNwBlockLockStatus_BlockDividerType_Fragment | XcNwBlockLockStatus_BlockDocumentHeaderType_Fragment | XcNwBlockLockStatus_BlockErrorType_Fragment | XcNwBlockLockStatus_BlockExternalLinkType_Fragment | XcNwBlockLockStatus_BlockHighlightType_Fragment | XcNwBlockLockStatus_BlockInstagramType_Fragment | XcNwBlockLockStatus_BlockIntegrationType_Fragment | XcNwBlockLockStatus_BlockJsonType_Fragment | XcNwBlockLockStatus_BlockKeyValueTableType_Fragment | XcNwBlockLockStatus_BlockMediaComparisonSliderType_Fragment | XcNwBlockLockStatus_BlockMediaGalleryType_Fragment | XcNwBlockLockStatus_BlockMediaSingleImageType_Fragment | XcNwBlockLockStatus_BlockOfficeVCardType_Fragment | XcNwBlockLockStatus_BlockPdfPreviewType_Fragment | XcNwBlockLockStatus_BlockPricingTableType_Fragment | XcNwBlockLockStatus_BlockQuotesType_Fragment | XcNwBlockLockStatus_BlockRichTextType_Fragment | XcNwBlockLockStatus_BlockSeEekType_Fragment | XcNwBlockLockStatus_BlockSeFeatureImagesType_Fragment | XcNwBlockLockStatus_BlockSePriceType_Fragment | XcNwBlockLockStatus_BlockSeQualityDescriptionType_Fragment | XcNwBlockLockStatus_BlockVideoType_Fragment | XcNwBlockLockStatus_BlockVideoWithDescriptionType_Fragment | XcNwBlockLockStatus_ButtonTypeBlockRowType_Fragment | XcNwBlockLockStatus_ConsumptionValueTypeBlockRowType_Fragment | XcNwBlockLockStatus_KeyFactSmallBlockRowType_Fragment | XcNwBlockLockStatus_KeyFactTypeBlockRowType_Fragment | XcNwBlockLockStatus_KpiTypeBlockRowType_Fragment | XcNwBlockLockStatus_VehicleDataTableSectionTypeBlockRowType_Fragment;

export type EufePageLockStatusFragment_EufePageType_lockStatus_LockStatusType = {
  __typename: 'LockStatusType',
  action: BlockStatusActionEnum,
  currentEditor: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType_currentEditor_MemberType
};

export type EufePageLockStatusFragment = {
  __typename: 'EufePageType',
  id: string,
  lockStatus: EufePageLockStatusFragment_EufePageType_lockStatus_LockStatusType | null
};

export type BlockIntegrationFragment = {
  __typename: 'BlockIntegrationType',
  integrationType: OfficeIntegrationEnum,
  defaultValue: string | null
};

export type BlockInstagramFragment_BlockInstagramType_logo_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType_image_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType = {
  __typename: 'InstagramItemType',
  text: string | null,
  created: any,
  image: BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType_image_XCMediaRefType
};

export type BlockInstagramFragment = {
  __typename: 'BlockInstagramType',
  href: string,
  name: string,
  logo: BlockInstagramFragment_BlockInstagramType_logo_XCMediaRefType | null,
  instaItems: Array<BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType>
};

export type BlockBannerFragment_BlockBannerType_cta_ContactFormTriggerButtonType = {
  __typename: 'ContactFormTriggerButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type BlockBannerFragment_BlockBannerType_cta_CopyButtonType = {
  __typename: 'CopyButtonType',
  content: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type BlockBannerFragment_BlockBannerType_cta_DialogButtonType = {
  __typename: 'DialogButtonType',
  panelId: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type BlockBannerFragment_BlockBannerType_cta_DocButtonType = {
  __typename: 'DocButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  docIdentifier: any,
  document: ButtonInterfaceFragment_DocButtonType_document,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type BlockBannerFragment_BlockBannerType_cta_DownloadButtonType = {
  __typename: 'DownloadButtonType',
  fileName: string | null,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  media: ButtonInterfaceFragment_DownloadButtonType_media_XCMediaRefType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type BlockBannerFragment_BlockBannerType_cta_HrefButtonType = {
  __typename: 'HrefButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  href: string,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type BlockBannerFragment_BlockBannerType_cta_NestedContentButtonType = {
  __typename: 'NestedContentButtonType',
  panelId: string,
  identifier: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  panel?: ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type BlockBannerFragment_BlockBannerType_cta = BlockBannerFragment_BlockBannerType_cta_ContactFormTriggerButtonType | BlockBannerFragment_BlockBannerType_cta_CopyButtonType | BlockBannerFragment_BlockBannerType_cta_DialogButtonType | BlockBannerFragment_BlockBannerType_cta_DocButtonType | BlockBannerFragment_BlockBannerType_cta_DownloadButtonType | BlockBannerFragment_BlockBannerType_cta_HrefButtonType | BlockBannerFragment_BlockBannerType_cta_NestedContentButtonType;

export type BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockBannerFragment = {
  __typename: 'BlockBannerType',
  bannerTitle: string | null,
  cta: BlockBannerFragment_BlockBannerType_cta | null,
  bannerBackground: BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType | null
};

export type BlockDividerFragment = {
  __typename: 'BlockDividerType',
  id: string
};

export type BlockErrorFragment = {
  __typename: 'BlockErrorType',
  message: string,
  eventId: string | null,
  sentryLink?: string | null
};

export type BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockChapterOpenerFragment = {
  __typename: 'BlockChapterOpenerType',
  title: string,
  count: number | null,
  chapterOpenerMedia: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType | null,
  chapterOpenerMediaMobile: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType | null
};

export type BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockAutoplayFragment = {
  __typename: 'BlockAutoplayType',
  media: BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType
};

export type BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType_image_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType = {
  __typename: 'FileHashTextType',
  text: string | null,
  image: BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType_image_XCMediaRefType
};

export type BlockMediaGalleryFragment = {
  __typename: 'BlockMediaGalleryType',
  mediaGalleryVisualization: BlockMediaGalleryVisualizationEnum,
  mediaGalleryItems: Array<BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType>
};

export type DataSheetProcessorFragment_DataSheetProcessorType_payload_DataSheetLookupType = {
  __typename: 'DataSheetLookupType',
  value: string,
  lookupType: DataSheetLookupEnum
};

export type DataSheetProcessorFragment = {
  __typename: 'DataSheetProcessorType',
  processor: DataSheetProcessorEnum,
  payload: DataSheetProcessorFragment_DataSheetProcessorType_payload_DataSheetLookupType | null
};

export type DataSheetLookupFragment_DataSheetLookupType_processors_DataSheetProcessorType = {
  __typename: 'DataSheetProcessorType',
  processor: DataSheetProcessorEnum,
  payload: DataSheetProcessorFragment_DataSheetProcessorType_payload_DataSheetLookupType | null
};

export type DataSheetLookupFragment = {
  __typename: 'DataSheetLookupType',
  value: string,
  lookupType: DataSheetLookupEnum,
  processors: Array<DataSheetLookupFragment_DataSheetLookupType_processors_DataSheetProcessorType>
};

export type DataSheetConfigFragment = {
  __typename: 'DataSheetConfigType',
  titleFieldName: string,
  ctaFieldName: string,
  descriptionFieldName: string | null,
  additionalFieldName: string | null,
  filterFieldName: string | null,
  keyVisualFieldName: string | null
};

export type DataSheetSectionItemFragment_DataSheetSectionItemType_label_DataSheetLookupType = {
  __typename: 'DataSheetLookupType',
  value: string,
  lookupType: DataSheetLookupEnum,
  processors: Array<DataSheetLookupFragment_DataSheetLookupType_processors_DataSheetProcessorType>
};

export type DataSheetSectionItemFragment_DataSheetSectionItemType_value_DataSheetLookupType = {
  __typename: 'DataSheetLookupType',
  value: string,
  lookupType: DataSheetLookupEnum,
  processors: Array<DataSheetLookupFragment_DataSheetLookupType_processors_DataSheetProcessorType>
};

export type DataSheetSectionItemFragment = {
  __typename: 'DataSheetSectionItemType',
  label: DataSheetSectionItemFragment_DataSheetSectionItemType_label_DataSheetLookupType,
  value: DataSheetSectionItemFragment_DataSheetSectionItemType_value_DataSheetLookupType
};

export type DataSheetSectionFragment_DataSheetSectionType_items_DataSheetSectionItemType = {
  __typename: 'DataSheetSectionItemType',
  label: DataSheetSectionItemFragment_DataSheetSectionItemType_label_DataSheetLookupType,
  value: DataSheetSectionItemFragment_DataSheetSectionItemType_value_DataSheetLookupType
};

export type DataSheetSectionFragment = {
  __typename: 'DataSheetSectionType',
  sectionName: string,
  items: Array<DataSheetSectionFragment_DataSheetSectionType_items_DataSheetSectionItemType>
};

export type DataSheetItemFragment_DataSheetItemType_media_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type DataSheetItemFragment = {
  __typename: 'DataSheetItemType',
  title: string,
  description: string | null,
  additional: string | null,
  btnLabel: string,
  media: DataSheetItemFragment_DataSheetItemType_media_XCMediaRefType
};

export type BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType = {
  __typename: 'DataSheetSectionType',
  sectionName: string,
  items: Array<DataSheetSectionFragment_DataSheetSectionType_items_DataSheetSectionItemType>
};

export type BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType = {
  __typename: 'DataSheetConfigType',
  titleFieldName: string,
  ctaFieldName: string,
  descriptionFieldName: string | null,
  additionalFieldName: string | null,
  filterFieldName: string | null,
  keyVisualFieldName: string | null
};

export type BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType = {
  __typename: 'DataSheetItemType',
  title: string,
  description: string | null,
  additional: string | null,
  btnLabel: string,
  media: DataSheetItemFragment_DataSheetItemType_media_XCMediaRefType
};

export type BlockDataSheetFragment = {
  __typename: 'BlockDataSheetType',
  rawItems: Array<any>,
  sections: Array<BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType>,
  config: BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType,
  items: Array<BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType>
};

export type OpeningHoursFragment = {
  __typename: 'OpeningHoursType',
  mondayOpen: string | null,
  mondayClose: string | null,
  tuesdayOpen: string | null,
  tuesdayClose: string | null,
  wednesdayOpen: string | null,
  wednesdayClose: string | null,
  thursdayOpen: string | null,
  thursdayClose: string | null,
  fridayOpen: string | null,
  fridayClose: string | null,
  saturdayOpen: string | null,
  saturdayClose: string | null,
  sundayOpen: string | null,
  sundayClose: string | null
};

export type BlockOfficeVCardFragment_BlockOfficeVCardType_officeVCardImage_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursAccessory_OpeningHoursType = {
  __typename: 'OpeningHoursType',
  mondayOpen: string | null,
  mondayClose: string | null,
  tuesdayOpen: string | null,
  tuesdayClose: string | null,
  wednesdayOpen: string | null,
  wednesdayClose: string | null,
  thursdayOpen: string | null,
  thursdayClose: string | null,
  fridayOpen: string | null,
  fridayClose: string | null,
  saturdayOpen: string | null,
  saturdayClose: string | null,
  sundayOpen: string | null,
  sundayClose: string | null
};

export type BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursGeneral_OpeningHoursType = {
  __typename: 'OpeningHoursType',
  mondayOpen: string | null,
  mondayClose: string | null,
  tuesdayOpen: string | null,
  tuesdayClose: string | null,
  wednesdayOpen: string | null,
  wednesdayClose: string | null,
  thursdayOpen: string | null,
  thursdayClose: string | null,
  fridayOpen: string | null,
  fridayClose: string | null,
  saturdayOpen: string | null,
  saturdayClose: string | null,
  sundayOpen: string | null,
  sundayClose: string | null
};

export type BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursSelling_OpeningHoursType = {
  __typename: 'OpeningHoursType',
  mondayOpen: string | null,
  mondayClose: string | null,
  tuesdayOpen: string | null,
  tuesdayClose: string | null,
  wednesdayOpen: string | null,
  wednesdayClose: string | null,
  thursdayOpen: string | null,
  thursdayClose: string | null,
  fridayOpen: string | null,
  fridayClose: string | null,
  saturdayOpen: string | null,
  saturdayClose: string | null,
  sundayOpen: string | null,
  sundayClose: string | null
};

export type BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursService_OpeningHoursType = {
  __typename: 'OpeningHoursType',
  mondayOpen: string | null,
  mondayClose: string | null,
  tuesdayOpen: string | null,
  tuesdayClose: string | null,
  wednesdayOpen: string | null,
  wednesdayClose: string | null,
  thursdayOpen: string | null,
  thursdayClose: string | null,
  fridayOpen: string | null,
  fridayClose: string | null,
  saturdayOpen: string | null,
  saturdayClose: string | null,
  sundayOpen: string | null,
  sundayClose: string | null
};

export type BlockOfficeVCardFragment = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  name: string,
  company: string | null,
  city: string | null,
  street: string | null,
  zipCode: string | null,
  streetNumber: string | null,
  geoLongitude: string | null,
  geoLatitude: string | null,
  phone: string | null,
  phoneService: string | null,
  newCarsSalesPhone: string | null,
  usedCarsSalesPhone: string | null,
  email: string | null,
  officeVCardImage: BlockOfficeVCardFragment_BlockOfficeVCardType_officeVCardImage_XCMediaRefType | null,
  openingHoursAccessory: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursAccessory_OpeningHoursType,
  openingHoursGeneral: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursGeneral_OpeningHoursType,
  openingHoursSelling: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursSelling_OpeningHoursType,
  openingHoursService: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursService_OpeningHoursType
};

export type KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType = {
  __typename: 'KeyFactType',
  title: string,
  mediaDivider: boolean,
  callOut: string | null,
  description: string | null,
  image: KeyFactFragment_KeyFactType_image_XCMediaRefType | null,
  cta: KeyFactFragment_KeyFactType_cta | null
};

export type KeyFactTypeBlockRowFragment = {
  __typename: 'KeyFactTypeBlockRowType',
  aspectRatio: AspectRatioEnum | null,
  keyFactVisualization: BlockKeyFactVisualizationEnum,
  items: Array<KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType>
};

export type XcNwBlockFragment_AwardTypeBlockRowType_items_AwardType = {
  __typename: 'AwardType',
  title: string,
  text: string,
  awardImage: AwardItemFragment_AwardType_awardImage_XCMediaRefType
};

export type XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType_panel_PanelType = {
  __typename: 'PanelType',
  id: string
};

export type XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType = {
  __typename: 'BlockAccordionSectionType',
  id: string,
  title: string,
  panel: XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType_panel_PanelType
};

export type XcNwBlockFragment_BlockHighlightType_cta_ContactFormTriggerButtonType = {
  __typename: 'ContactFormTriggerButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_BlockHighlightType_cta_CopyButtonType = {
  __typename: 'CopyButtonType',
  content: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_BlockHighlightType_cta_DialogButtonType = {
  __typename: 'DialogButtonType',
  panelId: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_BlockHighlightType_cta_DocButtonType = {
  __typename: 'DocButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  docIdentifier: any,
  document: ButtonInterfaceFragment_DocButtonType_document,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_BlockHighlightType_cta_DownloadButtonType = {
  __typename: 'DownloadButtonType',
  fileName: string | null,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  media: ButtonInterfaceFragment_DownloadButtonType_media_XCMediaRefType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_BlockHighlightType_cta_HrefButtonType = {
  __typename: 'HrefButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  href: string,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_BlockHighlightType_cta_NestedContentButtonType = {
  __typename: 'NestedContentButtonType',
  panelId: string,
  identifier: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  panel?: ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_BlockHighlightType_cta = XcNwBlockFragment_BlockHighlightType_cta_ContactFormTriggerButtonType | XcNwBlockFragment_BlockHighlightType_cta_CopyButtonType | XcNwBlockFragment_BlockHighlightType_cta_DialogButtonType | XcNwBlockFragment_BlockHighlightType_cta_DocButtonType | XcNwBlockFragment_BlockHighlightType_cta_DownloadButtonType | XcNwBlockFragment_BlockHighlightType_cta_HrefButtonType | XcNwBlockFragment_BlockHighlightType_cta_NestedContentButtonType;

export type XcNwBlockFragment_BlockHighlightType_media_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcNwBlockFragment_BlockHighlightType_mediaMobile_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcNwBlockFragment_BlockKeyValueTableType_items_KeyValueType = {
  __typename: 'KeyValueType',
  id: string,
  key: string,
  value: string
};

export type XcNwBlockFragment_BlockMediaComparisonSliderType_image1_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcNwBlockFragment_BlockMediaComparisonSliderType_image2_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcNwBlockFragment_BlockMediaSingleImageType_image_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcNwBlockFragment_BlockMediaSingleImageType_imageMobile_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcNwBlockFragment_ButtonTypeBlockRowType_items_CopyButtonType = {
  __typename: 'CopyButtonType',
  content: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_ButtonTypeBlockRowType_items_DocButtonType = {
  __typename: 'DocButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  docIdentifier: any,
  document: ButtonInterfaceFragment_DocButtonType_document,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_ButtonTypeBlockRowType_items_DownloadButtonType = {
  __typename: 'DownloadButtonType',
  fileName: string | null,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  media: ButtonInterfaceFragment_DownloadButtonType_media_XCMediaRefType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_ButtonTypeBlockRowType_items_HrefButtonType = {
  __typename: 'HrefButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  href: string,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_ButtonTypeBlockRowType_items_NestedContentButtonType = {
  __typename: 'NestedContentButtonType',
  panelId: string,
  identifier: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  panel?: ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type XcNwBlockFragment_ButtonTypeBlockRowType_items = XcNwBlockFragment_ButtonTypeBlockRowType_items_CopyButtonType | XcNwBlockFragment_ButtonTypeBlockRowType_items_DocButtonType | XcNwBlockFragment_ButtonTypeBlockRowType_items_DownloadButtonType | XcNwBlockFragment_ButtonTypeBlockRowType_items_HrefButtonType | XcNwBlockFragment_ButtonTypeBlockRowType_items_NestedContentButtonType;

export type XcNwBlockFragment_ConsumptionValueTypeBlockRowType_items_ConsumptionValueType = {
  __typename: 'ConsumptionValueType',
  type: EnvkvTypeEnum,
  consumptionLabel: string,
  consumptionValue: string
};

export type XcNwBlockFragment_KeyFactSmallBlockRowType_items_KeyFactSmallType = {
  __typename: 'KeyFactSmallType',
  heading: string,
  callout: string | null,
  description: string | null,
  image: KeyFactSmallFragment_KeyFactSmallType_image_XCMediaRefType | null,
  cta: KeyFactSmallFragment_KeyFactSmallType_cta | null
};

export type XcNwBlockFragment_KpiTypeBlockRowType_items_KpiNumberType = {
  __typename: 'KpiNumberType',
  title: string,
  prefix: string | null,
  suffix: string | null,
  subtitle: string | null,
  numberValue: number,
  kpiVariant: KpiNumberVariantEnum | null
};

export type XcNwBlockFragment_KpiTypeBlockRowType_items_KpiTextType = {
  __typename: 'KpiTextType',
  title: string,
  prefix: string | null,
  suffix: string | null,
  subtitle: string | null,
  stringValue: string
};

export type XcNwBlockFragment_KpiTypeBlockRowType_items = XcNwBlockFragment_KpiTypeBlockRowType_items_KpiNumberType | XcNwBlockFragment_KpiTypeBlockRowType_items_KpiTextType;

export type XcNwBlockFragment_VehicleDataTableSectionTypeBlockRowType_items_VehicleDataTableSectionType = {
  __typename: 'VehicleDataTableSectionType',
  title: string,
  items: Array<VehicleDataTableSectionFragment_VehicleDataTableSectionType_items_KeyValueType>
};

export type XcNwBlock_AwardTypeBlockRowType_Fragment = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_AwardTypeBlockRowType_items_AwardType>
};

export type XcNwBlock_BlockAccordionType_Fragment = {
  __typename: 'BlockAccordionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  sections: Array<XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType>
};

export type XcNwBlock_BlockAppDownloadType_Fragment = {
  __typename: 'BlockAppDownloadType',
  iosHref: string,
  androidHref: string,
  iosLabel: string,
  androidLabel: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type XcNwBlock_BlockAutoplayType_Fragment = {
  __typename: 'BlockAutoplayType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  media: BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType
};

export type XcNwBlock_BlockBannerType_Fragment = {
  __typename: 'BlockBannerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  bannerTitle: string | null,
  cta: BlockBannerFragment_BlockBannerType_cta | null,
  bannerBackground: BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType | null
};

export type XcNwBlock_BlockChapterOpenerType_Fragment = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  count: number | null,
  chapterOpenerMedia: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType | null,
  chapterOpenerMediaMobile: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType | null
};

export type XcNwBlock_BlockDataSheetType_Fragment = {
  __typename: 'BlockDataSheetType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  rawItems: Array<any>,
  sections: Array<BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType>,
  config: BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType,
  items: Array<BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType>
};

export type XcNwBlock_BlockDividerType_Fragment = {
  __typename: 'BlockDividerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type XcNwBlock_BlockDocumentHeaderType_Fragment = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  callout: string | null
};

export type XcNwBlock_BlockErrorType_Fragment = {
  __typename: 'BlockErrorType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  message: string,
  eventId: string | null,
  sentryLink?: string | null
};

export type XcNwBlock_BlockExternalLinkType_Fragment = {
  __typename: 'BlockExternalLinkType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  externalLinkUrl: string,
  media: BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType
};

export type XcNwBlock_BlockHighlightType_Fragment = {
  __typename: 'BlockHighlightType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  highlightTitle: string,
  highlightDescription: string,
  highlightVisualization: BlockHighlightVisualizationEnum,
  cta: XcNwBlockFragment_BlockHighlightType_cta | null,
  media: XcNwBlockFragment_BlockHighlightType_media_XCMediaRefType,
  mediaMobile: XcNwBlockFragment_BlockHighlightType_mediaMobile_XCMediaRefType | null
};

export type XcNwBlock_BlockInstagramType_Fragment = {
  __typename: 'BlockInstagramType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  href: string,
  name: string,
  logo: BlockInstagramFragment_BlockInstagramType_logo_XCMediaRefType | null,
  instaItems: Array<BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType>
};

export type XcNwBlock_BlockIntegrationType_Fragment = {
  __typename: 'BlockIntegrationType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  integrationType: OfficeIntegrationEnum,
  defaultValue: string | null
};

export type XcNwBlock_BlockJsonType_Fragment = {
  __typename: 'BlockJsonType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type XcNwBlock_BlockKeyValueTableType_Fragment = {
  __typename: 'BlockKeyValueTableType',
  alignValue: AlignEnum,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_BlockKeyValueTableType_items_KeyValueType>
};

export type XcNwBlock_BlockMediaComparisonSliderType_Fragment = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image1: XcNwBlockFragment_BlockMediaComparisonSliderType_image1_XCMediaRefType,
  image2: XcNwBlockFragment_BlockMediaComparisonSliderType_image2_XCMediaRefType
};

export type XcNwBlock_BlockMediaGalleryType_Fragment = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  mediaGalleryVisualization: BlockMediaGalleryVisualizationEnum,
  mediaGalleryItems: Array<BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType>
};

export type XcNwBlock_BlockMediaSingleImageType_Fragment = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image: XcNwBlockFragment_BlockMediaSingleImageType_image_XCMediaRefType,
  imageMobile: XcNwBlockFragment_BlockMediaSingleImageType_imageMobile_XCMediaRefType | null
};

export type XcNwBlock_BlockOfficeVCardType_Fragment = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  name: string,
  company: string | null,
  city: string | null,
  street: string | null,
  zipCode: string | null,
  streetNumber: string | null,
  geoLongitude: string | null,
  geoLatitude: string | null,
  phone: string | null,
  phoneService: string | null,
  newCarsSalesPhone: string | null,
  usedCarsSalesPhone: string | null,
  email: string | null,
  officeVCardImage: BlockOfficeVCardFragment_BlockOfficeVCardType_officeVCardImage_XCMediaRefType | null,
  openingHoursAccessory: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursAccessory_OpeningHoursType,
  openingHoursGeneral: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursGeneral_OpeningHoursType,
  openingHoursSelling: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursSelling_OpeningHoursType,
  openingHoursService: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursService_OpeningHoursType
};

export type XcNwBlock_BlockPdfPreviewType_Fragment = {
  __typename: 'BlockPdfPreviewType',
  title: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  pdfPreviewUrl: string
};

export type XcNwBlock_BlockPricingTableType_Fragment = {
  __typename: 'BlockPricingTableType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  description: string | null,
  pricingTableTitle: string | null,
  units: Array<BlockPricingTableFragment_BlockPricingTableType_units_KeyValueType>,
  total: BlockPricingTableFragment_BlockPricingTableType_total_KeyValueType
};

export type XcNwBlock_BlockQuotesType_Fragment = {
  __typename: 'BlockQuotesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  quotes: Array<string>
};

export type XcNwBlock_BlockRichTextType_Fragment = {
  __typename: 'BlockRichTextType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  text: string
};

export type XcNwBlock_BlockSeEekType_Fragment = {
  __typename: 'BlockSeEekType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  co2Class: string | null
};

export type XcNwBlock_BlockSeFeatureImagesType_Fragment = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  images: Array<BlockSeFeatureImagesFragment_BlockSeFeatureImagesType_images_XCMediaRefType>
};

export type XcNwBlock_BlockSePriceType_Fragment = {
  __typename: 'BlockSePriceType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  internalNumber: string | null,
  availability: AvailabilityEnum,
  price: number | null,
  tax: boolean | null,
  loanPageId: string | null,
  loan: string | null,
  leasingPageId: string | null,
  leasing: string | null
};

export type XcNwBlock_BlockSeQualityDescriptionType_Fragment = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  logoPosition: SealLogoPositionEnum | null,
  description: string | null,
  logo: BlockSeQualityDescriptionFragment_BlockSeQualityDescriptionType_logo_XCMediaRefType | null
};

export type XcNwBlock_BlockVideoType_Fragment = {
  __typename: 'BlockVideoType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  duration: number | null,
  autoplay: boolean,
  provider: VideoProviderEnum,
  thumbnail: BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType | null
};

export type XcNwBlock_BlockVideoWithDescriptionType_Fragment = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  publishingDate: any | null,
  optionalTitle: string | null,
  duration: number | null,
  provider: VideoProviderEnum,
  videoDescription: string | null,
  thumbnail: BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType | null
};

export type XcNwBlock_ButtonTypeBlockRowType_Fragment = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ButtonTypeBlockRowType_items>
};

export type XcNwBlock_ConsumptionValueTypeBlockRowType_Fragment = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ConsumptionValueTypeBlockRowType_items_ConsumptionValueType>
};

export type XcNwBlock_KeyFactSmallBlockRowType_Fragment = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KeyFactSmallBlockRowType_items_KeyFactSmallType>
};

export type XcNwBlock_KeyFactTypeBlockRowType_Fragment = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  aspectRatio: AspectRatioEnum | null,
  keyFactVisualization: BlockKeyFactVisualizationEnum,
  items: Array<KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType>
};

export type XcNwBlock_KpiTypeBlockRowType_Fragment = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KpiTypeBlockRowType_items>
};

export type XcNwBlock_VehicleDataTableSectionTypeBlockRowType_Fragment = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_VehicleDataTableSectionTypeBlockRowType_items_VehicleDataTableSectionType>
};

export type XcNwBlockFragment = XcNwBlock_AwardTypeBlockRowType_Fragment | XcNwBlock_BlockAccordionType_Fragment | XcNwBlock_BlockAppDownloadType_Fragment | XcNwBlock_BlockAutoplayType_Fragment | XcNwBlock_BlockBannerType_Fragment | XcNwBlock_BlockChapterOpenerType_Fragment | XcNwBlock_BlockDataSheetType_Fragment | XcNwBlock_BlockDividerType_Fragment | XcNwBlock_BlockDocumentHeaderType_Fragment | XcNwBlock_BlockErrorType_Fragment | XcNwBlock_BlockExternalLinkType_Fragment | XcNwBlock_BlockHighlightType_Fragment | XcNwBlock_BlockInstagramType_Fragment | XcNwBlock_BlockIntegrationType_Fragment | XcNwBlock_BlockJsonType_Fragment | XcNwBlock_BlockKeyValueTableType_Fragment | XcNwBlock_BlockMediaComparisonSliderType_Fragment | XcNwBlock_BlockMediaGalleryType_Fragment | XcNwBlock_BlockMediaSingleImageType_Fragment | XcNwBlock_BlockOfficeVCardType_Fragment | XcNwBlock_BlockPdfPreviewType_Fragment | XcNwBlock_BlockPricingTableType_Fragment | XcNwBlock_BlockQuotesType_Fragment | XcNwBlock_BlockRichTextType_Fragment | XcNwBlock_BlockSeEekType_Fragment | XcNwBlock_BlockSeFeatureImagesType_Fragment | XcNwBlock_BlockSePriceType_Fragment | XcNwBlock_BlockSeQualityDescriptionType_Fragment | XcNwBlock_BlockVideoType_Fragment | XcNwBlock_BlockVideoWithDescriptionType_Fragment | XcNwBlock_ButtonTypeBlockRowType_Fragment | XcNwBlock_ConsumptionValueTypeBlockRowType_Fragment | XcNwBlock_KeyFactSmallBlockRowType_Fragment | XcNwBlock_KeyFactTypeBlockRowType_Fragment | XcNwBlock_KpiTypeBlockRowType_Fragment | XcNwBlock_VehicleDataTableSectionTypeBlockRowType_Fragment;

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_AwardTypeBlockRowType_items_AwardType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  sections: Array<XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  iosHref: string,
  androidHref: string,
  iosLabel: string,
  androidLabel: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  media: BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  bannerTitle: string | null,
  cta: BlockBannerFragment_BlockBannerType_cta | null,
  bannerBackground: BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  count: number | null,
  chapterOpenerMedia: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType | null,
  chapterOpenerMediaMobile: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  rawItems: Array<any>,
  sections: Array<BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType>,
  config: BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType,
  items: Array<BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  callout: string | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  message: string,
  eventId: string | null,
  sentryLink?: string | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  externalLinkUrl: string,
  media: BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  highlightTitle: string,
  highlightDescription: string,
  highlightVisualization: BlockHighlightVisualizationEnum,
  cta: XcNwBlockFragment_BlockHighlightType_cta | null,
  media: XcNwBlockFragment_BlockHighlightType_media_XCMediaRefType,
  mediaMobile: XcNwBlockFragment_BlockHighlightType_mediaMobile_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  href: string,
  name: string,
  logo: BlockInstagramFragment_BlockInstagramType_logo_XCMediaRefType | null,
  instaItems: Array<BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  integrationType: OfficeIntegrationEnum,
  defaultValue: string | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  alignValue: AlignEnum,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_BlockKeyValueTableType_items_KeyValueType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image1: XcNwBlockFragment_BlockMediaComparisonSliderType_image1_XCMediaRefType,
  image2: XcNwBlockFragment_BlockMediaComparisonSliderType_image2_XCMediaRefType
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  mediaGalleryVisualization: BlockMediaGalleryVisualizationEnum,
  mediaGalleryItems: Array<BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image: XcNwBlockFragment_BlockMediaSingleImageType_image_XCMediaRefType,
  imageMobile: XcNwBlockFragment_BlockMediaSingleImageType_imageMobile_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  name: string,
  company: string | null,
  city: string | null,
  street: string | null,
  zipCode: string | null,
  streetNumber: string | null,
  geoLongitude: string | null,
  geoLatitude: string | null,
  phone: string | null,
  phoneService: string | null,
  newCarsSalesPhone: string | null,
  usedCarsSalesPhone: string | null,
  email: string | null,
  officeVCardImage: BlockOfficeVCardFragment_BlockOfficeVCardType_officeVCardImage_XCMediaRefType | null,
  openingHoursAccessory: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursAccessory_OpeningHoursType,
  openingHoursGeneral: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursGeneral_OpeningHoursType,
  openingHoursSelling: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursSelling_OpeningHoursType,
  openingHoursService: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursService_OpeningHoursType
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  title: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  pdfPreviewUrl: string
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  description: string | null,
  pricingTableTitle: string | null,
  units: Array<BlockPricingTableFragment_BlockPricingTableType_units_KeyValueType>,
  total: BlockPricingTableFragment_BlockPricingTableType_total_KeyValueType
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  quotes: Array<string>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  text: string
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  co2Class: string | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  images: Array<BlockSeFeatureImagesFragment_BlockSeFeatureImagesType_images_XCMediaRefType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  internalNumber: string | null,
  availability: AvailabilityEnum,
  price: number | null,
  tax: boolean | null,
  loanPageId: string | null,
  loan: string | null,
  leasingPageId: string | null,
  leasing: string | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  logoPosition: SealLogoPositionEnum | null,
  description: string | null,
  logo: BlockSeQualityDescriptionFragment_BlockSeQualityDescriptionType_logo_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  duration: number | null,
  autoplay: boolean,
  provider: VideoProviderEnum,
  thumbnail: BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  publishingDate: any | null,
  optionalTitle: string | null,
  duration: number | null,
  provider: VideoProviderEnum,
  videoDescription: string | null,
  thumbnail: BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ButtonTypeBlockRowType_items>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ConsumptionValueTypeBlockRowType_items_ConsumptionValueType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KeyFactSmallBlockRowType_items_KeyFactSmallType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  aspectRatio: AspectRatioEnum | null,
  keyFactVisualization: BlockKeyFactVisualizationEnum,
  items: Array<KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KpiTypeBlockRowType_items>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_VehicleDataTableSectionTypeBlockRowType_items_VehicleDataTableSectionType>
};

export type EufePageFragment_EufePageType_nestedPanels_PanelType_blocks = EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_AwardTypeBlockRowType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockAccordionType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockAppDownloadType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockAutoplayType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockBannerType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockChapterOpenerType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockDataSheetType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockDividerType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockDocumentHeaderType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockErrorType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockExternalLinkType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockHighlightType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockInstagramType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockIntegrationType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockJsonType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockKeyValueTableType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockMediaComparisonSliderType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockMediaGalleryType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockMediaSingleImageType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockOfficeVCardType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockPdfPreviewType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockPricingTableType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockQuotesType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockRichTextType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockSeEekType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockSeFeatureImagesType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockSePriceType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockSeQualityDescriptionType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockVideoType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_BlockVideoWithDescriptionType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_ButtonTypeBlockRowType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_ConsumptionValueTypeBlockRowType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_KeyFactSmallBlockRowType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_KeyFactTypeBlockRowType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_KpiTypeBlockRowType | EufePageFragment_EufePageType_nestedPanels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType;

export type EufePageFragment_EufePageType_nestedPanels_PanelType = {
  __typename: 'PanelType',
  id: string,
  blocks: Array<EufePageFragment_EufePageType_nestedPanels_PanelType_blocks>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_AwardTypeBlockRowType_items_AwardType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  sections: Array<XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  iosHref: string,
  androidHref: string,
  iosLabel: string,
  androidLabel: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  media: BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  bannerTitle: string | null,
  cta: BlockBannerFragment_BlockBannerType_cta | null,
  bannerBackground: BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  count: number | null,
  chapterOpenerMedia: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType | null,
  chapterOpenerMediaMobile: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  rawItems: Array<any>,
  sections: Array<BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType>,
  config: BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType,
  items: Array<BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  callout: string | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  message: string,
  eventId: string | null,
  sentryLink?: string | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  externalLinkUrl: string,
  media: BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  highlightTitle: string,
  highlightDescription: string,
  highlightVisualization: BlockHighlightVisualizationEnum,
  cta: XcNwBlockFragment_BlockHighlightType_cta | null,
  media: XcNwBlockFragment_BlockHighlightType_media_XCMediaRefType,
  mediaMobile: XcNwBlockFragment_BlockHighlightType_mediaMobile_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  href: string,
  name: string,
  logo: BlockInstagramFragment_BlockInstagramType_logo_XCMediaRefType | null,
  instaItems: Array<BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  integrationType: OfficeIntegrationEnum,
  defaultValue: string | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  alignValue: AlignEnum,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_BlockKeyValueTableType_items_KeyValueType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image1: XcNwBlockFragment_BlockMediaComparisonSliderType_image1_XCMediaRefType,
  image2: XcNwBlockFragment_BlockMediaComparisonSliderType_image2_XCMediaRefType
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  mediaGalleryVisualization: BlockMediaGalleryVisualizationEnum,
  mediaGalleryItems: Array<BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image: XcNwBlockFragment_BlockMediaSingleImageType_image_XCMediaRefType,
  imageMobile: XcNwBlockFragment_BlockMediaSingleImageType_imageMobile_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  name: string,
  company: string | null,
  city: string | null,
  street: string | null,
  zipCode: string | null,
  streetNumber: string | null,
  geoLongitude: string | null,
  geoLatitude: string | null,
  phone: string | null,
  phoneService: string | null,
  newCarsSalesPhone: string | null,
  usedCarsSalesPhone: string | null,
  email: string | null,
  officeVCardImage: BlockOfficeVCardFragment_BlockOfficeVCardType_officeVCardImage_XCMediaRefType | null,
  openingHoursAccessory: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursAccessory_OpeningHoursType,
  openingHoursGeneral: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursGeneral_OpeningHoursType,
  openingHoursSelling: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursSelling_OpeningHoursType,
  openingHoursService: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursService_OpeningHoursType
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  title: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  pdfPreviewUrl: string
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  description: string | null,
  pricingTableTitle: string | null,
  units: Array<BlockPricingTableFragment_BlockPricingTableType_units_KeyValueType>,
  total: BlockPricingTableFragment_BlockPricingTableType_total_KeyValueType
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  quotes: Array<string>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  text: string
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  co2Class: string | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  images: Array<BlockSeFeatureImagesFragment_BlockSeFeatureImagesType_images_XCMediaRefType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  internalNumber: string | null,
  availability: AvailabilityEnum,
  price: number | null,
  tax: boolean | null,
  loanPageId: string | null,
  loan: string | null,
  leasingPageId: string | null,
  leasing: string | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  logoPosition: SealLogoPositionEnum | null,
  description: string | null,
  logo: BlockSeQualityDescriptionFragment_BlockSeQualityDescriptionType_logo_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  duration: number | null,
  autoplay: boolean,
  provider: VideoProviderEnum,
  thumbnail: BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  publishingDate: any | null,
  optionalTitle: string | null,
  duration: number | null,
  provider: VideoProviderEnum,
  videoDescription: string | null,
  thumbnail: BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType | null
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ButtonTypeBlockRowType_items>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ConsumptionValueTypeBlockRowType_items_ConsumptionValueType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KeyFactSmallBlockRowType_items_KeyFactSmallType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  aspectRatio: AspectRatioEnum | null,
  keyFactVisualization: BlockKeyFactVisualizationEnum,
  items: Array<KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KpiTypeBlockRowType_items>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_VehicleDataTableSectionTypeBlockRowType_items_VehicleDataTableSectionType>
};

export type EufePageFragment_EufePageType_panels_PanelType_blocks = EufePageFragment_EufePageType_panels_PanelType_blocks_AwardTypeBlockRowType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockAccordionType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockAppDownloadType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockAutoplayType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockBannerType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockChapterOpenerType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockDataSheetType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockDividerType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockDocumentHeaderType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockErrorType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockExternalLinkType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockHighlightType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockInstagramType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockIntegrationType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockJsonType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockKeyValueTableType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockMediaComparisonSliderType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockMediaGalleryType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockMediaSingleImageType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockOfficeVCardType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockPdfPreviewType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockPricingTableType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockQuotesType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockRichTextType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockSeEekType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockSeFeatureImagesType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockSePriceType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockSeQualityDescriptionType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockVideoType | EufePageFragment_EufePageType_panels_PanelType_blocks_BlockVideoWithDescriptionType | EufePageFragment_EufePageType_panels_PanelType_blocks_ButtonTypeBlockRowType | EufePageFragment_EufePageType_panels_PanelType_blocks_ConsumptionValueTypeBlockRowType | EufePageFragment_EufePageType_panels_PanelType_blocks_KeyFactSmallBlockRowType | EufePageFragment_EufePageType_panels_PanelType_blocks_KeyFactTypeBlockRowType | EufePageFragment_EufePageType_panels_PanelType_blocks_KpiTypeBlockRowType | EufePageFragment_EufePageType_panels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType;

export type EufePageFragment_EufePageType_panels_PanelType = {
  __typename: 'PanelType',
  id: string,
  blocks: Array<EufePageFragment_EufePageType_panels_PanelType_blocks>
};

export type EufePageFragment = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type PanelFragment_PanelType_blocks_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_AwardTypeBlockRowType_items_AwardType>
};

export type PanelFragment_PanelType_blocks_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  sections: Array<XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType>
};

export type PanelFragment_PanelType_blocks_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  iosHref: string,
  androidHref: string,
  iosLabel: string,
  androidLabel: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type PanelFragment_PanelType_blocks_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  media: BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType
};

export type PanelFragment_PanelType_blocks_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  bannerTitle: string | null,
  cta: BlockBannerFragment_BlockBannerType_cta | null,
  bannerBackground: BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType | null
};

export type PanelFragment_PanelType_blocks_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  count: number | null,
  chapterOpenerMedia: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType | null,
  chapterOpenerMediaMobile: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType | null
};

export type PanelFragment_PanelType_blocks_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  rawItems: Array<any>,
  sections: Array<BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType>,
  config: BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType,
  items: Array<BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType>
};

export type PanelFragment_PanelType_blocks_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type PanelFragment_PanelType_blocks_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  callout: string | null
};

export type PanelFragment_PanelType_blocks_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  message: string,
  eventId: string | null,
  sentryLink?: string | null
};

export type PanelFragment_PanelType_blocks_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  externalLinkUrl: string,
  media: BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType
};

export type PanelFragment_PanelType_blocks_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  highlightTitle: string,
  highlightDescription: string,
  highlightVisualization: BlockHighlightVisualizationEnum,
  cta: XcNwBlockFragment_BlockHighlightType_cta | null,
  media: XcNwBlockFragment_BlockHighlightType_media_XCMediaRefType,
  mediaMobile: XcNwBlockFragment_BlockHighlightType_mediaMobile_XCMediaRefType | null
};

export type PanelFragment_PanelType_blocks_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  href: string,
  name: string,
  logo: BlockInstagramFragment_BlockInstagramType_logo_XCMediaRefType | null,
  instaItems: Array<BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType>
};

export type PanelFragment_PanelType_blocks_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  integrationType: OfficeIntegrationEnum,
  defaultValue: string | null
};

export type PanelFragment_PanelType_blocks_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type PanelFragment_PanelType_blocks_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  alignValue: AlignEnum,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_BlockKeyValueTableType_items_KeyValueType>
};

export type PanelFragment_PanelType_blocks_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image1: XcNwBlockFragment_BlockMediaComparisonSliderType_image1_XCMediaRefType,
  image2: XcNwBlockFragment_BlockMediaComparisonSliderType_image2_XCMediaRefType
};

export type PanelFragment_PanelType_blocks_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  mediaGalleryVisualization: BlockMediaGalleryVisualizationEnum,
  mediaGalleryItems: Array<BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType>
};

export type PanelFragment_PanelType_blocks_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image: XcNwBlockFragment_BlockMediaSingleImageType_image_XCMediaRefType,
  imageMobile: XcNwBlockFragment_BlockMediaSingleImageType_imageMobile_XCMediaRefType | null
};

export type PanelFragment_PanelType_blocks_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  name: string,
  company: string | null,
  city: string | null,
  street: string | null,
  zipCode: string | null,
  streetNumber: string | null,
  geoLongitude: string | null,
  geoLatitude: string | null,
  phone: string | null,
  phoneService: string | null,
  newCarsSalesPhone: string | null,
  usedCarsSalesPhone: string | null,
  email: string | null,
  officeVCardImage: BlockOfficeVCardFragment_BlockOfficeVCardType_officeVCardImage_XCMediaRefType | null,
  openingHoursAccessory: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursAccessory_OpeningHoursType,
  openingHoursGeneral: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursGeneral_OpeningHoursType,
  openingHoursSelling: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursSelling_OpeningHoursType,
  openingHoursService: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursService_OpeningHoursType
};

export type PanelFragment_PanelType_blocks_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  title: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  pdfPreviewUrl: string
};

export type PanelFragment_PanelType_blocks_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  description: string | null,
  pricingTableTitle: string | null,
  units: Array<BlockPricingTableFragment_BlockPricingTableType_units_KeyValueType>,
  total: BlockPricingTableFragment_BlockPricingTableType_total_KeyValueType
};

export type PanelFragment_PanelType_blocks_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  quotes: Array<string>
};

export type PanelFragment_PanelType_blocks_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  text: string
};

export type PanelFragment_PanelType_blocks_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  co2Class: string | null
};

export type PanelFragment_PanelType_blocks_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  images: Array<BlockSeFeatureImagesFragment_BlockSeFeatureImagesType_images_XCMediaRefType>
};

export type PanelFragment_PanelType_blocks_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  internalNumber: string | null,
  availability: AvailabilityEnum,
  price: number | null,
  tax: boolean | null,
  loanPageId: string | null,
  loan: string | null,
  leasingPageId: string | null,
  leasing: string | null
};

export type PanelFragment_PanelType_blocks_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  logoPosition: SealLogoPositionEnum | null,
  description: string | null,
  logo: BlockSeQualityDescriptionFragment_BlockSeQualityDescriptionType_logo_XCMediaRefType | null
};

export type PanelFragment_PanelType_blocks_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  duration: number | null,
  autoplay: boolean,
  provider: VideoProviderEnum,
  thumbnail: BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType | null
};

export type PanelFragment_PanelType_blocks_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  publishingDate: any | null,
  optionalTitle: string | null,
  duration: number | null,
  provider: VideoProviderEnum,
  videoDescription: string | null,
  thumbnail: BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType | null
};

export type PanelFragment_PanelType_blocks_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ButtonTypeBlockRowType_items>
};

export type PanelFragment_PanelType_blocks_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ConsumptionValueTypeBlockRowType_items_ConsumptionValueType>
};

export type PanelFragment_PanelType_blocks_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KeyFactSmallBlockRowType_items_KeyFactSmallType>
};

export type PanelFragment_PanelType_blocks_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  aspectRatio: AspectRatioEnum | null,
  keyFactVisualization: BlockKeyFactVisualizationEnum,
  items: Array<KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType>
};

export type PanelFragment_PanelType_blocks_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KpiTypeBlockRowType_items>
};

export type PanelFragment_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_VehicleDataTableSectionTypeBlockRowType_items_VehicleDataTableSectionType>
};

export type PanelFragment_PanelType_blocks = PanelFragment_PanelType_blocks_AwardTypeBlockRowType | PanelFragment_PanelType_blocks_BlockAccordionType | PanelFragment_PanelType_blocks_BlockAppDownloadType | PanelFragment_PanelType_blocks_BlockAutoplayType | PanelFragment_PanelType_blocks_BlockBannerType | PanelFragment_PanelType_blocks_BlockChapterOpenerType | PanelFragment_PanelType_blocks_BlockDataSheetType | PanelFragment_PanelType_blocks_BlockDividerType | PanelFragment_PanelType_blocks_BlockDocumentHeaderType | PanelFragment_PanelType_blocks_BlockErrorType | PanelFragment_PanelType_blocks_BlockExternalLinkType | PanelFragment_PanelType_blocks_BlockHighlightType | PanelFragment_PanelType_blocks_BlockInstagramType | PanelFragment_PanelType_blocks_BlockIntegrationType | PanelFragment_PanelType_blocks_BlockJsonType | PanelFragment_PanelType_blocks_BlockKeyValueTableType | PanelFragment_PanelType_blocks_BlockMediaComparisonSliderType | PanelFragment_PanelType_blocks_BlockMediaGalleryType | PanelFragment_PanelType_blocks_BlockMediaSingleImageType | PanelFragment_PanelType_blocks_BlockOfficeVCardType | PanelFragment_PanelType_blocks_BlockPdfPreviewType | PanelFragment_PanelType_blocks_BlockPricingTableType | PanelFragment_PanelType_blocks_BlockQuotesType | PanelFragment_PanelType_blocks_BlockRichTextType | PanelFragment_PanelType_blocks_BlockSeEekType | PanelFragment_PanelType_blocks_BlockSeFeatureImagesType | PanelFragment_PanelType_blocks_BlockSePriceType | PanelFragment_PanelType_blocks_BlockSeQualityDescriptionType | PanelFragment_PanelType_blocks_BlockVideoType | PanelFragment_PanelType_blocks_BlockVideoWithDescriptionType | PanelFragment_PanelType_blocks_ButtonTypeBlockRowType | PanelFragment_PanelType_blocks_ConsumptionValueTypeBlockRowType | PanelFragment_PanelType_blocks_KeyFactSmallBlockRowType | PanelFragment_PanelType_blocks_KeyFactTypeBlockRowType | PanelFragment_PanelType_blocks_KpiTypeBlockRowType | PanelFragment_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType;

export type PanelFragment = {
  __typename: 'PanelType',
  id: string,
  blocks: Array<PanelFragment_PanelType_blocks>
};

export type CtaBarFragment_CtaBarType_cta_ContactFormTriggerButtonType = {
  __typename: 'ContactFormTriggerButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type CtaBarFragment_CtaBarType_cta_CopyButtonType = {
  __typename: 'CopyButtonType',
  content: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type CtaBarFragment_CtaBarType_cta_DialogButtonType = {
  __typename: 'DialogButtonType',
  panelId: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type CtaBarFragment_CtaBarType_cta_DocButtonType = {
  __typename: 'DocButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  docIdentifier: any,
  document: ButtonInterfaceFragment_DocButtonType_document,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type CtaBarFragment_CtaBarType_cta_DownloadButtonType = {
  __typename: 'DownloadButtonType',
  fileName: string | null,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  media: ButtonInterfaceFragment_DownloadButtonType_media_XCMediaRefType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type CtaBarFragment_CtaBarType_cta_HrefButtonType = {
  __typename: 'HrefButtonType',
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  href: string,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type CtaBarFragment_CtaBarType_cta_NestedContentButtonType = {
  __typename: 'NestedContentButtonType',
  panelId: string,
  identifier: string,
  disclaimer: string | null,
  size: ButtonSizeEnum,
  variant: ButtonVariantEnum,
  leadingIcon: ButtonIconEnum | null,
  trailingIcon: ButtonIconEnum | null,
  label: string | null,
  panel?: ButtonInterfaceFragment_NestedContentButtonType_panel_PanelType,
  mboAttrs: ButtonInterfaceFragment_ContactFormTriggerButtonType_mboAttrs_MboAttrsType | null
};

export type CtaBarFragment_CtaBarType_cta = CtaBarFragment_CtaBarType_cta_ContactFormTriggerButtonType | CtaBarFragment_CtaBarType_cta_CopyButtonType | CtaBarFragment_CtaBarType_cta_DialogButtonType | CtaBarFragment_CtaBarType_cta_DocButtonType | CtaBarFragment_CtaBarType_cta_DownloadButtonType | CtaBarFragment_CtaBarType_cta_HrefButtonType | CtaBarFragment_CtaBarType_cta_NestedContentButtonType;

export type CtaBarFragment = {
  __typename: 'CtaBarType',
  description: string | null,
  cta: CtaBarFragment_CtaBarType_cta
};

export type XcDisclaimerInterface_XcDocDisclaimerType_Fragment = {
  __typename: 'XCDocDisclaimerType',
  id: string,
  key: string,
  variant: DisclaimerVariantEnum,
  docTextContent: string
};

export type XcDisclaimerInterface_XcInfoFootnoteType_Fragment = {
  __typename: 'XCInfoFootnoteType',
  textClick: string,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type XcDisclaimerInterface_XcRectangleFootnoteType_Fragment = {
  __typename: 'XCRectangleFootnoteType',
  textHover: string | null,
  textContent: string | null,
  colorBackground: string | null,
  colorFont: string | null,
  colorBorder: string | null,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type XcDisclaimerInterfaceFragment = XcDisclaimerInterface_XcDocDisclaimerType_Fragment | XcDisclaimerInterface_XcInfoFootnoteType_Fragment | XcDisclaimerInterface_XcRectangleFootnoteType_Fragment;

export type XcNwDataFragment_DocumentType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type XcNwDataFragment_DocumentType_xcMediaLibrary_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcNwDataFragment_DocumentType_inlineDisclaimers_XCDocDisclaimerType = {
  __typename: 'XCDocDisclaimerType',
  id: string,
  key: string,
  variant: DisclaimerVariantEnum,
  docTextContent: string
};

export type XcNwDataFragment_DocumentType_inlineDisclaimers_XCInfoFootnoteType = {
  __typename: 'XCInfoFootnoteType',
  textClick: string,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type XcNwDataFragment_DocumentType_inlineDisclaimers_XCRectangleFootnoteType = {
  __typename: 'XCRectangleFootnoteType',
  textHover: string | null,
  textContent: string | null,
  colorBackground: string | null,
  colorFont: string | null,
  colorBorder: string | null,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type XcNwDataFragment_DocumentType_inlineDisclaimers = XcNwDataFragment_DocumentType_inlineDisclaimers_XCDocDisclaimerType | XcNwDataFragment_DocumentType_inlineDisclaimers_XCInfoFootnoteType | XcNwDataFragment_DocumentType_inlineDisclaimers_XCRectangleFootnoteType;

export type XcNwDataFragment_DocumentType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType = {
  __typename: 'ExternalLinkDisclaimerConfigType',
  text: string,
  whiteList: Array<string>
};

export type XcNwDataFragment_DocumentType_xcTheme_XCThemeType = {
  __typename: 'XCThemeType',
  id: string,
  cssVariablesStr: string,
  cssVariables: any,
  cssHeader: string,
  faviconUrl: string | null,
  header: ThemeHeaderEnum,
  name?: string | null,
  headerFont?: XcThemeFragment_XCThemeType_headerFont_KeyValueType | null,
  bodyFont?: XcThemeFragment_XCThemeType_bodyFont_KeyValueType | null,
  favicon: XcThemeFragment_XCThemeType_favicon_XCMediaRefType | null,
  logo: XcThemeFragment_XCThemeType_logo_XCMediaRefType | null
};

export type XcNwDataFragment = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  displayName: string,
  brandId: string | null,
  disclaimers: Array<string>,
  pages: Array<XcNwDataFragment_DocumentType_pages_EufePageType>,
  xcMediaLibrary?: Array<XcNwDataFragment_DocumentType_xcMediaLibrary_XCMediaRefType>,
  inlineDisclaimers: Array<XcNwDataFragment_DocumentType_inlineDisclaimers>,
  externalLinkDisclaimerConfig: XcNwDataFragment_DocumentType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcNwDataFragment_DocumentType_xcTheme_XCThemeType | null
};

export type ErrorFragment = {
  __typename: 'ErrorType',
  message: string,
  code: ErrorCodeEnum,
  rawCode: number
};

export type SuccessFragment = {
  __typename: 'SuccessType',
  message: string,
  objId: string | null
};

export type ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_seOfficeVideo_ThirdPartyVideoType = {
  __typename: 'ThirdPartyVideoType',
  src: string,
  provider: VideoProviderEnum,
  thumbnail: string | null
};

export type ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_privacyStatement_LegalTextType = {
  __typename: 'LegalTextType',
  id: string,
  rendered: string
};

export type ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_cookieContext_CookieContextType_cookiePolicy_LegalTextType = {
  __typename: 'LegalTextType',
  id: string,
  rendered: string
};

export type ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_cookieContext_CookieContextType_cookieOptions_CookieOptionType = {
  __typename: 'CookieOptionType',
  id: string,
  default: boolean,
  headline: string,
  key: number,
  text: string,
  vital: boolean
};

export type ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_cookieContext_CookieContextType = {
  __typename: 'CookieContextType',
  id: string,
  blocking: boolean,
  text: string,
  overlayHeadline: string,
  overlayText: string,
  cookiePolicy: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_cookieContext_CookieContextType_cookiePolicy_LegalTextType | null,
  cookieOptions: Array<ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_cookieContext_CookieContextType_cookieOptions_CookieOptionType>
};

export type ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_xcTheme_XCThemeType = {
  __typename: 'XCThemeType',
  id: string,
  cssVariablesStr: string,
  cssVariables: any,
  cssHeader: string,
  faviconUrl: string | null,
  header: ThemeHeaderEnum,
  name?: string | null,
  headerFont?: XcThemeFragment_XCThemeType_headerFont_KeyValueType | null,
  bodyFont?: XcThemeFragment_XCThemeType_bodyFont_KeyValueType | null,
  favicon: XcThemeFragment_XCThemeType_favicon_XCMediaRefType | null,
  logo: XcThemeFragment_XCThemeType_logo_XCMediaRefType | null
};

export type ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_logo_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType = {
  __typename: 'OfficeType',
  id: string,
  street: string,
  zipcode: string,
  addressLine2: string,
  addressLine1: string,
  city: string,
  thumbnailUrl: string | null,
  imprintUrl: string | null,
  logoLabel: string | null,
  googleMapsUrl: string | null,
  stockUrl: string | null,
  seOfficeVideo: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_seOfficeVideo_ThirdPartyVideoType | null,
  privacyStatement: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_privacyStatement_LegalTextType,
  cookieContext: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_cookieContext_CookieContextType,
  xcTheme: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_xcTheme_XCThemeType | null,
  logo: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_logo_XCMediaRefType | null
};

export type ContentLandingPageProjectFragment_ContentLandingPageProjectType_xcTheme_XCThemeType = {
  __typename: 'XCThemeType',
  id: string,
  cssVariablesStr: string,
  cssVariables: any,
  cssHeader: string,
  faviconUrl: string | null,
  header: ThemeHeaderEnum,
  name?: string | null,
  headerFont?: XcThemeFragment_XCThemeType_headerFont_KeyValueType | null,
  bodyFont?: XcThemeFragment_XCThemeType_bodyFont_KeyValueType | null,
  favicon: XcThemeFragment_XCThemeType_favicon_XCMediaRefType | null,
  logo: XcThemeFragment_XCThemeType_logo_XCMediaRefType | null
};

export type ContentLandingPageProjectFragment = {
  __typename: 'ContentLandingPageProjectType',
  active?: boolean,
  created?: any,
  updated?: any,
  name: string,
  organizationId: string,
  office: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType,
  xcTheme: ContentLandingPageProjectFragment_ContentLandingPageProjectType_xcTheme_XCThemeType | null
};

export type OfficeFeatureFragment = {
  __typename: 'OfficeFeatureType',
  id: string,
  label: string,
  featureType: OfficeFeatureEnum
};

export type ContactPersonFragment_MemberType_video_ThirdPartyVideoType = {
  __typename: 'ThirdPartyVideoType',
  src: string,
  provider: VideoProviderEnum,
  thumbnail: string | null
};

export type ContactPersonFragment = {
  __typename: 'MemberType',
  id: string,
  fullName: string,
  firstName: string,
  email: string,
  salutation: SalutationEnum,
  displayEmail: string | null,
  lastName: string,
  mobile: string,
  phone: string | null,
  fax: string,
  thumbnail: string | null,
  title: string | null,
  vcard: string,
  isCampaignUser: boolean,
  video: ContactPersonFragment_MemberType_video_ThirdPartyVideoType | null
};

export type MemberFragment_MemberType_features_OfficeFeatureType = {
  __typename: 'OfficeFeatureType',
  id: string,
  label: string,
  featureType: OfficeFeatureEnum
};

export type MemberFragment = {
  __typename: 'MemberType',
  id: string,
  title: string | null,
  salutation: SalutationEnum,
  firstName: string,
  lastName: string,
  avatarSrc: string | null,
  hasSeFeature: boolean,
  hasAutomotiveFeature: boolean,
  hasGroupAnalysisFeature: boolean,
  hasCombinedDashboardFeature: boolean,
  hasCmsFeature: boolean,
  hasThemeEditorFeature: boolean,
  hasPrintManagerFeature: boolean,
  features: Array<MemberFragment_MemberType_features_OfficeFeatureType>
};

export type MemberProfileFragment = {
  __typename: 'MemberType',
  email: string,
  phone: string | null,
  mobile: string,
  fax: string,
  hasUsablePassword: boolean,
  id: string,
  title: string | null,
  salutation: SalutationEnum,
  firstName: string,
  lastName: string,
  avatarOriginalSrc: string | null,
  avatarSrc: string | null,
  hasSeFeature: boolean,
  hasAutomotiveFeature: boolean,
  hasGroupAnalysisFeature: boolean,
  hasCombinedDashboardFeature: boolean,
  hasCmsFeature: boolean,
  hasThemeEditorFeature: boolean,
  hasPrintManagerFeature: boolean,
  features: Array<MemberFragment_MemberType_features_OfficeFeatureType>
};

export type StockFragment = {
  __typename: 'MobField0MappingType',
  id: string,
  label: string,
  value: string
};

export type CarFragment_MobRecordType_mediaRef_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type CarFragment = {
  __typename: 'MobRecordType',
  id: string,
  identifier: any,
  fullName: string,
  disclaimers: Array<string>,
  internalName: string | null,
  price: number | null,
  kilometers: number | null,
  mediaRef: CarFragment_MobRecordType_mediaRef_XCMediaRefType | null
};

export type CampaignFragment = {
  __typename: 'XCCampaignType',
  id: string,
  displayName: string
};

export type AnalyticBucketFragment = {
  __typename: 'XCCampaignAnalyticBucketType',
  createdAt: any,
  scans: number,
  claims: number,
  visits: number
};

export type AnalyticLvFragment = {
  __typename: 'XCCampaignLVAnalyticType',
  label: string,
  value: number
};

export type LockStatusFragment = {
  __typename: 'LockStatusType',
  action: BlockStatusActionEnum,
  currentEditor: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType_currentEditor_MemberType
};

export type CmsCollectionFragment_XCollectionAutomotiveType_inlineDisclaimers_XCDocDisclaimerType = {
  __typename: 'XCDocDisclaimerType',
  id: string,
  key: string,
  variant: DisclaimerVariantEnum,
  docTextContent: string
};

export type CmsCollectionFragment_XCollectionAutomotiveType_inlineDisclaimers_XCInfoFootnoteType = {
  __typename: 'XCInfoFootnoteType',
  textClick: string,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type CmsCollectionFragment_XCollectionAutomotiveType_inlineDisclaimers_XCRectangleFootnoteType = {
  __typename: 'XCRectangleFootnoteType',
  textHover: string | null,
  textContent: string | null,
  colorBackground: string | null,
  colorFont: string | null,
  colorBorder: string | null,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type CmsCollectionFragment_XCollectionAutomotiveType_inlineDisclaimers = CmsCollectionFragment_XCollectionAutomotiveType_inlineDisclaimers_XCDocDisclaimerType | CmsCollectionFragment_XCollectionAutomotiveType_inlineDisclaimers_XCInfoFootnoteType | CmsCollectionFragment_XCollectionAutomotiveType_inlineDisclaimers_XCRectangleFootnoteType;

export type CmsCollectionFragment = {
  __typename: 'XCollectionAutomotiveType',
  id: string,
  name: string,
  isCms: boolean,
  contentCount: number,
  inlineDisclaimers: Array<CmsCollectionFragment_XCollectionAutomotiveType_inlineDisclaimers>
};

export type CmsCollectionDocumentFragment = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  name: string,
  editVersionId: string,
  keyVisualUrl: string
};

export type GenericCodeFragment_XCGenericCodeDataType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type GenericCodeFragment = {
  __typename: 'XCGenericCodeDataType',
  genericCode: string,
  pages: Array<GenericCodeFragment_XCGenericCodeDataType_pages_EufePageType>
};

export type ExternalLinkDisclaimerConfigFragment = {
  __typename: 'ExternalLinkDisclaimerConfigType',
  text: string,
  whiteList: Array<string>
};

export type XcRecordFragment_XCCCCupraDataType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType = {
  __typename: 'CtaBarType',
  description: string | null,
  cta: CtaBarFragment_CtaBarType_cta
};

export type XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  altText: string | null,
  thumbnailUrl: string,
  id: string,
  fileUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType = {
  __typename: 'ExternalLinkDisclaimerConfigType',
  text: string,
  whiteList: Array<string>
};

export type XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType = {
  __typename: 'XCThemeType',
  id: string,
  cssVariablesStr: string,
  cssVariables: any,
  cssHeader: string,
  faviconUrl: string | null,
  header: ThemeHeaderEnum,
  name?: string | null,
  headerFont?: XcThemeFragment_XCThemeType_headerFont_KeyValueType | null,
  bodyFont?: XcThemeFragment_XCThemeType_bodyFont_KeyValueType | null,
  favicon: XcThemeFragment_XCThemeType_favicon_XCMediaRefType | null,
  logo: XcThemeFragment_XCThemeType_logo_XCMediaRefType | null
};

export type XcRecordFragment_XCCCSeatDataType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type XcRecordFragment_XCDgaDataAudiType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type XcRecordFragment_XCDgaDataVwType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type XcRecordFragment_XCDgaDataVwnType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type XcRecordFragment_XCNwDataType_document_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  disclaimers: Array<string>,
  brandId: string | null
};

export type XcRecordFragment_XCSeDataType_expose_MobRecordType_keyVisual_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcRecordFragment_XCSeDataType_expose_MobRecordType = {
  __typename: 'MobRecordType',
  id: string,
  identifier: any,
  disclaimers: Array<string>,
  interneNummer: string | null,
  archived: boolean,
  reserviert: boolean | null,
  keyVisual: XcRecordFragment_XCSeDataType_expose_MobRecordType_keyVisual_XCMediaRefType | null
};

export type XcRecordFragment_XCUploadDataAttachmentType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type XcRecordFragment_XCUploadDataImageGalleryType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type XcRecord_XcccCupraDataType_Fragment = {
  __typename: 'XCCCCupraDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCCCCupraDataType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcccSeatDataType_Fragment = {
  __typename: 'XCCCSeatDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCCCSeatDataType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcDgaDataAudiType_Fragment = {
  __typename: 'XCDgaDataAudiType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCDgaDataAudiType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcDgaDataVwType_Fragment = {
  __typename: 'XCDgaDataVwType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCDgaDataVwType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcDgaDataVwnType_Fragment = {
  __typename: 'XCDgaDataVwnType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCDgaDataVwnType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcExternalLinkDataType_Fragment = {
  __typename: 'XCExternalLinkDataType',
  ogTitle: string | null,
  ogType: string | null,
  ogDescription: string | null,
  ogVideo: string | null,
  url: string,
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcGenericCodeDataType_Fragment = {
  __typename: 'XCGenericCodeDataType',
  genericCode: string,
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null,
  pages: Array<GenericCodeFragment_XCGenericCodeDataType_pages_EufePageType>
};

export type XcRecord_XcNwDataType_Fragment = {
  __typename: 'XCNwDataType',
  selectedPageIds: Array<string> | null,
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  document: XcRecordFragment_XCNwDataType_document_DocumentType,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcPricingTableType_Fragment = {
  __typename: 'XCPricingTableType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcSeDataType_Fragment = {
  __typename: 'XCSeDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string,
  note: string | null,
  subItemCount: number,
  expose: XcRecordFragment_XCSeDataType_expose_MobRecordType,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcUploadDataAttachmentType_Fragment = {
  __typename: 'XCUploadDataAttachmentType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCUploadDataAttachmentType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecord_XcUploadDataImageGalleryType_Fragment = {
  __typename: 'XCUploadDataImageGalleryType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCUploadDataImageGalleryType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type XcRecordFragment = XcRecord_XcccCupraDataType_Fragment | XcRecord_XcccSeatDataType_Fragment | XcRecord_XcDgaDataAudiType_Fragment | XcRecord_XcDgaDataVwType_Fragment | XcRecord_XcDgaDataVwnType_Fragment | XcRecord_XcExternalLinkDataType_Fragment | XcRecord_XcGenericCodeDataType_Fragment | XcRecord_XcNwDataType_Fragment | XcRecord_XcPricingTableType_Fragment | XcRecord_XcSeDataType_Fragment | XcRecord_XcUploadDataAttachmentType_Fragment | XcRecord_XcUploadDataImageGalleryType_Fragment;

export type LegalTextFragment = {
  __typename: 'LegalTextType',
  id: string,
  rendered: string
};

export type OfficeFragment = {
  __typename: 'OfficeType',
  id: string,
  street: string,
  zipcode: string,
  addressLine2: string,
  addressLine1: string,
  city: string,
  thumbnailUrl: string | null,
  imprintUrl: string | null,
  logoLabel: string | null,
  googleMapsUrl: string | null,
  stockUrl: string | null,
  seOfficeVideo: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_seOfficeVideo_ThirdPartyVideoType | null,
  privacyStatement: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_privacyStatement_LegalTextType,
  cookieContext: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_cookieContext_CookieContextType,
  xcTheme: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_xcTheme_XCThemeType | null,
  logo: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_logo_XCMediaRefType | null
};

export type SealFragment_SealType_logo_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type SealFragment_SealType_video_ThirdPartyVideoType = {
  __typename: 'ThirdPartyVideoType',
  src: string,
  provider: VideoProviderEnum,
  thumbnail: string | null
};

export type SealFragment_SealType_accordion_SealAccordionType_attachments_KeyValueType = {
  __typename: 'KeyValueType',
  id: string,
  label: string,
  href: string
};

export type SealFragment_SealType_accordion_SealAccordionType_footnotes_KeyValueType = {
  __typename: 'KeyValueType',
  id: string,
  key: string,
  text: string
};

export type SealFragment_SealType_accordion_SealAccordionType = {
  __typename: 'SealAccordionType',
  title: string,
  description: string,
  attachments: Array<SealFragment_SealType_accordion_SealAccordionType_attachments_KeyValueType>,
  footnotes: Array<SealFragment_SealType_accordion_SealAccordionType_footnotes_KeyValueType>
};

export type SealFragment = {
  __typename: 'SealType',
  id: string,
  description: string | null,
  logoPosition: SealLogoPositionEnum,
  websiteUrl: string | null,
  logo: SealFragment_SealType_logo_XCMediaRefType | null,
  video: SealFragment_SealType_video_ThirdPartyVideoType | null,
  accordion: Array<SealFragment_SealType_accordion_SealAccordionType>
};

export type CookieOptionFragment = {
  __typename: 'CookieOptionType',
  id: string,
  default: boolean,
  headline: string,
  key: number,
  text: string,
  vital: boolean
};

export type ExposeDataFragment_MobRecordType_keyVisual_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type ExposeDataFragment_MobRecordType_mediaRefs_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type ExposeDataFragment_MobRecordType_seal_SealType = {
  __typename: 'SealType',
  id: string,
  description: string | null,
  logoPosition: SealLogoPositionEnum,
  websiteUrl: string | null,
  logo: SealFragment_SealType_logo_XCMediaRefType | null,
  video: SealFragment_SealType_video_ThirdPartyVideoType | null,
  accordion: Array<SealFragment_SealType_accordion_SealAccordionType>
};

export type ExposeDataFragment_MobRecordType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type ExposeDataFragment = {
  __typename: 'MobRecordType',
  id: string,
  identifier: any,
  fullName: string,
  reserviert: boolean | null,
  interneNummer: string | null,
  videoUrl: string | null,
  archived: boolean,
  disclaimers: Array<string>,
  niceName: string,
  keyVisual: ExposeDataFragment_MobRecordType_keyVisual_XCMediaRefType | null,
  mediaRefs: Array<ExposeDataFragment_MobRecordType_mediaRefs_XCMediaRefType>,
  seal: ExposeDataFragment_MobRecordType_seal_SealType | null,
  pages: Array<ExposeDataFragment_MobRecordType_pages_EufePageType>
};

export type ExternalLinkDataFragment = {
  __typename: 'XCExternalLinkDataType',
  ogTitle: string | null,
  ogType: string | null,
  ogDescription: string | null,
  ogVideo: string | null,
  url: string
};

export type ExposeFolderFragment_ExposeFolderType_contactPerson_MemberType = {
  __typename: 'MemberType',
  id: string,
  fullName: string,
  firstName: string,
  email: string,
  salutation: SalutationEnum,
  displayEmail: string | null,
  lastName: string,
  mobile: string,
  phone: string | null,
  fax: string,
  thumbnail: string | null,
  title: string | null,
  vcard: string,
  isCampaignUser: boolean,
  video: ContactPersonFragment_MemberType_video_ThirdPartyVideoType | null
};

export type ExposeFolderFragment_ExposeFolderType_office_OfficeType = {
  __typename: 'OfficeType',
  id: string,
  street: string,
  zipcode: string,
  addressLine2: string,
  addressLine1: string,
  city: string,
  thumbnailUrl: string | null,
  imprintUrl: string | null,
  logoLabel: string | null,
  googleMapsUrl: string | null,
  stockUrl: string | null,
  seOfficeVideo: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_seOfficeVideo_ThirdPartyVideoType | null,
  privacyStatement: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_privacyStatement_LegalTextType,
  cookieContext: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_cookieContext_CookieContextType,
  xcTheme: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_xcTheme_XCThemeType | null,
  logo: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_logo_XCMediaRefType | null
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCCCCupraDataType = {
  __typename: 'XCCCCupraDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCCCSeatDataType = {
  __typename: 'XCCCSeatDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCDgaDataAudiType = {
  __typename: 'XCDgaDataAudiType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCDgaDataVwType = {
  __typename: 'XCDgaDataVwType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCDgaDataVwnType = {
  __typename: 'XCDgaDataVwnType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCExternalLinkDataType = {
  __typename: 'XCExternalLinkDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCGenericCodeDataType = {
  __typename: 'XCGenericCodeDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCNwDataType = {
  __typename: 'XCNwDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCPricingTableType = {
  __typename: 'XCPricingTableType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCSeDataType = {
  __typename: 'XCSeDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCUploadDataAttachmentType = {
  __typename: 'XCUploadDataAttachmentType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords_XCUploadDataImageGalleryType = {
  __typename: 'XCUploadDataImageGalleryType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  xcMediaRef: XcRecordBaseFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType
};

export type ExposeFolderFragment_ExposeFolderType_xcRecords = ExposeFolderFragment_ExposeFolderType_xcRecords_XCCCCupraDataType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCCCSeatDataType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCDgaDataAudiType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCDgaDataVwType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCDgaDataVwnType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCExternalLinkDataType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCGenericCodeDataType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCNwDataType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCPricingTableType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCSeDataType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCUploadDataAttachmentType | ExposeFolderFragment_ExposeFolderType_xcRecords_XCUploadDataImageGalleryType;

export type ExposeFolderFragment = {
  __typename: 'ExposeFolderType',
  id: string,
  slug: string,
  salutationType: SalutationTypeEnum,
  salutationText: string | null,
  salutation: string,
  created: any,
  lastEdit: any | null,
  organizationId: string,
  contactPerson: ExposeFolderFragment_ExposeFolderType_contactPerson_MemberType | null,
  office: ExposeFolderFragment_ExposeFolderType_office_OfficeType,
  xcRecords: Array<ExposeFolderFragment_ExposeFolderType_xcRecords>
};

export type ContentLandingPageFragment_ContentLandingPageType_document_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  displayName: string,
  brandId: string | null,
  disclaimers: Array<string>,
  pages: Array<XcNwDataFragment_DocumentType_pages_EufePageType>,
  xcMediaLibrary?: Array<XcNwDataFragment_DocumentType_xcMediaLibrary_XCMediaRefType>,
  inlineDisclaimers: Array<XcNwDataFragment_DocumentType_inlineDisclaimers>,
  externalLinkDisclaimerConfig: XcNwDataFragment_DocumentType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcNwDataFragment_DocumentType_xcTheme_XCThemeType | null
};

export type ContentLandingPageFragment_ContentLandingPageType_project_ContentLandingPageProjectType = {
  __typename: 'ContentLandingPageProjectType',
  active?: boolean,
  created?: any,
  updated?: any,
  name: string,
  organizationId: string,
  office: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType,
  xcTheme: ContentLandingPageProjectFragment_ContentLandingPageProjectType_xcTheme_XCThemeType | null
};

export type ContentLandingPageFragment_ContentLandingPageType_ctaBar_CtaBarType = {
  __typename: 'CtaBarType',
  description: string | null,
  cta: CtaBarFragment_CtaBarType_cta
};

export type ContentLandingPageFragment = {
  __typename: 'ContentLandingPageType',
  active?: boolean,
  created?: any,
  updated?: any,
  document: ContentLandingPageFragment_ContentLandingPageType_document_DocumentType,
  project: ContentLandingPageFragment_ContentLandingPageType_project_ContentLandingPageProjectType,
  ctaBar: ContentLandingPageFragment_ContentLandingPageType_ctaBar_CtaBarType | null
};

export type UserAgentFragment = {
  __typename: 'UserAgentType',
  uaString: string,
  os: string,
  browser: string,
  device: string,
  isTablet: boolean,
  isMobile: boolean,
  isTouchCapable: boolean,
  isPc: boolean,
  isEmailClient: boolean,
  isBot: boolean
};

export type UpdateMemberSelfMutation_updateMemberSelf_MemberType = {
  __typename: 'MemberType',
  email: string,
  phone: string | null,
  mobile: string,
  fax: string,
  hasUsablePassword: boolean,
  id: string,
  title: string | null,
  salutation: SalutationEnum,
  firstName: string,
  lastName: string,
  avatarOriginalSrc: string | null,
  avatarSrc: string | null,
  hasSeFeature: boolean,
  hasAutomotiveFeature: boolean,
  hasGroupAnalysisFeature: boolean,
  hasCombinedDashboardFeature: boolean,
  hasCmsFeature: boolean,
  hasThemeEditorFeature: boolean,
  hasPrintManagerFeature: boolean,
  features: Array<MemberFragment_MemberType_features_OfficeFeatureType>
};

export type UpdateMemberSelfMutation_Mutation = {
  __typename: 'Mutation',
  updateMemberSelf: UpdateMemberSelfMutation_updateMemberSelf_MemberType
};


export type UpdateMemberSelfMutationVariables = Exact<{
  memberInput: UpdateMemberSelfInput;
}>;


export type UpdateMemberSelfMutation = UpdateMemberSelfMutation_Mutation;

export type SetPasswordMutation_setPassword_ErrorType = {
  __typename: 'ErrorType',
  message: string,
  code: ErrorCodeEnum,
  rawCode: number
};

export type SetPasswordMutation_setPassword_SuccessType = {
  __typename: 'SuccessType',
  message: string,
  objId: string | null
};

export type SetPasswordMutation_setPassword = SetPasswordMutation_setPassword_ErrorType | SetPasswordMutation_setPassword_SuccessType;

export type SetPasswordMutation_Mutation = {
  __typename: 'Mutation',
  setPassword: SetPasswordMutation_setPassword
};


export type SetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetPasswordMutation = SetPasswordMutation_Mutation;

export type SendPasswordResetEmailMutation_Mutation = {
  __typename: 'Mutation',
  sendPasswordResetEmail: boolean
};


export type SendPasswordResetEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type SendPasswordResetEmailMutation = SendPasswordResetEmailMutation_Mutation;

export type PublishDocumentMutation_publishDocument_DocumentType = {
  __typename: 'DocumentType',
  editVersionId: string,
  id: string,
  identifier: any,
  displayName: string,
  brandId: string | null,
  disclaimers: Array<string>,
  pages: Array<XcNwDataFragment_DocumentType_pages_EufePageType>,
  xcMediaLibrary?: Array<XcNwDataFragment_DocumentType_xcMediaLibrary_XCMediaRefType>,
  inlineDisclaimers: Array<XcNwDataFragment_DocumentType_inlineDisclaimers>,
  externalLinkDisclaimerConfig: XcNwDataFragment_DocumentType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcNwDataFragment_DocumentType_xcTheme_XCThemeType | null
};

export type PublishDocumentMutation_Mutation = {
  __typename: 'Mutation',
  publishDocument: PublishDocumentMutation_publishDocument_DocumentType
};


export type PublishDocumentMutationVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PublishDocumentMutation = PublishDocumentMutation_Mutation;

export type DeletePageMutation_Mutation = {
  __typename: 'Mutation',
  deletePage: string
};


export type DeletePageMutationVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
}>;


export type DeletePageMutation = DeletePageMutation_Mutation;

export type CreateOrUpdatePageMutation_createOrUpdatePage_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type CreateOrUpdatePageMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdatePage: CreateOrUpdatePageMutation_createOrUpdatePage_EufePageType
};


export type CreateOrUpdatePageMutationVariables = Exact<{
  data: PageInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdatePageMutation = CreateOrUpdatePageMutation_Mutation;

export type MoveBlockMutation_moveBlock_PanelType = {
  __typename: 'PanelType',
  id: string,
  blocks: Array<PanelFragment_PanelType_blocks>
};

export type MoveBlockMutation_Mutation = {
  __typename: 'Mutation',
  moveBlock: Array<MoveBlockMutation_moveBlock_PanelType>
};


export type MoveBlockMutationVariables = Exact<{
  meta: BlockMetaInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MoveBlockMutation = MoveBlockMutation_Mutation;

export type DeleteBlockMutation_Mutation = {
  __typename: 'Mutation',
  deleteBlock: string
};


export type DeleteBlockMutationVariables = Exact<{
  blockId: Scalars['ID']['input'];
  documentVersionId: Scalars['ID']['input'];
}>;


export type DeleteBlockMutation = DeleteBlockMutation_Mutation;

export type CreateOrUpdateBlockDividerMutation_createOrUpdateBlock_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type CreateOrUpdateBlockDividerMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockDividerMutation_createOrUpdateBlock_BlockDividerType
};


export type CreateOrUpdateBlockDividerMutationVariables = Exact<{
  meta: BlockMetaInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockDividerMutation = CreateOrUpdateBlockDividerMutation_Mutation;

export type CreateOrUpdateBlockChapterOpenerMutation_createOrUpdateBlock_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  count: number | null,
  chapterOpenerMedia: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType | null,
  chapterOpenerMediaMobile: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType | null
};

export type CreateOrUpdateBlockChapterOpenerMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockChapterOpenerMutation_createOrUpdateBlock_BlockChapterOpenerType
};


export type CreateOrUpdateBlockChapterOpenerMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockChapterOpenerInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockChapterOpenerMutation = CreateOrUpdateBlockChapterOpenerMutation_Mutation;

export type CreateOrUpdateBlockRichTextMutation_createOrUpdateBlock_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  text: string
};

export type CreateOrUpdateBlockRichTextMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockRichTextMutation_createOrUpdateBlock_BlockRichTextType
};


export type CreateOrUpdateBlockRichTextMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockRichTextInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockRichTextMutation = CreateOrUpdateBlockRichTextMutation_Mutation;

export type CreateOrUpdateBlockVideoMutation_createOrUpdateBlock_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  duration: number | null,
  autoplay: boolean,
  provider: VideoProviderEnum,
  thumbnail: BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType | null
};

export type CreateOrUpdateBlockVideoMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockVideoMutation_createOrUpdateBlock_BlockVideoType
};


export type CreateOrUpdateBlockVideoMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockVideoInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockVideoMutation = CreateOrUpdateBlockVideoMutation_Mutation;

export type CreateOrUpdateBlockVideoWithDescriptionMutation_createOrUpdateBlock_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  publishingDate: any | null,
  optionalTitle: string | null,
  duration: number | null,
  provider: VideoProviderEnum,
  videoDescription: string | null,
  thumbnail: BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType | null
};

export type CreateOrUpdateBlockVideoWithDescriptionMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockVideoWithDescriptionMutation_createOrUpdateBlock_BlockVideoWithDescriptionType
};


export type CreateOrUpdateBlockVideoWithDescriptionMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockVideoWithDescriptionInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockVideoWithDescriptionMutation = CreateOrUpdateBlockVideoWithDescriptionMutation_Mutation;

export type CreateOrUpdateBlockMediaSingleImageMutation_createOrUpdateBlock_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image: XcNwBlockFragment_BlockMediaSingleImageType_image_XCMediaRefType,
  imageMobile: XcNwBlockFragment_BlockMediaSingleImageType_imageMobile_XCMediaRefType | null
};

export type CreateOrUpdateBlockMediaSingleImageMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockMediaSingleImageMutation_createOrUpdateBlock_BlockMediaSingleImageType
};


export type CreateOrUpdateBlockMediaSingleImageMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockMediaSingleImageInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockMediaSingleImageMutation = CreateOrUpdateBlockMediaSingleImageMutation_Mutation;

export type CreateOrUpdateBlockMediaComparisonSliderMutation_createOrUpdateBlock_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image1: XcNwBlockFragment_BlockMediaComparisonSliderType_image1_XCMediaRefType,
  image2: XcNwBlockFragment_BlockMediaComparisonSliderType_image2_XCMediaRefType
};

export type CreateOrUpdateBlockMediaComparisonSliderMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockMediaComparisonSliderMutation_createOrUpdateBlock_BlockMediaComparisonSliderType
};


export type CreateOrUpdateBlockMediaComparisonSliderMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockMediaComparisonSliderInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockMediaComparisonSliderMutation = CreateOrUpdateBlockMediaComparisonSliderMutation_Mutation;

export type CreateOrUpdateBlockMediaGalleryMutation_createOrUpdateBlock_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  mediaGalleryVisualization: BlockMediaGalleryVisualizationEnum,
  mediaGalleryItems: Array<BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType>
};

export type CreateOrUpdateBlockMediaGalleryMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockMediaGalleryMutation_createOrUpdateBlock_BlockMediaGalleryType
};


export type CreateOrUpdateBlockMediaGalleryMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockMediaGalleryInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockMediaGalleryMutation = CreateOrUpdateBlockMediaGalleryMutation_Mutation;

export type CreateOrUpdateBlockAwardRowMutation_createOrUpdateBlock_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_AwardTypeBlockRowType_items_AwardType>
};

export type CreateOrUpdateBlockAwardRowMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockAwardRowMutation_createOrUpdateBlock_AwardTypeBlockRowType
};


export type CreateOrUpdateBlockAwardRowMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: Array<BlockAwardInput> | BlockAwardInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockAwardRowMutation = CreateOrUpdateBlockAwardRowMutation_Mutation;

export type CreateOrUpdateBlockAppDownloadMutation_createOrUpdateBlock_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  iosHref: string,
  androidHref: string,
  iosLabel: string,
  androidLabel: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type CreateOrUpdateBlockAppDownloadMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockAppDownloadMutation_createOrUpdateBlock_BlockAppDownloadType
};


export type CreateOrUpdateBlockAppDownloadMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockAppDownloadInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockAppDownloadMutation = CreateOrUpdateBlockAppDownloadMutation_Mutation;

export type CreateOrUpdateBlockHighlightMutation_createOrUpdateBlock_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  highlightTitle: string,
  highlightDescription: string,
  highlightVisualization: BlockHighlightVisualizationEnum,
  cta: XcNwBlockFragment_BlockHighlightType_cta | null,
  media: XcNwBlockFragment_BlockHighlightType_media_XCMediaRefType,
  mediaMobile: XcNwBlockFragment_BlockHighlightType_mediaMobile_XCMediaRefType | null
};

export type CreateOrUpdateBlockHighlightMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockHighlightMutation_createOrUpdateBlock_BlockHighlightType
};


export type CreateOrUpdateBlockHighlightMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockHighlightInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockHighlightMutation = CreateOrUpdateBlockHighlightMutation_Mutation;

export type CreateOrUpdateBlockBannerMutation_createOrUpdateBlock_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  bannerTitle: string | null,
  cta: BlockBannerFragment_BlockBannerType_cta | null,
  bannerBackground: BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType | null
};

export type CreateOrUpdateBlockBannerMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockBannerMutation_createOrUpdateBlock_BlockBannerType
};


export type CreateOrUpdateBlockBannerMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockBannerInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockBannerMutation = CreateOrUpdateBlockBannerMutation_Mutation;

export type CreateOrUpdateBlockKeyFactMutation_createOrUpdateBlock_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  aspectRatio: AspectRatioEnum | null,
  keyFactVisualization: BlockKeyFactVisualizationEnum,
  items: Array<KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType>
};

export type CreateOrUpdateBlockKeyFactMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockKeyFactMutation_createOrUpdateBlock_KeyFactTypeBlockRowType
};


export type CreateOrUpdateBlockKeyFactMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockKeyFactInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockKeyFactMutation = CreateOrUpdateBlockKeyFactMutation_Mutation;

export type CreateOrUpdateBlockKeyFactSmallMutation_createOrUpdateBlock_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KeyFactSmallBlockRowType_items_KeyFactSmallType>
};

export type CreateOrUpdateBlockKeyFactSmallMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockKeyFactSmallMutation_createOrUpdateBlock_KeyFactSmallBlockRowType
};


export type CreateOrUpdateBlockKeyFactSmallMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: Array<BlockKeyFactSmallInput> | BlockKeyFactSmallInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockKeyFactSmallMutation = CreateOrUpdateBlockKeyFactSmallMutation_Mutation;

export type CreateOrUpdateBlockKpiMutation_createOrUpdateBlock_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KpiTypeBlockRowType_items>
};

export type CreateOrUpdateBlockKpiMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockKpiMutation_createOrUpdateBlock_KpiTypeBlockRowType
};


export type CreateOrUpdateBlockKpiMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: Array<BlockKpiInput> | BlockKpiInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockKpiMutation = CreateOrUpdateBlockKpiMutation_Mutation;

export type CreateOrUpdateBlockVehicleDataMutation_createOrUpdateBlock_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_VehicleDataTableSectionTypeBlockRowType_items_VehicleDataTableSectionType>
};

export type CreateOrUpdateBlockVehicleDataMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockVehicleDataMutation_createOrUpdateBlock_VehicleDataTableSectionTypeBlockRowType
};


export type CreateOrUpdateBlockVehicleDataMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: Array<BlockVehicleDataInput> | BlockVehicleDataInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockVehicleDataMutation = CreateOrUpdateBlockVehicleDataMutation_Mutation;

export type CreateOrUpdateBlockButtonRowMutation_createOrUpdateBlock_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ButtonTypeBlockRowType_items>
};

export type CreateOrUpdateBlockButtonRowMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockButtonRowMutation_createOrUpdateBlock_ButtonTypeBlockRowType
};


export type CreateOrUpdateBlockButtonRowMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: Array<BlockButtonInput> | BlockButtonInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockButtonRowMutation = CreateOrUpdateBlockButtonRowMutation_Mutation;

export type CreateOrUpdateBlockExternalLinkMutation_createOrUpdateBlock_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  externalLinkUrl: string,
  media: BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType
};

export type CreateOrUpdateBlockExternalLinkMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockExternalLinkMutation_createOrUpdateBlock_BlockExternalLinkType
};


export type CreateOrUpdateBlockExternalLinkMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockExternalLinkInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockExternalLinkMutation = CreateOrUpdateBlockExternalLinkMutation_Mutation;

export type CreateOrUpdateBlockAccordionMutation_createOrUpdateBlock_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  sections: Array<XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType>
};

export type CreateOrUpdateBlockAccordionMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockAccordionMutation_createOrUpdateBlock_BlockAccordionType
};


export type CreateOrUpdateBlockAccordionMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: Array<BlockAccordionSectionInput> | BlockAccordionSectionInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockAccordionMutation = CreateOrUpdateBlockAccordionMutation_Mutation;

export type CreateOrUpdateBlockKeyValueTableMutation_createOrUpdateBlock_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  alignValue: AlignEnum,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_BlockKeyValueTableType_items_KeyValueType>
};

export type CreateOrUpdateBlockKeyValueTableMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockKeyValueTableMutation_createOrUpdateBlock_BlockKeyValueTableType
};


export type CreateOrUpdateBlockKeyValueTableMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockKeyValueTableInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockKeyValueTableMutation = CreateOrUpdateBlockKeyValueTableMutation_Mutation;

export type CreateOrUpdateBlockDataSheetMutation_createOrUpdateBlock_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  rawItems: Array<any>,
  sections: Array<BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType>,
  config: BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType,
  items: Array<BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType>
};

export type CreateOrUpdateBlockDataSheetMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockDataSheetMutation_createOrUpdateBlock_BlockDataSheetType
};


export type CreateOrUpdateBlockDataSheetMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockDataSheetInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockDataSheetMutation = CreateOrUpdateBlockDataSheetMutation_Mutation;

export type SetBlockLockMutation_setBlockLock_LockStatusType = {
  __typename: 'LockStatusType',
  action: BlockStatusActionEnum,
  currentEditor: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType_currentEditor_MemberType
};

export type SetBlockLockMutation_Mutation = {
  __typename: 'Mutation',
  setBlockLock: SetBlockLockMutation_setBlockLock_LockStatusType | null
};


export type SetBlockLockMutationVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  blockId: Scalars['ID']['input'];
  lockStatus?: InputMaybe<LockStatusInput>;
}>;


export type SetBlockLockMutation = SetBlockLockMutation_Mutation;

export type SetPageLockMutation_setPageLock_LockStatusType = {
  __typename: 'LockStatusType',
  action: BlockStatusActionEnum,
  currentEditor: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType_currentEditor_MemberType
};

export type SetPageLockMutation_Mutation = {
  __typename: 'Mutation',
  setPageLock: SetPageLockMutation_setPageLock_LockStatusType | null
};


export type SetPageLockMutationVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  pageId: Scalars['ID']['input'];
  lockStatus?: InputMaybe<LockStatusInput>;
}>;


export type SetPageLockMutation = SetPageLockMutation_Mutation;

export type DeleteThemeMutation_Mutation = {
  __typename: 'Mutation',
  deleteTheme: boolean
};


export type DeleteThemeMutationVariables = Exact<{
  themeId: Scalars['ID']['input'];
}>;


export type DeleteThemeMutation = DeleteThemeMutation_Mutation;

export type CreateOrUpdateThemeMutation_createOrUpdateTheme_XCThemeType = {
  __typename: 'XCThemeType',
  id: string,
  cssVariablesStr: string,
  cssVariables: any,
  cssHeader: string,
  faviconUrl: string | null,
  header: ThemeHeaderEnum,
  name?: string | null,
  headerFont?: XcThemeFragment_XCThemeType_headerFont_KeyValueType | null,
  bodyFont?: XcThemeFragment_XCThemeType_bodyFont_KeyValueType | null,
  favicon: XcThemeFragment_XCThemeType_favicon_XCMediaRefType | null,
  logo: XcThemeFragment_XCThemeType_logo_XCMediaRefType | null
};

export type CreateOrUpdateThemeMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateTheme: CreateOrUpdateThemeMutation_createOrUpdateTheme_XCThemeType
};


export type CreateOrUpdateThemeMutationVariables = Exact<{
  themeId?: InputMaybe<Scalars['ID']['input']>;
  data: ThemeInput;
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateThemeMutation = CreateOrUpdateThemeMutation_Mutation;

export type FileToJsonMutation_Mutation = {
  __typename: 'Mutation',
  fileToJson: any
};


export type FileToJsonMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type FileToJsonMutation = FileToJsonMutation_Mutation;

export type CreateDocumentXcMediaLibraryEntryMutation_createDocumentXcMediaLibraryEntry_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type CreateDocumentXcMediaLibraryEntryMutation_Mutation = {
  __typename: 'Mutation',
  createDocumentXcMediaLibraryEntry: CreateDocumentXcMediaLibraryEntryMutation_createDocumentXcMediaLibraryEntry_XCMediaRefType
};


export type CreateDocumentXcMediaLibraryEntryMutationVariables = Exact<{
  collectionId: Scalars['ID']['input'];
  documentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type CreateDocumentXcMediaLibraryEntryMutation = CreateDocumentXcMediaLibraryEntryMutation_Mutation;

export type CreateOrUpdateDocumentMutation_createOrUpdateDocument_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  name: string,
  editVersionId: string,
  keyVisualUrl: string
};

export type CreateOrUpdateDocumentMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateDocument: CreateOrUpdateDocumentMutation_createOrUpdateDocument_DocumentType
};


export type CreateOrUpdateDocumentMutationVariables = Exact<{
  data: CreateUpdateDocumentInput;
}>;


export type CreateOrUpdateDocumentMutation = CreateOrUpdateDocumentMutation_Mutation;

export type CreateOrUpdateBlockIntegrationMutation_createOrUpdateBlock_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  integrationType: OfficeIntegrationEnum,
  defaultValue: string | null
};

export type CreateOrUpdateBlockIntegrationMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockIntegrationMutation_createOrUpdateBlock_BlockIntegrationType
};


export type CreateOrUpdateBlockIntegrationMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockIntegrationInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockIntegrationMutation = CreateOrUpdateBlockIntegrationMutation_Mutation;

export type CreateOrUpdateBlockDocumentHeaderMutation_createOrUpdateBlock_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  callout: string | null
};

export type CreateOrUpdateBlockDocumentHeaderMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockDocumentHeaderMutation_createOrUpdateBlock_BlockDocumentHeaderType
};


export type CreateOrUpdateBlockDocumentHeaderMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockDocumentHeaderInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockDocumentHeaderMutation = CreateOrUpdateBlockDocumentHeaderMutation_Mutation;

export type CreateOrUpdateBlockAutoplayMutation_createOrUpdateBlock_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  media: BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType
};

export type CreateOrUpdateBlockAutoplayMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateBlock: CreateOrUpdateBlockAutoplayMutation_createOrUpdateBlock_BlockAutoplayType
};


export type CreateOrUpdateBlockAutoplayMutationVariables = Exact<{
  meta: BlockMetaInput;
  data: BlockAutoplayInput;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateBlockAutoplayMutation = CreateOrUpdateBlockAutoplayMutation_Mutation;

export type DeleteXcDisclaimerMutation_Mutation = {
  __typename: 'Mutation',
  deleteXcDisclaimer: string
};


export type DeleteXcDisclaimerMutationVariables = Exact<{
  disclaimerId: Scalars['ID']['input'];
}>;


export type DeleteXcDisclaimerMutation = DeleteXcDisclaimerMutation_Mutation;

export type CreateOrUpdateXcDisclaimerMutation_createOrUpdateXcDisclaimer_XCDocDisclaimerType = {
  __typename: 'XCDocDisclaimerType',
  id: string,
  key: string,
  variant: DisclaimerVariantEnum,
  docTextContent: string
};

export type CreateOrUpdateXcDisclaimerMutation_createOrUpdateXcDisclaimer_XCInfoFootnoteType = {
  __typename: 'XCInfoFootnoteType',
  textClick: string,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type CreateOrUpdateXcDisclaimerMutation_createOrUpdateXcDisclaimer_XCRectangleFootnoteType = {
  __typename: 'XCRectangleFootnoteType',
  textHover: string | null,
  textContent: string | null,
  colorBackground: string | null,
  colorFont: string | null,
  colorBorder: string | null,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type CreateOrUpdateXcDisclaimerMutation_createOrUpdateXcDisclaimer = CreateOrUpdateXcDisclaimerMutation_createOrUpdateXcDisclaimer_XCDocDisclaimerType | CreateOrUpdateXcDisclaimerMutation_createOrUpdateXcDisclaimer_XCInfoFootnoteType | CreateOrUpdateXcDisclaimerMutation_createOrUpdateXcDisclaimer_XCRectangleFootnoteType;

export type CreateOrUpdateXcDisclaimerMutation_Mutation = {
  __typename: 'Mutation',
  createOrUpdateXcDisclaimer: Array<CreateOrUpdateXcDisclaimerMutation_createOrUpdateXcDisclaimer>
};


export type CreateOrUpdateXcDisclaimerMutationVariables = Exact<{
  data: DisclaimerInput;
}>;


export type CreateOrUpdateXcDisclaimerMutation = CreateOrUpdateXcDisclaimerMutation_Mutation;

export type ExposeCtaCallbackMutation_Mutation = {
  __typename: 'Mutation',
  exposeCtaCallback: boolean
};


export type ExposeCtaCallbackMutationVariables = Exact<{
  exposeFolderSlug: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
  data: CtaCallbackDataInput;
}>;


export type ExposeCtaCallbackMutation = ExposeCtaCallbackMutation_Mutation;

export type ExposeCtaResellCallbackMutation_Mutation = {
  __typename: 'Mutation',
  exposeCtaResellCallback: boolean
};


export type ExposeCtaResellCallbackMutationVariables = Exact<{
  exposeFolderSlug: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
  data: CtaResellDataInput;
}>;


export type ExposeCtaResellCallbackMutation = ExposeCtaResellCallbackMutation_Mutation;

export type RequestContactPersonCtaMutation_eufeRequestContactPersonCta_ErrorType = {
  __typename: 'ErrorType',
  message: string,
  code: ErrorCodeEnum,
  rawCode: number
};

export type RequestContactPersonCtaMutation_eufeRequestContactPersonCta_SuccessType = {
  __typename: 'SuccessType',
  message: string,
  objId: string | null
};

export type RequestContactPersonCtaMutation_eufeRequestContactPersonCta = RequestContactPersonCtaMutation_eufeRequestContactPersonCta_ErrorType | RequestContactPersonCtaMutation_eufeRequestContactPersonCta_SuccessType;

export type RequestContactPersonCtaMutation_Mutation = {
  __typename: 'Mutation',
  eufeRequestContactPersonCta: RequestContactPersonCtaMutation_eufeRequestContactPersonCta
};


export type RequestContactPersonCtaMutationVariables = Exact<{
  inp: EufeRequestContactPersonCtaInput;
  exposeFolderRecordId: Scalars['ID']['input'];
}>;


export type RequestContactPersonCtaMutation = RequestContactPersonCtaMutation_Mutation;

export type UserAgentQuery_userAgent_UserAgentType = {
  __typename: 'UserAgentType',
  uaString: string,
  os: string,
  browser: string,
  device: string,
  isTablet: boolean,
  isMobile: boolean,
  isTouchCapable: boolean,
  isPc: boolean,
  isEmailClient: boolean,
  isBot: boolean
};

export type UserAgentQuery_Query = {
  __typename: 'Query',
  userAgent: UserAgentQuery_userAgent_UserAgentType
};


export type UserAgentQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAgentQuery = UserAgentQuery_Query;

export type CurrentOfficeQuery_currentOffice_OfficeType = {
  __typename: 'OfficeType',
  id: string,
  street: string,
  zipcode: string,
  addressLine2: string,
  addressLine1: string,
  city: string,
  thumbnailUrl: string | null,
  imprintUrl: string | null,
  logoLabel: string | null,
  googleMapsUrl: string | null,
  stockUrl: string | null,
  seOfficeVideo: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_seOfficeVideo_ThirdPartyVideoType | null,
  privacyStatement: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_privacyStatement_LegalTextType,
  cookieContext: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_cookieContext_CookieContextType,
  xcTheme: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_xcTheme_XCThemeType | null,
  logo: ContentLandingPageProjectFragment_ContentLandingPageProjectType_office_OfficeType_logo_XCMediaRefType | null
};

export type CurrentOfficeQuery_Query = {
  __typename: 'Query',
  currentOffice: CurrentOfficeQuery_currentOffice_OfficeType | null
};


export type CurrentOfficeQueryVariables = Exact<{
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CurrentOfficeQuery = CurrentOfficeQuery_Query;

export type CurrentContactPersonQuery_currentContactPerson_MemberType = {
  __typename: 'MemberType',
  id: string,
  fullName: string,
  firstName: string,
  email: string,
  salutation: SalutationEnum,
  displayEmail: string | null,
  lastName: string,
  mobile: string,
  phone: string | null,
  fax: string,
  thumbnail: string | null,
  title: string | null,
  vcard: string,
  isCampaignUser: boolean,
  video: ContactPersonFragment_MemberType_video_ThirdPartyVideoType | null
};

export type CurrentContactPersonQuery_Query = {
  __typename: 'Query',
  currentContactPerson: CurrentContactPersonQuery_currentContactPerson_MemberType | null
};


export type CurrentContactPersonQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentContactPersonQuery = CurrentContactPersonQuery_Query;

export type CurrentOrgIdQuery_Query = {
  __typename: 'Query',
  currentOrgId: string | null
};


export type CurrentOrgIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentOrgIdQuery = CurrentOrgIdQuery_Query;

export type IsLoggedInQuery_Query = {
  __typename: 'Query',
  isLoggedIn: boolean
};


export type IsLoggedInQueryVariables = Exact<{ [key: string]: never; }>;


export type IsLoggedInQuery = IsLoggedInQuery_Query;

export type MemberDataQuery_memberSelf_MemberType = {
  __typename: 'MemberType',
  id: string,
  title: string | null,
  salutation: SalutationEnum,
  firstName: string,
  lastName: string,
  avatarSrc: string | null,
  hasSeFeature: boolean,
  hasAutomotiveFeature: boolean,
  hasGroupAnalysisFeature: boolean,
  hasCombinedDashboardFeature: boolean,
  hasCmsFeature: boolean,
  hasThemeEditorFeature: boolean,
  hasPrintManagerFeature: boolean,
  features: Array<MemberFragment_MemberType_features_OfficeFeatureType>
};

export type MemberDataQuery_Query = {
  __typename: 'Query',
  memberSelf: MemberDataQuery_memberSelf_MemberType
};


export type MemberDataQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberDataQuery = MemberDataQuery_Query;

export type MemberProfileDataQuery_memberSelf_MemberType = {
  __typename: 'MemberType',
  email: string,
  phone: string | null,
  mobile: string,
  fax: string,
  hasUsablePassword: boolean,
  id: string,
  title: string | null,
  salutation: SalutationEnum,
  firstName: string,
  lastName: string,
  avatarOriginalSrc: string | null,
  avatarSrc: string | null,
  hasSeFeature: boolean,
  hasAutomotiveFeature: boolean,
  hasGroupAnalysisFeature: boolean,
  hasCombinedDashboardFeature: boolean,
  hasCmsFeature: boolean,
  hasThemeEditorFeature: boolean,
  hasPrintManagerFeature: boolean,
  features: Array<MemberFragment_MemberType_features_OfficeFeatureType>
};

export type MemberProfileDataQuery_Query = {
  __typename: 'Query',
  memberSelf: MemberProfileDataQuery_memberSelf_MemberType
};


export type MemberProfileDataQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberProfileDataQuery = MemberProfileDataQuery_Query;

export type MemberMagicLinkQuery_memberSelf_MemberType = {
  __typename: 'MemberType',
  id: string,
  permanentLoginMagicLink: string | null
};

export type MemberMagicLinkQuery_Query = {
  __typename: 'Query',
  memberSelf: MemberMagicLinkQuery_memberSelf_MemberType
};


export type MemberMagicLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberMagicLinkQuery = MemberMagicLinkQuery_Query;

export type CampaignsQuery_xcCampaigns_XCCampaignType = {
  __typename: 'XCCampaignType',
  id: string,
  displayName: string
};

export type CampaignsQuery_Query = {
  __typename: 'Query',
  xcCampaigns: Array<CampaignsQuery_xcCampaigns_XCCampaignType>
};


export type CampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignsQuery = CampaignsQuery_Query;

export type CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_topDocumentScans_XCCampaignTopVehicleType_car_MobRecordType = {
  __typename: 'MobRecordType',
  id: string,
  identifier: any,
  fullName: string,
  disclaimers: Array<string>,
  internalName: string | null,
  price: number | null,
  kilometers: number | null,
  mediaRef: CarFragment_MobRecordType_mediaRef_XCMediaRefType | null
};

export type CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_topDocumentScans_XCCampaignTopVehicleType = {
  __typename: 'XCCampaignTopVehicleType',
  count: number,
  car: CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_topDocumentScans_XCCampaignTopVehicleType_car_MobRecordType
};

export type CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_weeklyBucketScans_XCCampaignLVAnalyticType = {
  __typename: 'XCCampaignLVAnalyticType',
  label: string,
  value: number
};

export type CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_hourlyBucketScans_XCCampaignLVAnalyticType = {
  __typename: 'XCCampaignLVAnalyticType',
  label: string,
  value: number
};

export type CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_dailyStats_XCCampaignAnalyticBucketType = {
  __typename: 'XCCampaignAnalyticBucketType',
  createdAt: any,
  scans: number,
  claims: number,
  visits: number
};

export type CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_totalStats_XCCampaignAnalyticBucketType = {
  __typename: 'XCCampaignAnalyticBucketType',
  createdAt: any,
  scans: number,
  claims: number,
  visits: number
};

export type CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType = {
  __typename: 'XCCampaignStatsType',
  avgDocumentScansPerFolder: number,
  topDocumentScans: Array<CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_topDocumentScans_XCCampaignTopVehicleType>,
  weeklyBucketScans: Array<CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_weeklyBucketScans_XCCampaignLVAnalyticType>,
  hourlyBucketScans: Array<CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_hourlyBucketScans_XCCampaignLVAnalyticType>,
  dailyStats: Array<CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_dailyStats_XCCampaignAnalyticBucketType>,
  totalStats: CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType_totalStats_XCCampaignAnalyticBucketType
};

export type CampaignAnalyticsQuery_Query = {
  __typename: 'Query',
  xcCampaignAnalytics: CampaignAnalyticsQuery_xcCampaignAnalytics_XCCampaignStatsType
};


export type CampaignAnalyticsQueryVariables = Exact<{
  analyticsFilter?: InputMaybe<XcCampaignAnalyticsFilterInput>;
}>;


export type CampaignAnalyticsQuery = CampaignAnalyticsQuery_Query;

export type SingleCarQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType_car_MobRecordType = {
  __typename: 'MobRecordType',
  id: string,
  identifier: any,
  fullName: string,
  disclaimers: Array<string>,
  internalName: string | null,
  price: number | null,
  kilometers: number | null,
  mediaRef: CarFragment_MobRecordType_mediaRef_XCMediaRefType | null
};

export type SingleCarQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType = {
  __typename: 'XCollectionSeType',
  id: string,
  car: SingleCarQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType_car_MobRecordType
};

export type SingleCarQuery_memberSelf_MemberType_feature_OfficeFeatureType = {
  __typename: 'OfficeFeatureType',
  id: string,
  collectionSe: SingleCarQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType
};

export type SingleCarQuery_memberSelf_MemberType = {
  __typename: 'MemberType',
  id: string,
  feature: SingleCarQuery_memberSelf_MemberType_feature_OfficeFeatureType
};

export type SingleCarQuery_Query = {
  __typename: 'Query',
  memberSelf: SingleCarQuery_memberSelf_MemberType
};


export type SingleCarQueryVariables = Exact<{
  carId: Scalars['ID']['input'];
  featureId: Scalars['ID']['input'];
}>;


export type SingleCarQuery = SingleCarQuery_Query;

export type StockQuery_seMobField0Mapping_MobField0MappingType = {
  __typename: 'MobField0MappingType',
  id: string,
  label: string,
  value: string
};

export type StockQuery_Query = {
  __typename: 'Query',
  seMobField0Mapping: Array<StockQuery_seMobField0Mapping_MobField0MappingType>
};


export type StockQueryVariables = Exact<{
  featureId: Scalars['ID']['input'];
}>;


export type StockQuery = StockQuery_Query;

export type CarFilterValuesQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType_filterStats_MobRecordStatsType = {
  __typename: 'MobRecordStatsType',
  kmMin: number,
  kmMax: number,
  priceMin: number,
  priceMax: number
};

export type CarFilterValuesQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType = {
  __typename: 'XCollectionSeType',
  id: string,
  filterSpec: any,
  filterStats: CarFilterValuesQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType_filterStats_MobRecordStatsType
};

export type CarFilterValuesQuery_memberSelf_MemberType_feature_OfficeFeatureType = {
  __typename: 'OfficeFeatureType',
  id: string,
  collectionSe: CarFilterValuesQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType
};

export type CarFilterValuesQuery_memberSelf_MemberType = {
  __typename: 'MemberType',
  id: string,
  feature: CarFilterValuesQuery_memberSelf_MemberType_feature_OfficeFeatureType
};

export type CarFilterValuesQuery_Query = {
  __typename: 'Query',
  memberSelf: CarFilterValuesQuery_memberSelf_MemberType
};


export type CarFilterValuesQueryVariables = Exact<{
  filterStock?: InputMaybe<Scalars['String']['input']>;
  kilometers?: InputMaybe<MinMaxInputIntType>;
  totalPrice?: InputMaybe<MinMaxInputIntType>;
  firstRegistration?: InputMaybe<MinMaxInputIntType>;
  fuelType?: InputMaybe<Scalars['Int']['input']>;
  gearbox?: InputMaybe<Scalars['Int']['input']>;
  carType?: InputMaybe<Scalars['Int']['input']>;
  reducedCarType?: InputMaybe<ReducedCarType>;
  featureId: Scalars['ID']['input'];
}>;


export type CarFilterValuesQuery = CarFilterValuesQuery_Query;

export type CarListIdsQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType = {
  __typename: 'XCollectionSeType',
  id: string,
  carIds: Array<string>
};

export type CarListIdsQuery_memberSelf_MemberType_feature_OfficeFeatureType = {
  __typename: 'OfficeFeatureType',
  id: string,
  collectionSe: CarListIdsQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType
};

export type CarListIdsQuery_memberSelf_MemberType = {
  __typename: 'MemberType',
  id: string,
  feature: CarListIdsQuery_memberSelf_MemberType_feature_OfficeFeatureType
};

export type CarListIdsQuery_Query = {
  __typename: 'Query',
  memberSelf: CarListIdsQuery_memberSelf_MemberType
};


export type CarListIdsQueryVariables = Exact<{
  filterStock?: InputMaybe<Scalars['String']['input']>;
  filterModelComplex?: InputMaybe<ComplexModellFilterInputType>;
  kilometers?: InputMaybe<MinMaxInputIntType>;
  totalPrice?: InputMaybe<MinMaxInputIntType>;
  firstRegistration?: InputMaybe<MinMaxInputIntType>;
  fuelType?: InputMaybe<Scalars['Int']['input']>;
  gearbox?: InputMaybe<Scalars['Int']['input']>;
  carType?: InputMaybe<Scalars['Int']['input']>;
  reducedCarType?: InputMaybe<ReducedCarType>;
  featureId: Scalars['ID']['input'];
}>;


export type CarListIdsQuery = CarListIdsQuery_Query;

export type CarListQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType_cars_MobRecordTypePageInfoType_items_MobRecordType = {
  __typename: 'MobRecordType',
  id: string,
  identifier: any,
  fullName: string,
  disclaimers: Array<string>,
  internalName: string | null,
  price: number | null,
  kilometers: number | null,
  mediaRef: CarFragment_MobRecordType_mediaRef_XCMediaRefType | null
};

export type CarListQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType_cars_MobRecordTypePageInfoType = {
  __typename: 'MobRecordTypePageInfoType',
  total: number,
  items: Array<CarListQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType_cars_MobRecordTypePageInfoType_items_MobRecordType>
};

export type CarListQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType = {
  __typename: 'XCollectionSeType',
  id: string,
  cars: CarListQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType_cars_MobRecordTypePageInfoType
};

export type CarListQuery_memberSelf_MemberType_feature_OfficeFeatureType = {
  __typename: 'OfficeFeatureType',
  id: string,
  collectionSe: CarListQuery_memberSelf_MemberType_feature_OfficeFeatureType_collectionSe_XCollectionSeType
};

export type CarListQuery_memberSelf_MemberType = {
  __typename: 'MemberType',
  id: string,
  feature: CarListQuery_memberSelf_MemberType_feature_OfficeFeatureType
};

export type CarListQuery_Query = {
  __typename: 'Query',
  memberSelf: CarListQuery_memberSelf_MemberType
};


export type CarListQueryVariables = Exact<{
  documentIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  textSearch?: InputMaybe<Scalars['String']['input']>;
  filterStock?: InputMaybe<Scalars['String']['input']>;
  filterModelComplex?: InputMaybe<ComplexModellFilterInputType>;
  kilometers?: InputMaybe<MinMaxInputIntType>;
  totalPrice?: InputMaybe<MinMaxInputIntType>;
  firstRegistration?: InputMaybe<MinMaxInputIntType>;
  fuelType?: InputMaybe<Scalars['Int']['input']>;
  gearbox?: InputMaybe<Scalars['Int']['input']>;
  carType?: InputMaybe<Scalars['Int']['input']>;
  reducedCarType?: InputMaybe<ReducedCarType>;
  featureId: Scalars['ID']['input'];
}>;


export type CarListQuery = CarListQuery_Query;

export type StockListQuery_seMobField0Mapping_MobField0MappingType = {
  __typename: 'MobField0MappingType',
  id: string,
  label: string,
  value: string
};

export type StockListQuery_Query = {
  __typename: 'Query',
  seMobField0Mapping: Array<StockListQuery_seMobField0Mapping_MobField0MappingType>
};


export type StockListQueryVariables = Exact<{
  featureId: Scalars['ID']['input'];
}>;


export type StockListQuery = StockListQuery_Query;

export type EditDocumentQuery_editDocument_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  displayName: string,
  brandId: string | null,
  disclaimers: Array<string>,
  pages: Array<XcNwDataFragment_DocumentType_pages_EufePageType>,
  xcMediaLibrary?: Array<XcNwDataFragment_DocumentType_xcMediaLibrary_XCMediaRefType>,
  inlineDisclaimers: Array<XcNwDataFragment_DocumentType_inlineDisclaimers>,
  externalLinkDisclaimerConfig: XcNwDataFragment_DocumentType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcNwDataFragment_DocumentType_xcTheme_XCThemeType | null
};

export type EditDocumentQuery_Query = {
  __typename: 'Query',
  editDocument: EditDocumentQuery_editDocument_DocumentType
};


export type EditDocumentQueryVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditDocumentQuery = EditDocumentQuery_Query;

export type XcMediaLibraryQuery_editDocument_DocumentType_xcMediaLibrary_XCMediaRefType = {
  __typename: 'XCMediaRefType',
  id: string,
  fileUrl: string,
  thumbnailUrl: string,
  createdAt: any | null,
  size: number | null,
  mimeType: string | null,
  altText: string | null,
  fileHash: string | null,
  isPlaceholder: boolean,
  thumbnailUrl380x380: string,
  thumbnailUrl380w: string,
  originalThumbnailDimensions: XcMediaRefFragment_XCMediaRefType_originalThumbnailDimensions_DimensionsType | null
};

export type XcMediaLibraryQuery_editDocument_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  xcMediaLibrary: Array<XcMediaLibraryQuery_editDocument_DocumentType_xcMediaLibrary_XCMediaRefType>
};

export type XcMediaLibraryQuery_Query = {
  __typename: 'Query',
  editDocument: XcMediaLibraryQuery_editDocument_DocumentType
};


export type XcMediaLibraryQueryVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
}>;


export type XcMediaLibraryQuery = XcMediaLibraryQuery_Query;

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks = LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_AwardTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockAccordionType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockAppDownloadType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockAutoplayType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockBannerType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockChapterOpenerType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockDataSheetType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockDividerType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockDocumentHeaderType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockErrorType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockExternalLinkType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockHighlightType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockInstagramType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockIntegrationType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockJsonType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockKeyValueTableType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockMediaComparisonSliderType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockMediaGalleryType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockMediaSingleImageType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockOfficeVCardType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockPdfPreviewType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockPricingTableType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockQuotesType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockRichTextType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockSeEekType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockSeFeatureImagesType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockSePriceType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockSeQualityDescriptionType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockVideoType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_BlockVideoWithDescriptionType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_ButtonTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_ConsumptionValueTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_KeyFactSmallBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_KeyFactTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_KpiTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType;

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType = {
  __typename: 'PanelType',
  id: string,
  blocks: Array<LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType_blocks>
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  lockStatus: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks = LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_AwardTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockAccordionType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockAppDownloadType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockAutoplayType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockBannerType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockChapterOpenerType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockDataSheetType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockDividerType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockDocumentHeaderType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockErrorType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockExternalLinkType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockHighlightType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockInstagramType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockIntegrationType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockJsonType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockKeyValueTableType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockMediaComparisonSliderType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockMediaGalleryType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockMediaSingleImageType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockOfficeVCardType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockPdfPreviewType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockPricingTableType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockQuotesType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockRichTextType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockSeEekType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockSeFeatureImagesType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockSePriceType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockSeQualityDescriptionType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockVideoType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_BlockVideoWithDescriptionType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_ButtonTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_ConsumptionValueTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_KeyFactSmallBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_KeyFactTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_KpiTypeBlockRowType | LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType;

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType = {
  __typename: 'PanelType',
  id: string,
  blocks: Array<LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType_blocks>
};

export type LockStatusQuery_editDocument_DocumentType_pages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  panels: Array<LockStatusQuery_editDocument_DocumentType_pages_EufePageType_panels_PanelType>,
  nestedPanels: Array<LockStatusQuery_editDocument_DocumentType_pages_EufePageType_nestedPanels_PanelType>,
  lockStatus: EufePageLockStatusFragment_EufePageType_lockStatus_LockStatusType | null
};

export type LockStatusQuery_editDocument_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  pages: Array<LockStatusQuery_editDocument_DocumentType_pages_EufePageType>
};

export type LockStatusQuery_Query = {
  __typename: 'Query',
  editDocument: LockStatusQuery_editDocument_DocumentType
};


export type LockStatusQueryVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LockStatusQuery = LockStatusQuery_Query;

export type ThemeEditorFontsQuery_fonts_KeyValueType = {
  __typename: 'KeyValueType',
  id: string,
  key: string,
  value: string
};

export type ThemeEditorFontsQuery_Query = {
  __typename: 'Query',
  fonts: Array<ThemeEditorFontsQuery_fonts_KeyValueType>
};


export type ThemeEditorFontsQueryVariables = Exact<{ [key: string]: never; }>;


export type ThemeEditorFontsQuery = ThemeEditorFontsQuery_Query;

export type ThemeEditorThemesQuery_memberSelf_MemberType_organization_OrganizationType_xcThemes_XCThemeType = {
  __typename: 'XCThemeType',
  id: string,
  cssVariablesStr: string,
  cssVariables: any,
  cssHeader: string,
  faviconUrl: string | null,
  header: ThemeHeaderEnum,
  name?: string | null,
  headerFont?: XcThemeFragment_XCThemeType_headerFont_KeyValueType | null,
  bodyFont?: XcThemeFragment_XCThemeType_bodyFont_KeyValueType | null,
  favicon: XcThemeFragment_XCThemeType_favicon_XCMediaRefType | null,
  logo: XcThemeFragment_XCThemeType_logo_XCMediaRefType | null
};

export type ThemeEditorThemesQuery_memberSelf_MemberType_organization_OrganizationType = {
  __typename: 'OrganizationType',
  id: string,
  xcThemes: Array<ThemeEditorThemesQuery_memberSelf_MemberType_organization_OrganizationType_xcThemes_XCThemeType>
};

export type ThemeEditorThemesQuery_memberSelf_MemberType = {
  __typename: 'MemberType',
  id: string,
  organization: ThemeEditorThemesQuery_memberSelf_MemberType_organization_OrganizationType
};

export type ThemeEditorThemesQuery_Query = {
  __typename: 'Query',
  memberSelf: ThemeEditorThemesQuery_memberSelf_MemberType
};


export type ThemeEditorThemesQueryVariables = Exact<{
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ThemeEditorThemesQuery = ThemeEditorThemesQuery_Query;

export type CheckMediaMd5Query_Query = {
  __typename: 'Query',
  checkMediaMd5: boolean
};


export type CheckMediaMd5QueryVariables = Exact<{
  md5: Scalars['String']['input'];
}>;


export type CheckMediaMd5Query = CheckMediaMd5Query_Query;

export type CmsCollectionsQuery_xcCmsCollections_XCollectionAutomotiveType = {
  __typename: 'XCollectionAutomotiveType',
  id: string,
  name: string,
  isCms: boolean,
  contentCount: number,
  inlineDisclaimers: Array<CmsCollectionFragment_XCollectionAutomotiveType_inlineDisclaimers>
};

export type CmsCollectionsQuery_Query = {
  __typename: 'Query',
  xcCmsCollections: Array<CmsCollectionsQuery_xcCmsCollections_XCollectionAutomotiveType>
};


export type CmsCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CmsCollectionsQuery = CmsCollectionsQuery_Query;

export type CmsCollectionQuery_xcCmsCollection_XCollectionAutomotiveType_editContent_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  name: string,
  editVersionId: string,
  keyVisualUrl: string
};

export type CmsCollectionQuery_xcCmsCollection_XCollectionAutomotiveType_liveContent_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  name: string,
  editVersionId: string,
  keyVisualUrl: string
};

export type CmsCollectionQuery_xcCmsCollection_XCollectionAutomotiveType = {
  __typename: 'XCollectionAutomotiveType',
  id: string,
  editContent: Array<CmsCollectionQuery_xcCmsCollection_XCollectionAutomotiveType_editContent_DocumentType>,
  liveContent: Array<CmsCollectionQuery_xcCmsCollection_XCollectionAutomotiveType_liveContent_DocumentType>
};

export type CmsCollectionQuery_Query = {
  __typename: 'Query',
  xcCmsCollection: CmsCollectionQuery_xcCmsCollection_XCollectionAutomotiveType
};


export type CmsCollectionQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type CmsCollectionQuery = CmsCollectionQuery_Query;

export type XcDisclaimersQuery_xcDisclaimers_XCDocDisclaimerType = {
  __typename: 'XCDocDisclaimerType',
  id: string,
  key: string,
  variant: DisclaimerVariantEnum,
  docTextContent: string
};

export type XcDisclaimersQuery_xcDisclaimers_XCInfoFootnoteType = {
  __typename: 'XCInfoFootnoteType',
  textClick: string,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type XcDisclaimersQuery_xcDisclaimers_XCRectangleFootnoteType = {
  __typename: 'XCRectangleFootnoteType',
  textHover: string | null,
  textContent: string | null,
  colorBackground: string | null,
  colorFont: string | null,
  colorBorder: string | null,
  id: string,
  key: string,
  variant: DisclaimerVariantEnum
};

export type XcDisclaimersQuery_xcDisclaimers = XcDisclaimersQuery_xcDisclaimers_XCDocDisclaimerType | XcDisclaimersQuery_xcDisclaimers_XCInfoFootnoteType | XcDisclaimersQuery_xcDisclaimers_XCRectangleFootnoteType;

export type XcDisclaimersQuery_Query = {
  __typename: 'Query',
  xcDisclaimers: Array<XcDisclaimersQuery_xcDisclaimers>
};


export type XcDisclaimersQueryVariables = Exact<{
  collectionId: Scalars['ID']['input'];
}>;


export type XcDisclaimersQuery = XcDisclaimersQuery_Query;

export type ExposeFolderQuery_exposeFolder_ErrorType = {
  __typename: 'ErrorType',
  message: string,
  code: ErrorCodeEnum,
  rawCode: number
};

export type ExposeFolderQuery_exposeFolder_ExposeFolderType = {
  __typename: 'ExposeFolderType',
  id: string,
  slug: string,
  salutationType: SalutationTypeEnum,
  salutationText: string | null,
  salutation: string,
  created: any,
  lastEdit: any | null,
  organizationId: string,
  contactPerson: ExposeFolderFragment_ExposeFolderType_contactPerson_MemberType | null,
  office: ExposeFolderFragment_ExposeFolderType_office_OfficeType,
  xcRecords: Array<ExposeFolderFragment_ExposeFolderType_xcRecords>
};

export type ExposeFolderQuery_exposeFolder = ExposeFolderQuery_exposeFolder_ErrorType | ExposeFolderQuery_exposeFolder_ExposeFolderType;

export type ExposeFolderQuery_userAgent_UserAgentType = {
  __typename: 'UserAgentType',
  uaString: string,
  os: string,
  browser: string,
  device: string,
  isTablet: boolean,
  isMobile: boolean,
  isTouchCapable: boolean,
  isPc: boolean,
  isEmailClient: boolean,
  isBot: boolean
};

export type ExposeFolderQuery_Query = {
  __typename: 'Query',
  exposeFolder: ExposeFolderQuery_exposeFolder,
  userAgent: ExposeFolderQuery_userAgent_UserAgentType
};


export type ExposeFolderQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ExposeFolderQuery = ExposeFolderQuery_Query;

export type DocumentQuery_document_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  displayName: string,
  brandId: string | null,
  disclaimers: Array<string>,
  pages: Array<XcNwDataFragment_DocumentType_pages_EufePageType>,
  xcMediaLibrary?: Array<XcNwDataFragment_DocumentType_xcMediaLibrary_XCMediaRefType>,
  inlineDisclaimers: Array<XcNwDataFragment_DocumentType_inlineDisclaimers>,
  externalLinkDisclaimerConfig: XcNwDataFragment_DocumentType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcNwDataFragment_DocumentType_xcTheme_XCThemeType | null
};

export type DocumentQuery_document_ErrorType = {
  __typename: 'ErrorType',
  message: string,
  code: ErrorCodeEnum,
  rawCode: number
};

export type DocumentQuery_document_MobRecordType = {
  __typename: 'MobRecordType',
  id: string,
  identifier: any,
  fullName: string,
  reserviert: boolean | null,
  interneNummer: string | null,
  videoUrl: string | null,
  archived: boolean,
  disclaimers: Array<string>,
  niceName: string,
  keyVisual: ExposeDataFragment_MobRecordType_keyVisual_XCMediaRefType | null,
  mediaRefs: Array<ExposeDataFragment_MobRecordType_mediaRefs_XCMediaRefType>,
  seal: ExposeDataFragment_MobRecordType_seal_SealType | null,
  pages: Array<ExposeDataFragment_MobRecordType_pages_EufePageType>
};

export type DocumentQuery_document = DocumentQuery_document_DocumentType | DocumentQuery_document_ErrorType | DocumentQuery_document_MobRecordType;

export type DocumentQuery_Query = {
  __typename: 'Query',
  document: DocumentQuery_document
};


export type DocumentQueryVariables = Exact<{
  identifier: Scalars['UUID']['input'];
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DocumentQuery = DocumentQuery_Query;

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCCCCupraDataType = {
  __typename: 'XCCCCupraDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCCCCupraDataType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCCCSeatDataType = {
  __typename: 'XCCCSeatDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCCCSeatDataType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCDgaDataAudiType = {
  __typename: 'XCDgaDataAudiType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCDgaDataAudiType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCDgaDataVwType = {
  __typename: 'XCDgaDataVwType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCDgaDataVwType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCDgaDataVwnType = {
  __typename: 'XCDgaDataVwnType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCDgaDataVwnType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCExternalLinkDataType = {
  __typename: 'XCExternalLinkDataType',
  ogTitle: string | null,
  ogType: string | null,
  ogDescription: string | null,
  ogVideo: string | null,
  url: string,
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCGenericCodeDataType = {
  __typename: 'XCGenericCodeDataType',
  genericCode: string,
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null,
  pages: Array<GenericCodeFragment_XCGenericCodeDataType_pages_EufePageType>
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCNwDataType = {
  __typename: 'XCNwDataType',
  selectedPageIds: Array<string> | null,
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  document: XcRecordFragment_XCNwDataType_document_DocumentType,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCPricingTableType = {
  __typename: 'XCPricingTableType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCSeDataType = {
  __typename: 'XCSeDataType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string,
  note: string | null,
  subItemCount: number,
  expose: XcRecordFragment_XCSeDataType_expose_MobRecordType,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCUploadDataAttachmentType = {
  __typename: 'XCUploadDataAttachmentType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCUploadDataAttachmentType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord_XCUploadDataImageGalleryType = {
  __typename: 'XCUploadDataImageGalleryType',
  id: string,
  exposeFolderId: string,
  order: number,
  createdAt: any,
  title: string,
  callout: string | null,
  note: string | null,
  subItemCount: number,
  pages: Array<XcRecordFragment_XCUploadDataImageGalleryType_pages_EufePageType>,
  ctaBar: XcRecordFragment_XCCCCupraDataType_ctaBar_CtaBarType | null,
  xcMediaRef: XcRecordFragment_XCCCCupraDataType_xcMediaRef_XCMediaRefType,
  externalLinkDisclaimerConfig: XcRecordFragment_XCCCCupraDataType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcRecordFragment_XCCCCupraDataType_xcTheme_XCThemeType | null
};

export type ExposeFolderDetailsQuery_exposeFolderRecord = ExposeFolderDetailsQuery_exposeFolderRecord_XCCCCupraDataType | ExposeFolderDetailsQuery_exposeFolderRecord_XCCCSeatDataType | ExposeFolderDetailsQuery_exposeFolderRecord_XCDgaDataAudiType | ExposeFolderDetailsQuery_exposeFolderRecord_XCDgaDataVwType | ExposeFolderDetailsQuery_exposeFolderRecord_XCDgaDataVwnType | ExposeFolderDetailsQuery_exposeFolderRecord_XCExternalLinkDataType | ExposeFolderDetailsQuery_exposeFolderRecord_XCGenericCodeDataType | ExposeFolderDetailsQuery_exposeFolderRecord_XCNwDataType | ExposeFolderDetailsQuery_exposeFolderRecord_XCPricingTableType | ExposeFolderDetailsQuery_exposeFolderRecord_XCSeDataType | ExposeFolderDetailsQuery_exposeFolderRecord_XCUploadDataAttachmentType | ExposeFolderDetailsQuery_exposeFolderRecord_XCUploadDataImageGalleryType;

export type ExposeFolderDetailsQuery_Query = {
  __typename: 'Query',
  exposeFolderRecord: ExposeFolderDetailsQuery_exposeFolderRecord
};


export type ExposeFolderDetailsQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  recordId: Scalars['ID']['input'];
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ExposeFolderDetailsQuery = ExposeFolderDetailsQuery_Query;

export type IntegrationBlocksQuery_integrationBlocks_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_AwardTypeBlockRowType_items_AwardType>
};

export type IntegrationBlocksQuery_integrationBlocks_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  sections: Array<XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType>
};

export type IntegrationBlocksQuery_integrationBlocks_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  iosHref: string,
  androidHref: string,
  iosLabel: string,
  androidLabel: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type IntegrationBlocksQuery_integrationBlocks_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  media: BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType
};

export type IntegrationBlocksQuery_integrationBlocks_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  bannerTitle: string | null,
  cta: BlockBannerFragment_BlockBannerType_cta | null,
  bannerBackground: BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  count: number | null,
  chapterOpenerMedia: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType | null,
  chapterOpenerMediaMobile: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  rawItems: Array<any>,
  sections: Array<BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType>,
  config: BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType,
  items: Array<BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType>
};

export type IntegrationBlocksQuery_integrationBlocks_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type IntegrationBlocksQuery_integrationBlocks_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  callout: string | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  message: string,
  eventId: string | null,
  sentryLink?: string | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  externalLinkUrl: string,
  media: BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType
};

export type IntegrationBlocksQuery_integrationBlocks_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  highlightTitle: string,
  highlightDescription: string,
  highlightVisualization: BlockHighlightVisualizationEnum,
  cta: XcNwBlockFragment_BlockHighlightType_cta | null,
  media: XcNwBlockFragment_BlockHighlightType_media_XCMediaRefType,
  mediaMobile: XcNwBlockFragment_BlockHighlightType_mediaMobile_XCMediaRefType | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  href: string,
  name: string,
  logo: BlockInstagramFragment_BlockInstagramType_logo_XCMediaRefType | null,
  instaItems: Array<BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType>
};

export type IntegrationBlocksQuery_integrationBlocks_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  integrationType: OfficeIntegrationEnum,
  defaultValue: string | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type IntegrationBlocksQuery_integrationBlocks_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  alignValue: AlignEnum,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_BlockKeyValueTableType_items_KeyValueType>
};

export type IntegrationBlocksQuery_integrationBlocks_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image1: XcNwBlockFragment_BlockMediaComparisonSliderType_image1_XCMediaRefType,
  image2: XcNwBlockFragment_BlockMediaComparisonSliderType_image2_XCMediaRefType
};

export type IntegrationBlocksQuery_integrationBlocks_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  mediaGalleryVisualization: BlockMediaGalleryVisualizationEnum,
  mediaGalleryItems: Array<BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType>
};

export type IntegrationBlocksQuery_integrationBlocks_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image: XcNwBlockFragment_BlockMediaSingleImageType_image_XCMediaRefType,
  imageMobile: XcNwBlockFragment_BlockMediaSingleImageType_imageMobile_XCMediaRefType | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  name: string,
  company: string | null,
  city: string | null,
  street: string | null,
  zipCode: string | null,
  streetNumber: string | null,
  geoLongitude: string | null,
  geoLatitude: string | null,
  phone: string | null,
  phoneService: string | null,
  newCarsSalesPhone: string | null,
  usedCarsSalesPhone: string | null,
  email: string | null,
  officeVCardImage: BlockOfficeVCardFragment_BlockOfficeVCardType_officeVCardImage_XCMediaRefType | null,
  openingHoursAccessory: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursAccessory_OpeningHoursType,
  openingHoursGeneral: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursGeneral_OpeningHoursType,
  openingHoursSelling: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursSelling_OpeningHoursType,
  openingHoursService: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursService_OpeningHoursType
};

export type IntegrationBlocksQuery_integrationBlocks_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  title: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  pdfPreviewUrl: string
};

export type IntegrationBlocksQuery_integrationBlocks_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  description: string | null,
  pricingTableTitle: string | null,
  units: Array<BlockPricingTableFragment_BlockPricingTableType_units_KeyValueType>,
  total: BlockPricingTableFragment_BlockPricingTableType_total_KeyValueType
};

export type IntegrationBlocksQuery_integrationBlocks_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  quotes: Array<string>
};

export type IntegrationBlocksQuery_integrationBlocks_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  text: string
};

export type IntegrationBlocksQuery_integrationBlocks_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  co2Class: string | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  images: Array<BlockSeFeatureImagesFragment_BlockSeFeatureImagesType_images_XCMediaRefType>
};

export type IntegrationBlocksQuery_integrationBlocks_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  internalNumber: string | null,
  availability: AvailabilityEnum,
  price: number | null,
  tax: boolean | null,
  loanPageId: string | null,
  loan: string | null,
  leasingPageId: string | null,
  leasing: string | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  logoPosition: SealLogoPositionEnum | null,
  description: string | null,
  logo: BlockSeQualityDescriptionFragment_BlockSeQualityDescriptionType_logo_XCMediaRefType | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  duration: number | null,
  autoplay: boolean,
  provider: VideoProviderEnum,
  thumbnail: BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType | null
};

export type IntegrationBlocksQuery_integrationBlocks_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  publishingDate: any | null,
  optionalTitle: string | null,
  duration: number | null,
  provider: VideoProviderEnum,
  videoDescription: string | null,
  thumbnail: BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType | null
};

export type IntegrationBlocksQuery_integrationBlocks_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ButtonTypeBlockRowType_items>
};

export type IntegrationBlocksQuery_integrationBlocks_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ConsumptionValueTypeBlockRowType_items_ConsumptionValueType>
};

export type IntegrationBlocksQuery_integrationBlocks_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KeyFactSmallBlockRowType_items_KeyFactSmallType>
};

export type IntegrationBlocksQuery_integrationBlocks_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  aspectRatio: AspectRatioEnum | null,
  keyFactVisualization: BlockKeyFactVisualizationEnum,
  items: Array<KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType>
};

export type IntegrationBlocksQuery_integrationBlocks_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KpiTypeBlockRowType_items>
};

export type IntegrationBlocksQuery_integrationBlocks_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_VehicleDataTableSectionTypeBlockRowType_items_VehicleDataTableSectionType>
};

export type IntegrationBlocksQuery_integrationBlocks = IntegrationBlocksQuery_integrationBlocks_AwardTypeBlockRowType | IntegrationBlocksQuery_integrationBlocks_BlockAccordionType | IntegrationBlocksQuery_integrationBlocks_BlockAppDownloadType | IntegrationBlocksQuery_integrationBlocks_BlockAutoplayType | IntegrationBlocksQuery_integrationBlocks_BlockBannerType | IntegrationBlocksQuery_integrationBlocks_BlockChapterOpenerType | IntegrationBlocksQuery_integrationBlocks_BlockDataSheetType | IntegrationBlocksQuery_integrationBlocks_BlockDividerType | IntegrationBlocksQuery_integrationBlocks_BlockDocumentHeaderType | IntegrationBlocksQuery_integrationBlocks_BlockErrorType | IntegrationBlocksQuery_integrationBlocks_BlockExternalLinkType | IntegrationBlocksQuery_integrationBlocks_BlockHighlightType | IntegrationBlocksQuery_integrationBlocks_BlockInstagramType | IntegrationBlocksQuery_integrationBlocks_BlockIntegrationType | IntegrationBlocksQuery_integrationBlocks_BlockJsonType | IntegrationBlocksQuery_integrationBlocks_BlockKeyValueTableType | IntegrationBlocksQuery_integrationBlocks_BlockMediaComparisonSliderType | IntegrationBlocksQuery_integrationBlocks_BlockMediaGalleryType | IntegrationBlocksQuery_integrationBlocks_BlockMediaSingleImageType | IntegrationBlocksQuery_integrationBlocks_BlockOfficeVCardType | IntegrationBlocksQuery_integrationBlocks_BlockPdfPreviewType | IntegrationBlocksQuery_integrationBlocks_BlockPricingTableType | IntegrationBlocksQuery_integrationBlocks_BlockQuotesType | IntegrationBlocksQuery_integrationBlocks_BlockRichTextType | IntegrationBlocksQuery_integrationBlocks_BlockSeEekType | IntegrationBlocksQuery_integrationBlocks_BlockSeFeatureImagesType | IntegrationBlocksQuery_integrationBlocks_BlockSePriceType | IntegrationBlocksQuery_integrationBlocks_BlockSeQualityDescriptionType | IntegrationBlocksQuery_integrationBlocks_BlockVideoType | IntegrationBlocksQuery_integrationBlocks_BlockVideoWithDescriptionType | IntegrationBlocksQuery_integrationBlocks_ButtonTypeBlockRowType | IntegrationBlocksQuery_integrationBlocks_ConsumptionValueTypeBlockRowType | IntegrationBlocksQuery_integrationBlocks_KeyFactSmallBlockRowType | IntegrationBlocksQuery_integrationBlocks_KeyFactTypeBlockRowType | IntegrationBlocksQuery_integrationBlocks_KpiTypeBlockRowType | IntegrationBlocksQuery_integrationBlocks_VehicleDataTableSectionTypeBlockRowType;

export type IntegrationBlocksQuery_Query = {
  __typename: 'Query',
  integrationBlocks: Array<IntegrationBlocksQuery_integrationBlocks>
};


export type IntegrationBlocksQueryVariables = Exact<{
  integrationType: OfficeIntegrationEnum;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
  integrationInput: IntegrationQueryInput;
}>;


export type IntegrationBlocksQuery = IntegrationBlocksQuery_Query;

export type ContentLandingPageQuery_contentLandingPage_ContentLandingPageType = {
  __typename: 'ContentLandingPageType',
  active?: boolean,
  created?: any,
  updated?: any,
  document: ContentLandingPageFragment_ContentLandingPageType_document_DocumentType,
  project: ContentLandingPageFragment_ContentLandingPageType_project_ContentLandingPageProjectType,
  ctaBar: ContentLandingPageFragment_ContentLandingPageType_ctaBar_CtaBarType | null
};

export type ContentLandingPageQuery_Query = {
  __typename: 'Query',
  contentLandingPage: ContentLandingPageQuery_contentLandingPage_ContentLandingPageType
};


export type ContentLandingPageQueryVariables = Exact<{
  clpSlug: Scalars['String']['input'];
  isCufeApp?: InputMaybe<Scalars['Boolean']['input']>;
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ContentLandingPageQuery = ContentLandingPageQuery_Query;

export type IsFolderItemAvailableQuery_Query = {
  __typename: 'Query',
  isFolderItemAvailable: boolean
};


export type IsFolderItemAvailableQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  exposeFolderRecordId: Scalars['ID']['input'];
}>;


export type IsFolderItemAvailableQuery = IsFolderItemAvailableQuery_Query;

export type IsClpAvailableQuery_Query = {
  __typename: 'Query',
  isClpAvailable: boolean
};


export type IsClpAvailableQueryVariables = Exact<{
  clpSlug: Scalars['String']['input'];
}>;


export type IsClpAvailableQuery = IsClpAvailableQuery_Query;

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType = {
  __typename: 'LockStatusType',
  action: BlockStatusActionEnum,
  currentEditor: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType_currentEditor_MemberType
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  lockStatus: EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType_lockStatus_LockStatusType | null
};

export type EditorBlockLockStatusSubscription_editorBlockLockStatus = EditorBlockLockStatusSubscription_editorBlockLockStatus_AwardTypeBlockRowType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockAccordionType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockAppDownloadType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockAutoplayType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockBannerType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockChapterOpenerType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockDataSheetType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockDividerType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockDocumentHeaderType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockErrorType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockExternalLinkType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockHighlightType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockInstagramType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockIntegrationType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockJsonType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockKeyValueTableType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockMediaComparisonSliderType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockMediaGalleryType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockMediaSingleImageType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockOfficeVCardType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockPdfPreviewType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockPricingTableType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockQuotesType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockRichTextType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockSeEekType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockSeFeatureImagesType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockSePriceType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockSeQualityDescriptionType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockVideoType | EditorBlockLockStatusSubscription_editorBlockLockStatus_BlockVideoWithDescriptionType | EditorBlockLockStatusSubscription_editorBlockLockStatus_ButtonTypeBlockRowType | EditorBlockLockStatusSubscription_editorBlockLockStatus_ConsumptionValueTypeBlockRowType | EditorBlockLockStatusSubscription_editorBlockLockStatus_KeyFactSmallBlockRowType | EditorBlockLockStatusSubscription_editorBlockLockStatus_KeyFactTypeBlockRowType | EditorBlockLockStatusSubscription_editorBlockLockStatus_KpiTypeBlockRowType | EditorBlockLockStatusSubscription_editorBlockLockStatus_VehicleDataTableSectionTypeBlockRowType;

export type EditorBlockLockStatusSubscription_Subscription = {
  __typename: 'Subscription',
  editorBlockLockStatus: Array<EditorBlockLockStatusSubscription_editorBlockLockStatus>
};


export type EditorBlockLockStatusSubscriptionVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
}>;


export type EditorBlockLockStatusSubscription = EditorBlockLockStatusSubscription_Subscription;

export type EditorPageLockStatusSubscription_editorPageLockStatus_EufePageType_lockStatus_LockStatusType = {
  __typename: 'LockStatusType',
  action: BlockStatusActionEnum,
  currentEditor: XcNwBlockLockStatusFragment_AwardTypeBlockRowType_lockStatus_LockStatusType_currentEditor_MemberType
};

export type EditorPageLockStatusSubscription_editorPageLockStatus_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  lockStatus: EditorPageLockStatusSubscription_editorPageLockStatus_EufePageType_lockStatus_LockStatusType | null
};

export type EditorPageLockStatusSubscription_Subscription = {
  __typename: 'Subscription',
  editorPageLockStatus: Array<EditorPageLockStatusSubscription_editorPageLockStatus_EufePageType>
};


export type EditorPageLockStatusSubscriptionVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
}>;


export type EditorPageLockStatusSubscription = EditorPageLockStatusSubscription_Subscription;

export type EditorPagesSubscription_editorPages_EufePageType = {
  __typename: 'EufePageType',
  id: string,
  name: string | null,
  subtitle: string | null,
  callout: string | null,
  navLabel: string | null,
  isEditable: boolean | null,
  nestedPanels: Array<EufePageFragment_EufePageType_nestedPanels_PanelType>,
  panels: Array<EufePageFragment_EufePageType_panels_PanelType>
};

export type EditorPagesSubscription_Subscription = {
  __typename: 'Subscription',
  editorPages: Array<EditorPagesSubscription_editorPages_EufePageType>
};


export type EditorPagesSubscriptionVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditorPagesSubscription = EditorPagesSubscription_Subscription;

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_AwardTypeBlockRowType_items_AwardType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  sections: Array<XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  iosHref: string,
  androidHref: string,
  iosLabel: string,
  androidLabel: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  media: BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  bannerTitle: string | null,
  cta: BlockBannerFragment_BlockBannerType_cta | null,
  bannerBackground: BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  count: number | null,
  chapterOpenerMedia: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType | null,
  chapterOpenerMediaMobile: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  rawItems: Array<any>,
  sections: Array<BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType>,
  config: BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType,
  items: Array<BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  callout: string | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  message: string,
  eventId: string | null,
  sentryLink?: string | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  externalLinkUrl: string,
  media: BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  highlightTitle: string,
  highlightDescription: string,
  highlightVisualization: BlockHighlightVisualizationEnum,
  cta: XcNwBlockFragment_BlockHighlightType_cta | null,
  media: XcNwBlockFragment_BlockHighlightType_media_XCMediaRefType,
  mediaMobile: XcNwBlockFragment_BlockHighlightType_mediaMobile_XCMediaRefType | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  href: string,
  name: string,
  logo: BlockInstagramFragment_BlockInstagramType_logo_XCMediaRefType | null,
  instaItems: Array<BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  integrationType: OfficeIntegrationEnum,
  defaultValue: string | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  alignValue: AlignEnum,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_BlockKeyValueTableType_items_KeyValueType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image1: XcNwBlockFragment_BlockMediaComparisonSliderType_image1_XCMediaRefType,
  image2: XcNwBlockFragment_BlockMediaComparisonSliderType_image2_XCMediaRefType
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  mediaGalleryVisualization: BlockMediaGalleryVisualizationEnum,
  mediaGalleryItems: Array<BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image: XcNwBlockFragment_BlockMediaSingleImageType_image_XCMediaRefType,
  imageMobile: XcNwBlockFragment_BlockMediaSingleImageType_imageMobile_XCMediaRefType | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  name: string,
  company: string | null,
  city: string | null,
  street: string | null,
  zipCode: string | null,
  streetNumber: string | null,
  geoLongitude: string | null,
  geoLatitude: string | null,
  phone: string | null,
  phoneService: string | null,
  newCarsSalesPhone: string | null,
  usedCarsSalesPhone: string | null,
  email: string | null,
  officeVCardImage: BlockOfficeVCardFragment_BlockOfficeVCardType_officeVCardImage_XCMediaRefType | null,
  openingHoursAccessory: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursAccessory_OpeningHoursType,
  openingHoursGeneral: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursGeneral_OpeningHoursType,
  openingHoursSelling: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursSelling_OpeningHoursType,
  openingHoursService: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursService_OpeningHoursType
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  title: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  pdfPreviewUrl: string
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  description: string | null,
  pricingTableTitle: string | null,
  units: Array<BlockPricingTableFragment_BlockPricingTableType_units_KeyValueType>,
  total: BlockPricingTableFragment_BlockPricingTableType_total_KeyValueType
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  quotes: Array<string>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  text: string
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  co2Class: string | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  images: Array<BlockSeFeatureImagesFragment_BlockSeFeatureImagesType_images_XCMediaRefType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  internalNumber: string | null,
  availability: AvailabilityEnum,
  price: number | null,
  tax: boolean | null,
  loanPageId: string | null,
  loan: string | null,
  leasingPageId: string | null,
  leasing: string | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  logoPosition: SealLogoPositionEnum | null,
  description: string | null,
  logo: BlockSeQualityDescriptionFragment_BlockSeQualityDescriptionType_logo_XCMediaRefType | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  duration: number | null,
  autoplay: boolean,
  provider: VideoProviderEnum,
  thumbnail: BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  publishingDate: any | null,
  optionalTitle: string | null,
  duration: number | null,
  provider: VideoProviderEnum,
  videoDescription: string | null,
  thumbnail: BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType | null
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ButtonTypeBlockRowType_items>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ConsumptionValueTypeBlockRowType_items_ConsumptionValueType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KeyFactSmallBlockRowType_items_KeyFactSmallType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  aspectRatio: AspectRatioEnum | null,
  keyFactVisualization: BlockKeyFactVisualizationEnum,
  items: Array<KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KpiTypeBlockRowType_items>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_VehicleDataTableSectionTypeBlockRowType_items_VehicleDataTableSectionType>
};

export type EditorPanelsSubscription_editorPanels_PanelType_blocks = EditorPanelsSubscription_editorPanels_PanelType_blocks_AwardTypeBlockRowType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockAccordionType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockAppDownloadType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockAutoplayType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockBannerType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockChapterOpenerType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockDataSheetType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockDividerType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockDocumentHeaderType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockErrorType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockExternalLinkType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockHighlightType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockInstagramType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockIntegrationType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockJsonType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockKeyValueTableType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockMediaComparisonSliderType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockMediaGalleryType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockMediaSingleImageType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockOfficeVCardType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockPdfPreviewType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockPricingTableType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockQuotesType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockRichTextType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockSeEekType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockSeFeatureImagesType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockSePriceType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockSeQualityDescriptionType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockVideoType | EditorPanelsSubscription_editorPanels_PanelType_blocks_BlockVideoWithDescriptionType | EditorPanelsSubscription_editorPanels_PanelType_blocks_ButtonTypeBlockRowType | EditorPanelsSubscription_editorPanels_PanelType_blocks_ConsumptionValueTypeBlockRowType | EditorPanelsSubscription_editorPanels_PanelType_blocks_KeyFactSmallBlockRowType | EditorPanelsSubscription_editorPanels_PanelType_blocks_KeyFactTypeBlockRowType | EditorPanelsSubscription_editorPanels_PanelType_blocks_KpiTypeBlockRowType | EditorPanelsSubscription_editorPanels_PanelType_blocks_VehicleDataTableSectionTypeBlockRowType;

export type EditorPanelsSubscription_editorPanels_PanelType = {
  __typename: 'PanelType',
  id: string,
  blocks: Array<EditorPanelsSubscription_editorPanels_PanelType_blocks>
};

export type EditorPanelsSubscription_Subscription = {
  __typename: 'Subscription',
  editorPanels: Array<EditorPanelsSubscription_editorPanels_PanelType>
};


export type EditorPanelsSubscriptionVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditorPanelsSubscription = EditorPanelsSubscription_Subscription;

export type EditorDocumentSubscription_editorDocument_DocumentType = {
  __typename: 'DocumentType',
  id: string,
  identifier: any,
  displayName: string,
  brandId: string | null,
  disclaimers: Array<string>,
  pages: Array<XcNwDataFragment_DocumentType_pages_EufePageType>,
  xcMediaLibrary?: Array<XcNwDataFragment_DocumentType_xcMediaLibrary_XCMediaRefType>,
  inlineDisclaimers: Array<XcNwDataFragment_DocumentType_inlineDisclaimers>,
  externalLinkDisclaimerConfig: XcNwDataFragment_DocumentType_externalLinkDisclaimerConfig_ExternalLinkDisclaimerConfigType | null,
  xcTheme: XcNwDataFragment_DocumentType_xcTheme_XCThemeType | null
};

export type EditorDocumentSubscription_Subscription = {
  __typename: 'Subscription',
  editorDocument: Array<EditorDocumentSubscription_editorDocument_DocumentType>
};


export type EditorDocumentSubscriptionVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
  isThemeEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditorDocumentSubscription = EditorDocumentSubscription_Subscription;

export type EditorBlocksSubscription_editorBlocks_AwardTypeBlockRowType = {
  __typename: 'AwardTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_AwardTypeBlockRowType_items_AwardType>
};

export type EditorBlocksSubscription_editorBlocks_BlockAccordionType = {
  __typename: 'BlockAccordionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  sections: Array<XcNwBlockFragment_BlockAccordionType_sections_BlockAccordionSectionType>
};

export type EditorBlocksSubscription_editorBlocks_BlockAppDownloadType = {
  __typename: 'BlockAppDownloadType',
  iosHref: string,
  androidHref: string,
  iosLabel: string,
  androidLabel: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EditorBlocksSubscription_editorBlocks_BlockAutoplayType = {
  __typename: 'BlockAutoplayType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  media: BlockAutoplayFragment_BlockAutoplayType_media_XCMediaRefType
};

export type EditorBlocksSubscription_editorBlocks_BlockBannerType = {
  __typename: 'BlockBannerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  bannerTitle: string | null,
  cta: BlockBannerFragment_BlockBannerType_cta | null,
  bannerBackground: BlockBannerFragment_BlockBannerType_bannerBackground_XCMediaRefType | null
};

export type EditorBlocksSubscription_editorBlocks_BlockChapterOpenerType = {
  __typename: 'BlockChapterOpenerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  count: number | null,
  chapterOpenerMedia: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMedia_XCMediaRefType | null,
  chapterOpenerMediaMobile: BlockChapterOpenerFragment_BlockChapterOpenerType_chapterOpenerMediaMobile_XCMediaRefType | null
};

export type EditorBlocksSubscription_editorBlocks_BlockDataSheetType = {
  __typename: 'BlockDataSheetType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  rawItems: Array<any>,
  sections: Array<BlockDataSheetFragment_BlockDataSheetType_sections_DataSheetSectionType>,
  config: BlockDataSheetFragment_BlockDataSheetType_config_DataSheetConfigType,
  items: Array<BlockDataSheetFragment_BlockDataSheetType_items_DataSheetItemType>
};

export type EditorBlocksSubscription_editorBlocks_BlockDividerType = {
  __typename: 'BlockDividerType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EditorBlocksSubscription_editorBlocks_BlockDocumentHeaderType = {
  __typename: 'BlockDocumentHeaderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  callout: string | null
};

export type EditorBlocksSubscription_editorBlocks_BlockErrorType = {
  __typename: 'BlockErrorType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  message: string,
  eventId: string | null,
  sentryLink?: string | null
};

export type EditorBlocksSubscription_editorBlocks_BlockExternalLinkType = {
  __typename: 'BlockExternalLinkType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  title: string,
  externalLinkUrl: string,
  media: BlockExternalLinkFragment_BlockExternalLinkType_media_XCMediaRefType
};

export type EditorBlocksSubscription_editorBlocks_BlockHighlightType = {
  __typename: 'BlockHighlightType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  highlightTitle: string,
  highlightDescription: string,
  highlightVisualization: BlockHighlightVisualizationEnum,
  cta: XcNwBlockFragment_BlockHighlightType_cta | null,
  media: XcNwBlockFragment_BlockHighlightType_media_XCMediaRefType,
  mediaMobile: XcNwBlockFragment_BlockHighlightType_mediaMobile_XCMediaRefType | null
};

export type EditorBlocksSubscription_editorBlocks_BlockInstagramType = {
  __typename: 'BlockInstagramType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  href: string,
  name: string,
  logo: BlockInstagramFragment_BlockInstagramType_logo_XCMediaRefType | null,
  instaItems: Array<BlockInstagramFragment_BlockInstagramType_instaItems_InstagramItemType>
};

export type EditorBlocksSubscription_editorBlocks_BlockIntegrationType = {
  __typename: 'BlockIntegrationType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  integrationType: OfficeIntegrationEnum,
  defaultValue: string | null
};

export type EditorBlocksSubscription_editorBlocks_BlockJsonType = {
  __typename: 'BlockJsonType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean
};

export type EditorBlocksSubscription_editorBlocks_BlockKeyValueTableType = {
  __typename: 'BlockKeyValueTableType',
  alignValue: AlignEnum,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_BlockKeyValueTableType_items_KeyValueType>
};

export type EditorBlocksSubscription_editorBlocks_BlockMediaComparisonSliderType = {
  __typename: 'BlockMediaComparisonSliderType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image1: XcNwBlockFragment_BlockMediaComparisonSliderType_image1_XCMediaRefType,
  image2: XcNwBlockFragment_BlockMediaComparisonSliderType_image2_XCMediaRefType
};

export type EditorBlocksSubscription_editorBlocks_BlockMediaGalleryType = {
  __typename: 'BlockMediaGalleryType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  mediaGalleryVisualization: BlockMediaGalleryVisualizationEnum,
  mediaGalleryItems: Array<BlockMediaGalleryFragment_BlockMediaGalleryType_mediaGalleryItems_FileHashTextType>
};

export type EditorBlocksSubscription_editorBlocks_BlockMediaSingleImageType = {
  __typename: 'BlockMediaSingleImageType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  image: XcNwBlockFragment_BlockMediaSingleImageType_image_XCMediaRefType,
  imageMobile: XcNwBlockFragment_BlockMediaSingleImageType_imageMobile_XCMediaRefType | null
};

export type EditorBlocksSubscription_editorBlocks_BlockOfficeVCardType = {
  __typename: 'BlockOfficeVCardType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  name: string,
  company: string | null,
  city: string | null,
  street: string | null,
  zipCode: string | null,
  streetNumber: string | null,
  geoLongitude: string | null,
  geoLatitude: string | null,
  phone: string | null,
  phoneService: string | null,
  newCarsSalesPhone: string | null,
  usedCarsSalesPhone: string | null,
  email: string | null,
  officeVCardImage: BlockOfficeVCardFragment_BlockOfficeVCardType_officeVCardImage_XCMediaRefType | null,
  openingHoursAccessory: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursAccessory_OpeningHoursType,
  openingHoursGeneral: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursGeneral_OpeningHoursType,
  openingHoursSelling: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursSelling_OpeningHoursType,
  openingHoursService: BlockOfficeVCardFragment_BlockOfficeVCardType_openingHoursService_OpeningHoursType
};

export type EditorBlocksSubscription_editorBlocks_BlockPdfPreviewType = {
  __typename: 'BlockPdfPreviewType',
  title: string,
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  pdfPreviewUrl: string
};

export type EditorBlocksSubscription_editorBlocks_BlockPricingTableType = {
  __typename: 'BlockPricingTableType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  description: string | null,
  pricingTableTitle: string | null,
  units: Array<BlockPricingTableFragment_BlockPricingTableType_units_KeyValueType>,
  total: BlockPricingTableFragment_BlockPricingTableType_total_KeyValueType
};

export type EditorBlocksSubscription_editorBlocks_BlockQuotesType = {
  __typename: 'BlockQuotesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  quotes: Array<string>
};

export type EditorBlocksSubscription_editorBlocks_BlockRichTextType = {
  __typename: 'BlockRichTextType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  text: string
};

export type EditorBlocksSubscription_editorBlocks_BlockSeEekType = {
  __typename: 'BlockSeEekType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  co2Class: string | null
};

export type EditorBlocksSubscription_editorBlocks_BlockSeFeatureImagesType = {
  __typename: 'BlockSeFeatureImagesType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  images: Array<BlockSeFeatureImagesFragment_BlockSeFeatureImagesType_images_XCMediaRefType>
};

export type EditorBlocksSubscription_editorBlocks_BlockSePriceType = {
  __typename: 'BlockSePriceType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  internalNumber: string | null,
  availability: AvailabilityEnum,
  price: number | null,
  tax: boolean | null,
  loanPageId: string | null,
  loan: string | null,
  leasingPageId: string | null,
  leasing: string | null
};

export type EditorBlocksSubscription_editorBlocks_BlockSeQualityDescriptionType = {
  __typename: 'BlockSeQualityDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  logoPosition: SealLogoPositionEnum | null,
  description: string | null,
  logo: BlockSeQualityDescriptionFragment_BlockSeQualityDescriptionType_logo_XCMediaRefType | null
};

export type EditorBlocksSubscription_editorBlocks_BlockVideoType = {
  __typename: 'BlockVideoType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  duration: number | null,
  autoplay: boolean,
  provider: VideoProviderEnum,
  thumbnail: BlockVideoFragment_BlockVideoType_thumbnail_XCMediaRefType | null
};

export type EditorBlocksSubscription_editorBlocks_BlockVideoWithDescriptionType = {
  __typename: 'BlockVideoWithDescriptionType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  url: string | null,
  videoId: string | null,
  openInNewTab: boolean,
  publishingDate: any | null,
  optionalTitle: string | null,
  duration: number | null,
  provider: VideoProviderEnum,
  videoDescription: string | null,
  thumbnail: BlockVideoWithDescriptionFragment_BlockVideoWithDescriptionType_thumbnail_XCMediaRefType | null
};

export type EditorBlocksSubscription_editorBlocks_ButtonTypeBlockRowType = {
  __typename: 'ButtonTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ButtonTypeBlockRowType_items>
};

export type EditorBlocksSubscription_editorBlocks_ConsumptionValueTypeBlockRowType = {
  __typename: 'ConsumptionValueTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_ConsumptionValueTypeBlockRowType_items_ConsumptionValueType>
};

export type EditorBlocksSubscription_editorBlocks_KeyFactSmallBlockRowType = {
  __typename: 'KeyFactSmallBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KeyFactSmallBlockRowType_items_KeyFactSmallType>
};

export type EditorBlocksSubscription_editorBlocks_KeyFactTypeBlockRowType = {
  __typename: 'KeyFactTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  aspectRatio: AspectRatioEnum | null,
  keyFactVisualization: BlockKeyFactVisualizationEnum,
  items: Array<KeyFactTypeBlockRowFragment_KeyFactTypeBlockRowType_items_KeyFactType>
};

export type EditorBlocksSubscription_editorBlocks_KpiTypeBlockRowType = {
  __typename: 'KpiTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_KpiTypeBlockRowType_items>
};

export type EditorBlocksSubscription_editorBlocks_VehicleDataTableSectionTypeBlockRowType = {
  __typename: 'VehicleDataTableSectionTypeBlockRowType',
  id: string,
  disclaimer: string | null,
  pullout: boolean,
  countryCodes: Array<CountryCodeEnum>,
  isEditable?: boolean,
  items: Array<XcNwBlockFragment_VehicleDataTableSectionTypeBlockRowType_items_VehicleDataTableSectionType>
};

export type EditorBlocksSubscription_editorBlocks = EditorBlocksSubscription_editorBlocks_AwardTypeBlockRowType | EditorBlocksSubscription_editorBlocks_BlockAccordionType | EditorBlocksSubscription_editorBlocks_BlockAppDownloadType | EditorBlocksSubscription_editorBlocks_BlockAutoplayType | EditorBlocksSubscription_editorBlocks_BlockBannerType | EditorBlocksSubscription_editorBlocks_BlockChapterOpenerType | EditorBlocksSubscription_editorBlocks_BlockDataSheetType | EditorBlocksSubscription_editorBlocks_BlockDividerType | EditorBlocksSubscription_editorBlocks_BlockDocumentHeaderType | EditorBlocksSubscription_editorBlocks_BlockErrorType | EditorBlocksSubscription_editorBlocks_BlockExternalLinkType | EditorBlocksSubscription_editorBlocks_BlockHighlightType | EditorBlocksSubscription_editorBlocks_BlockInstagramType | EditorBlocksSubscription_editorBlocks_BlockIntegrationType | EditorBlocksSubscription_editorBlocks_BlockJsonType | EditorBlocksSubscription_editorBlocks_BlockKeyValueTableType | EditorBlocksSubscription_editorBlocks_BlockMediaComparisonSliderType | EditorBlocksSubscription_editorBlocks_BlockMediaGalleryType | EditorBlocksSubscription_editorBlocks_BlockMediaSingleImageType | EditorBlocksSubscription_editorBlocks_BlockOfficeVCardType | EditorBlocksSubscription_editorBlocks_BlockPdfPreviewType | EditorBlocksSubscription_editorBlocks_BlockPricingTableType | EditorBlocksSubscription_editorBlocks_BlockQuotesType | EditorBlocksSubscription_editorBlocks_BlockRichTextType | EditorBlocksSubscription_editorBlocks_BlockSeEekType | EditorBlocksSubscription_editorBlocks_BlockSeFeatureImagesType | EditorBlocksSubscription_editorBlocks_BlockSePriceType | EditorBlocksSubscription_editorBlocks_BlockSeQualityDescriptionType | EditorBlocksSubscription_editorBlocks_BlockVideoType | EditorBlocksSubscription_editorBlocks_BlockVideoWithDescriptionType | EditorBlocksSubscription_editorBlocks_ButtonTypeBlockRowType | EditorBlocksSubscription_editorBlocks_ConsumptionValueTypeBlockRowType | EditorBlocksSubscription_editorBlocks_KeyFactSmallBlockRowType | EditorBlocksSubscription_editorBlocks_KeyFactTypeBlockRowType | EditorBlocksSubscription_editorBlocks_KpiTypeBlockRowType | EditorBlocksSubscription_editorBlocks_VehicleDataTableSectionTypeBlockRowType;

export type EditorBlocksSubscription_Subscription = {
  __typename: 'Subscription',
  editorBlocks: Array<EditorBlocksSubscription_editorBlocks>
};


export type EditorBlocksSubscriptionVariables = Exact<{
  documentVersionId: Scalars['ID']['input'];
  isXcEditor?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditorBlocksSubscription = EditorBlocksSubscription_Subscription;

export const LockStatusFragmentDoc = gql`
    fragment LockStatus on LockStatusType {
  action
  currentEditor {
    id
    fullName
  }
}
    `;
export const XcNwBlockLockStatusFragmentDoc = gql`
    fragment XCNwBlockLockStatus on BlockInterface {
  id
  lockStatus {
    ...LockStatus
  }
}
    ${LockStatusFragmentDoc}`;
export const EufePageLockStatusFragmentDoc = gql`
    fragment EufePageLockStatus on EufePageType {
  id
  lockStatus {
    ...LockStatus
  }
}
    ${LockStatusFragmentDoc}`;
export const BlockSePriceFragmentDoc = gql`
    fragment BlockSePrice on BlockSePriceType {
  internalNumber
  availability
  price
  tax
  loanPageId
  loan
  leasingPageId
  leasing
}
    `;
export const BlockSeEekFragmentDoc = gql`
    fragment BlockSeEek on BlockSeEekType {
  co2Class
}
    `;
export const XcMediaRefFragmentDoc = gql`
    fragment XCMediaRef on XCMediaRefType {
  id
  fileUrl
  thumbnailUrl(inp: {width: 0, height: 0})
  thumbnailUrl380x380: thumbnailUrl(inp: {height: 380, width: 380})
  thumbnailUrl380w: thumbnailUrl(inp: {width: 380})
  createdAt
  size
  mimeType
  altText
  fileHash
  isPlaceholder
  originalThumbnailDimensions {
    height
    width
    aspect
  }
}
    `;
export const BlockSeQualityDescriptionFragmentDoc = gql`
    fragment BlockSeQualityDescription on BlockSeQualityDescriptionType {
  logo {
    ...XCMediaRef
  }
  logoPosition
  description
}
    ${XcMediaRefFragmentDoc}`;
export const BlockSeFeatureImagesFragmentDoc = gql`
    fragment BlockSeFeatureImages on BlockSeFeatureImagesType {
  images {
    ...XCMediaRef
  }
}
    ${XcMediaRefFragmentDoc}`;
export const BlockDocumentHeaderFragmentDoc = gql`
    fragment BlockDocumentHeader on BlockDocumentHeaderType {
  title
  callout
}
    `;
export const BlockExternalLinkFragmentDoc = gql`
    fragment BlockExternalLink on BlockExternalLinkType {
  id
  title
  media {
    ...XCMediaRef
  }
  externalLinkUrl: url
}
    ${XcMediaRefFragmentDoc}`;
export const BlockMediaGalleryFragmentDoc = gql`
    fragment BlockMediaGallery on BlockMediaGalleryType {
  mediaGalleryVisualization: visualization
  mediaGalleryItems: items {
    image {
      ...XCMediaRef
    }
    text
  }
}
    ${XcMediaRefFragmentDoc}`;
export const BlockVideoFragmentDoc = gql`
    fragment BlockVideo on BlockVideoType {
  url
  videoId
  thumbnail {
    ...XCMediaRef
  }
  openInNewTab
  duration
  autoplay
  provider
}
    ${XcMediaRefFragmentDoc}`;
export const ErrorFragmentDoc = gql`
    fragment Error on ErrorType {
  message
  code
  rawCode
}
    `;
export const ButtonInterfaceFragmentDoc = gql`
    fragment ButtonInterface on ButtonInterface {
  disclaimer
  size
  variant
  leadingIcon
  trailingIcon
  label
  mboAttrs {
    prefix
    piece
  }
  ... on HrefButtonType {
    href: url
  }
  ... on CopyButtonType {
    content
  }
  ... on DocButtonType {
    docIdentifier: identifier
    document {
      ... on DocumentType {
        id
        identifier
        displayName
        keyVisualUrl(inp: {height: 0, width: 0})
      }
      ... on MobRecordType {
        id
        identifier
        fullName
        mediaRef {
          ...XCMediaRef
        }
      }
      ... on ErrorType {
        ...Error
      }
    }
  }
  ... on DownloadButtonType {
    media {
      ...XCMediaRef
    }
    fileName
  }
  ... on DialogButtonType {
    panelId
  }
  ... on NestedContentButtonType {
    panelId
    identifier
    panel @include(if: $isXcEditor) {
      id
      blocks(editable: $isXcEditor) {
        id
      }
    }
  }
}
    ${XcMediaRefFragmentDoc}
${ErrorFragmentDoc}`;
export const BlockBannerFragmentDoc = gql`
    fragment BlockBanner on BlockBannerType {
  bannerTitle: title
  cta {
    ...ButtonInterface
  }
  bannerBackground: media {
    ...XCMediaRef
  }
}
    ${ButtonInterfaceFragmentDoc}
${XcMediaRefFragmentDoc}`;
export const BlockVideoWithDescriptionFragmentDoc = gql`
    fragment BlockVideoWithDescription on BlockVideoWithDescriptionType {
  url
  videoId
  thumbnail {
    ...XCMediaRef
  }
  openInNewTab
  videoDescription: description
  publishingDate
  optionalTitle
  duration
  provider
}
    ${XcMediaRefFragmentDoc}`;
export const KpiFragmentDoc = gql`
    fragment Kpi on KpiInterface {
  title
  prefix
  suffix
  subtitle
  ... on KpiNumberType {
    numberValue: value
    kpiVariant: variant
  }
  ... on KpiTextType {
    stringValue: value
  }
}
    `;
export const ConsumptionValueFragmentDoc = gql`
    fragment ConsumptionValue on ConsumptionValueType {
  consumptionLabel: label
  consumptionValue: value
  type
}
    `;
export const AwardItemFragmentDoc = gql`
    fragment AwardItem on AwardType {
  title
  text
  awardImage: image {
    ...XCMediaRef
  }
}
    ${XcMediaRefFragmentDoc}`;
export const BlockRichTextFragmentDoc = gql`
    fragment BlockRichText on BlockRichTextType {
  id
  text
}
    `;
export const KeyValueFragmentDoc = gql`
    fragment KeyValue on KeyValueType {
  id
  key
  value
}
    `;
export const VehicleDataTableSectionFragmentDoc = gql`
    fragment VehicleDataTableSection on VehicleDataTableSectionType {
  title
  items {
    ...KeyValue
  }
}
    ${KeyValueFragmentDoc}`;
export const KeyFactFragmentDoc = gql`
    fragment KeyFact on KeyFactType {
  title
  image {
    ...XCMediaRef
  }
  mediaDivider
  callOut
  description
  cta {
    ...ButtonInterface
  }
}
    ${XcMediaRefFragmentDoc}
${ButtonInterfaceFragmentDoc}`;
export const KeyFactTypeBlockRowFragmentDoc = gql`
    fragment KeyFactTypeBlockRow on KeyFactTypeBlockRowType {
  aspectRatio
  keyFactVisualization: visualization
  items {
    ...KeyFact
  }
}
    ${KeyFactFragmentDoc}`;
export const KeyFactSmallFragmentDoc = gql`
    fragment KeyFactSmall on KeyFactSmallType {
  heading
  image {
    ...XCMediaRef
  }
  callout
  description
  cta {
    ...ButtonInterface
  }
}
    ${XcMediaRefFragmentDoc}
${ButtonInterfaceFragmentDoc}`;
export const BlockPricingTableFragmentDoc = gql`
    fragment BlockPricingTable on BlockPricingTableType {
  id
  units {
    ...KeyValue
  }
  total {
    ...KeyValue
  }
  pricingTableTitle: title
  description
}
    ${KeyValueFragmentDoc}`;
export const BlockQuotesFragmentDoc = gql`
    fragment BlockQuotes on BlockQuotesType {
  quotes
}
    `;
export const BlockIntegrationFragmentDoc = gql`
    fragment BlockIntegration on BlockIntegrationType {
  integrationType
  defaultValue
}
    `;
export const BlockInstagramFragmentDoc = gql`
    fragment BlockInstagram on BlockInstagramType {
  href
  name
  logo {
    ...XCMediaRef
  }
  instaItems: items {
    text
    created
    image {
      ...XCMediaRef
    }
  }
}
    ${XcMediaRefFragmentDoc}`;
export const BlockDividerFragmentDoc = gql`
    fragment BlockDivider on BlockDividerType {
  id
}
    `;
export const BlockChapterOpenerFragmentDoc = gql`
    fragment BlockChapterOpener on BlockChapterOpenerType {
  title
  chapterOpenerMedia: media {
    ...XCMediaRef
  }
  chapterOpenerMediaMobile: mediaMobile {
    ...XCMediaRef
  }
  count
}
    ${XcMediaRefFragmentDoc}`;
export const BlockAutoplayFragmentDoc = gql`
    fragment BlockAutoplay on BlockAutoplayType {
  media {
    ...XCMediaRef
  }
}
    ${XcMediaRefFragmentDoc}`;
export const DataSheetProcessorFragmentDoc = gql`
    fragment DataSheetProcessor on DataSheetProcessorType {
  processor
  payload {
    value
    lookupType
  }
}
    `;
export const DataSheetLookupFragmentDoc = gql`
    fragment DataSheetLookup on DataSheetLookupType {
  value
  lookupType
  processors {
    ...DataSheetProcessor
  }
}
    ${DataSheetProcessorFragmentDoc}`;
export const DataSheetSectionItemFragmentDoc = gql`
    fragment DataSheetSectionItem on DataSheetSectionItemType {
  label {
    ...DataSheetLookup
  }
  value {
    ...DataSheetLookup
  }
}
    ${DataSheetLookupFragmentDoc}`;
export const DataSheetSectionFragmentDoc = gql`
    fragment DataSheetSection on DataSheetSectionType {
  sectionName
  items {
    ...DataSheetSectionItem
  }
}
    ${DataSheetSectionItemFragmentDoc}`;
export const DataSheetConfigFragmentDoc = gql`
    fragment DataSheetConfig on DataSheetConfigType {
  titleFieldName
  ctaFieldName
  descriptionFieldName
  additionalFieldName
  filterFieldName
  keyVisualFieldName
}
    `;
export const DataSheetItemFragmentDoc = gql`
    fragment DataSheetItem on DataSheetItemType {
  title
  description
  additional
  media {
    ...XCMediaRef
  }
  btnLabel
}
    ${XcMediaRefFragmentDoc}`;
export const BlockDataSheetFragmentDoc = gql`
    fragment BlockDataSheet on BlockDataSheetType {
  rawItems
  sections {
    ...DataSheetSection
  }
  config {
    ...DataSheetConfig
  }
  items {
    ...DataSheetItem
  }
}
    ${DataSheetSectionFragmentDoc}
${DataSheetConfigFragmentDoc}
${DataSheetItemFragmentDoc}`;
export const BlockErrorFragmentDoc = gql`
    fragment BlockError on BlockErrorType {
  message
  eventId
  sentryLink @include(if: $isXcEditor)
}
    `;
export const OpeningHoursFragmentDoc = gql`
    fragment OpeningHours on OpeningHoursType {
  mondayOpen
  mondayClose
  tuesdayOpen
  tuesdayClose
  wednesdayOpen
  wednesdayClose
  thursdayOpen
  thursdayClose
  fridayOpen
  fridayClose
  saturdayOpen
  saturdayClose
  sundayOpen
  sundayClose
}
    `;
export const BlockOfficeVCardFragmentDoc = gql`
    fragment BlockOfficeVCard on BlockOfficeVCardType {
  id
  name
  company
  city
  street
  zipCode
  streetNumber
  geoLongitude
  geoLatitude
  phone
  phoneService
  newCarsSalesPhone
  usedCarsSalesPhone
  email
  officeVCardImage: image {
    ...XCMediaRef
  }
  openingHoursAccessory {
    ...OpeningHours
  }
  openingHoursGeneral {
    ...OpeningHours
  }
  openingHoursSelling {
    ...OpeningHours
  }
  openingHoursService {
    ...OpeningHours
  }
}
    ${XcMediaRefFragmentDoc}
${OpeningHoursFragmentDoc}`;
export const XcNwBlockFragmentDoc = gql`
    fragment XCNwBlock on BlockInterface {
  id
  disclaimer
  pullout
  countryCodes
  isEditable @include(if: $isXcEditor)
  ... on BlockSePriceType {
    ...BlockSePrice
  }
  ... on BlockSeEekType {
    ...BlockSeEek
  }
  ... on BlockSeQualityDescriptionType {
    ...BlockSeQualityDescription
  }
  ... on BlockSeFeatureImagesType {
    ...BlockSeFeatureImages
  }
  ... on BlockDocumentHeaderType {
    ...BlockDocumentHeader
  }
  ... on BlockExternalLinkType {
    ...BlockExternalLink
  }
  ... on BlockMediaGalleryType {
    ...BlockMediaGallery
  }
  ... on BlockMediaComparisonSliderType {
    image1 {
      ...XCMediaRef
    }
    image2 {
      ...XCMediaRef
    }
  }
  ... on BlockVideoType {
    ...BlockVideo
  }
  ... on BlockBannerType {
    ...BlockBanner
  }
  ... on BlockVideoWithDescriptionType {
    ...BlockVideoWithDescription
  }
  ... on ButtonTypeBlockRowType {
    items {
      ...ButtonInterface
    }
  }
  ... on KpiTypeBlockRowType {
    items {
      ...Kpi
    }
  }
  ... on ConsumptionValueTypeBlockRowType {
    items {
      ...ConsumptionValue
    }
  }
  ... on BlockMediaSingleImageType {
    image {
      ...XCMediaRef
    }
    imageMobile {
      ...XCMediaRef
    }
  }
  ... on BlockAppDownloadType {
    iosHref
    androidHref
    iosLabel
    androidLabel
  }
  ... on AwardTypeBlockRowType {
    items {
      ...AwardItem
    }
  }
  ... on BlockRichTextType {
    ...BlockRichText
  }
  ... on VehicleDataTableSectionTypeBlockRowType {
    items {
      ...VehicleDataTableSection
    }
  }
  ... on BlockHighlightType {
    highlightTitle: title
    highlightDescription: description
    highlightVisualization: visualization
    cta {
      ...ButtonInterface
    }
    media {
      ...XCMediaRef
    }
    mediaMobile {
      ...XCMediaRef
    }
  }
  ... on KeyFactTypeBlockRowType {
    ...KeyFactTypeBlockRow
  }
  ... on KeyFactSmallBlockRowType {
    items {
      ...KeyFactSmall
    }
  }
  ... on BlockPricingTableType {
    ...BlockPricingTable
  }
  ... on BlockQuotesType {
    ...BlockQuotes
  }
  ... on BlockAccordionType {
    sections {
      id
      title
      panel {
        id
      }
    }
  }
  ... on BlockKeyValueTableType {
    alignValue
    items {
      ...KeyValue
    }
  }
  ... on BlockPdfPreviewType {
    pdfPreviewUrl: url
    title
  }
  ... on BlockIntegrationType {
    ...BlockIntegration
  }
  ... on BlockInstagramType {
    ...BlockInstagram
  }
  ... on BlockDividerType {
    ...BlockDivider
  }
  ... on BlockChapterOpenerType {
    ...BlockChapterOpener
  }
  ... on BlockAutoplayType {
    ...BlockAutoplay
  }
  ... on BlockDataSheetType {
    ...BlockDataSheet
  }
  ... on BlockErrorType {
    ...BlockError
  }
  ... on BlockOfficeVCardType {
    ...BlockOfficeVCard
  }
}
    ${BlockSePriceFragmentDoc}
${BlockSeEekFragmentDoc}
${BlockSeQualityDescriptionFragmentDoc}
${BlockSeFeatureImagesFragmentDoc}
${BlockDocumentHeaderFragmentDoc}
${BlockExternalLinkFragmentDoc}
${BlockMediaGalleryFragmentDoc}
${XcMediaRefFragmentDoc}
${BlockVideoFragmentDoc}
${BlockBannerFragmentDoc}
${BlockVideoWithDescriptionFragmentDoc}
${ButtonInterfaceFragmentDoc}
${KpiFragmentDoc}
${ConsumptionValueFragmentDoc}
${AwardItemFragmentDoc}
${BlockRichTextFragmentDoc}
${VehicleDataTableSectionFragmentDoc}
${KeyFactTypeBlockRowFragmentDoc}
${KeyFactSmallFragmentDoc}
${BlockPricingTableFragmentDoc}
${BlockQuotesFragmentDoc}
${KeyValueFragmentDoc}
${BlockIntegrationFragmentDoc}
${BlockInstagramFragmentDoc}
${BlockDividerFragmentDoc}
${BlockChapterOpenerFragmentDoc}
${BlockAutoplayFragmentDoc}
${BlockDataSheetFragmentDoc}
${BlockErrorFragmentDoc}
${BlockOfficeVCardFragmentDoc}`;
export const PanelFragmentDoc = gql`
    fragment Panel on PanelType {
  id
  blocks(editable: $isXcEditor) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export const SuccessFragmentDoc = gql`
    fragment Success on SuccessType {
  message
  objId
}
    `;
export const OfficeFeatureFragmentDoc = gql`
    fragment OfficeFeature on OfficeFeatureType {
  id
  label
  featureType
}
    `;
export const MemberFragmentDoc = gql`
    fragment Member on MemberType {
  id
  title
  salutation
  firstName
  lastName
  avatarSrc: thumbnail
  features(featureType: COLLECTION_SE, selectable: true) {
    ...OfficeFeature
  }
  hasSeFeature: hasFeature(featureType: COLLECTION_SE)
  hasAutomotiveFeature: hasFeature(featureType: COLLECTION_AUTOMOTIVE)
  hasGroupAnalysisFeature: hasFeature(featureType: GROUP_ANALYSIS)
  hasCombinedDashboardFeature: hasFeature(featureType: COMBINED_DASHBOARD)
  hasCmsFeature: hasFeature(featureType: APP_CMS)
  hasThemeEditorFeature: hasFeature(featureType: APP_THEME_EDITOR)
  hasPrintManagerFeature: hasFeature(featureType: PRINT_MANAGER)
}
    ${OfficeFeatureFragmentDoc}`;
export const MemberProfileFragmentDoc = gql`
    fragment MemberProfile on MemberType {
  ...Member
  avatarOriginalSrc: originalImageUrl
  email
  phone
  mobile
  fax
  hasUsablePassword
}
    ${MemberFragmentDoc}`;
export const StockFragmentDoc = gql`
    fragment Stock on MobField0MappingType {
  id
  label
  value
}
    `;
export const CarFragmentDoc = gql`
    fragment Car on MobRecordType {
  id
  identifier
  internalName: interneNummer
  fullName
  mediaRef {
    ...XCMediaRef
  }
  price: preis
  kilometers: kilometer
  disclaimers
}
    ${XcMediaRefFragmentDoc}`;
export const CampaignFragmentDoc = gql`
    fragment Campaign on XCCampaignType {
  id
  displayName
}
    `;
export const AnalyticBucketFragmentDoc = gql`
    fragment AnalyticBucket on XCCampaignAnalyticBucketType {
  createdAt
  scans: countScans
  claims: countClaims
  visits: countVisits
}
    `;
export const AnalyticLvFragmentDoc = gql`
    fragment AnalyticLV on XCCampaignLVAnalyticType {
  label
  value
}
    `;
export const XcDisclaimerInterfaceFragmentDoc = gql`
    fragment XCDisclaimerInterface on XCDisclaimerInterface {
  id
  key
  variant
  ... on XCInfoFootnoteType {
    textClick
  }
  ... on XCRectangleFootnoteType {
    textHover
    textContent
    colorBackground
    colorFont
    colorBorder
  }
  ... on XCDocDisclaimerType {
    docTextContent: textContent
  }
}
    `;
export const CmsCollectionFragmentDoc = gql`
    fragment CmsCollection on XCollectionAutomotiveType {
  id
  name
  isCms
  contentCount
  inlineDisclaimers {
    ...XCDisclaimerInterface
  }
}
    ${XcDisclaimerInterfaceFragmentDoc}`;
export const CmsCollectionDocumentFragmentDoc = gql`
    fragment CmsCollectionDocument on DocumentType {
  id
  identifier
  name
  editVersionId
  keyVisualUrl(inp: {width: 550, height: 420, smart: FALSE, focalAsCrop: true})
}
    `;
export const XcRecordBaseFragmentDoc = gql`
    fragment XCRecordBase on XCFolderDocumentInterface {
  id
  exposeFolderId
  order
  createdAt
  title
  callout
  note
  xcMediaRef {
    altText
    thumbnailUrl(inp: {width: 0, height: 0})
  }
  subItemCount
}
    `;
export const CtaBarFragmentDoc = gql`
    fragment CtaBar on CtaBarType {
  description
  cta {
    ...ButtonInterface
  }
}
    ${ButtonInterfaceFragmentDoc}`;
export const ExternalLinkDisclaimerConfigFragmentDoc = gql`
    fragment ExternalLinkDisclaimerConfig on ExternalLinkDisclaimerConfigType {
  text
  whiteList
}
    `;
export const XcThemeFragmentDoc = gql`
    fragment XCTheme on XCThemeType {
  id
  cssVariablesStr
  cssVariables
  cssHeader
  faviconUrl
  header
  name @include(if: $isThemeEditor)
  headerFont @include(if: $isThemeEditor) {
    ...KeyValue
  }
  bodyFont @include(if: $isThemeEditor) {
    ...KeyValue
  }
  favicon {
    ...XCMediaRef
  }
  logo {
    ...XCMediaRef
  }
}
    ${KeyValueFragmentDoc}
${XcMediaRefFragmentDoc}`;
export const EufePageFragmentDoc = gql`
    fragment EufePage on EufePageType {
  id
  name
  subtitle
  callout
  navLabel
  isEditable
  nestedPanels {
    id
    blocks(editable: $isXcEditor) {
      ...XCNwBlock
    }
  }
  panels {
    id
    blocks(editable: $isXcEditor) {
      ...XCNwBlock
    }
  }
}
    ${XcNwBlockFragmentDoc}`;
export const GenericCodeFragmentDoc = gql`
    fragment GenericCode on XCGenericCodeDataType {
  genericCode
  pages {
    ...EufePage
  }
}
    ${EufePageFragmentDoc}`;
export const ExternalLinkDataFragmentDoc = gql`
    fragment ExternalLinkData on XCExternalLinkDataType {
  ogTitle
  ogType
  ogDescription
  ogVideo
  url
}
    `;
export const XcRecordFragmentDoc = gql`
    fragment XCRecord on XCFolderDocumentInterface {
  ...XCRecordBase
  ctaBar {
    ...CtaBar
  }
  xcMediaRef {
    ...XCMediaRef
  }
  externalLinkDisclaimerConfig {
    ...ExternalLinkDisclaimerConfig
  }
  xcTheme {
    ...XCTheme
  }
  ... on XCSeDataType {
    expose: data {
      id
      identifier
      disclaimers
      interneNummer
      archived
      reserviert
      keyVisual: mediaRef {
        ...XCMediaRef
      }
    }
  }
  ... on XCCCCupraDataType {
    pages {
      ...EufePage
    }
  }
  ... on XCCCSeatDataType {
    pages {
      ...EufePage
    }
  }
  ... on XCDgaDataAudiType {
    pages {
      ...EufePage
    }
  }
  ... on XCDgaDataVwnType {
    pages {
      ...EufePage
    }
  }
  ... on XCDgaDataVwType {
    pages {
      ...EufePage
    }
  }
  ... on XCGenericCodeDataType {
    ...GenericCode
  }
  ... on XCUploadDataImageGalleryType {
    pages {
      ...EufePage
    }
  }
  ... on XCUploadDataAttachmentType {
    pages {
      ...EufePage
    }
  }
  ... on XCNwDataType {
    selectedPageIds
    document {
      id
      identifier
      disclaimers
      brandId
    }
  }
  ... on XCExternalLinkDataType {
    ...ExternalLinkData
  }
}
    ${XcRecordBaseFragmentDoc}
${CtaBarFragmentDoc}
${XcMediaRefFragmentDoc}
${ExternalLinkDisclaimerConfigFragmentDoc}
${XcThemeFragmentDoc}
${EufePageFragmentDoc}
${GenericCodeFragmentDoc}
${ExternalLinkDataFragmentDoc}`;
export const SealFragmentDoc = gql`
    fragment Seal on SealType {
  id
  description
  logo {
    ...XCMediaRef
  }
  logoPosition
  video {
    src
    provider
    thumbnail
  }
  websiteUrl
  accordion {
    title
    description
    attachments {
      id
      label: key
      href: value
    }
    footnotes {
      id
      key
      text: value
    }
  }
}
    ${XcMediaRefFragmentDoc}`;
export const ExposeDataFragmentDoc = gql`
    fragment ExposeData on MobRecordType {
  id
  identifier
  fullName
  reserviert
  interneNummer
  keyVisual: mediaRef {
    ...XCMediaRef
  }
  mediaRefs {
    ...XCMediaRef
  }
  videoUrl
  niceName: fullName(nice: true)
  archived
  seal {
    ...Seal
  }
  pages {
    ...EufePage
  }
  disclaimers
}
    ${XcMediaRefFragmentDoc}
${SealFragmentDoc}
${EufePageFragmentDoc}`;
export const ContactPersonFragmentDoc = gql`
    fragment ContactPerson on MemberType {
  id
  fullName
  firstName
  email
  salutation
  displayEmail
  lastName
  mobile
  phone
  fax
  thumbnail
  title
  vcard
  video {
    src
    provider
    thumbnail
  }
  isCampaignUser
}
    `;
export const LegalTextFragmentDoc = gql`
    fragment LegalText on LegalTextType {
  id
  rendered
}
    `;
export const CookieOptionFragmentDoc = gql`
    fragment CookieOption on CookieOptionType {
  id
  default
  headline
  key
  text
  vital
}
    `;
export const OfficeFragmentDoc = gql`
    fragment Office on OfficeType {
  id
  street
  zipcode
  addressLine2
  addressLine1
  city
  thumbnailUrl(placeholder: false, size: ORIGINAL)
  seOfficeVideo {
    src
    provider
    thumbnail
  }
  googleMapsUrl: socialUrl(social: GOOGLE_MAPS)
  stockUrl: socialUrl(social: STOCK)
  imprintUrl
  privacyStatement {
    ...LegalText
  }
  cookieContext {
    id
    cookiePolicy {
      ...LegalText
    }
    blocking
    text
    overlayHeadline
    overlayText
    cookieOptions {
      ...CookieOption
    }
  }
  xcTheme {
    ...XCTheme
  }
  logoLabel
  logo {
    ...XCMediaRef
  }
}
    ${LegalTextFragmentDoc}
${CookieOptionFragmentDoc}
${XcThemeFragmentDoc}
${XcMediaRefFragmentDoc}`;
export const ExposeFolderFragmentDoc = gql`
    fragment ExposeFolder on ExposeFolderType {
  id
  slug
  salutationType
  salutationText
  salutation
  created
  lastEdit
  organizationId
  contactPerson {
    ...ContactPerson
  }
  office {
    ...Office
  }
  xcRecords {
    ...XCRecordBase
  }
}
    ${ContactPersonFragmentDoc}
${OfficeFragmentDoc}
${XcRecordBaseFragmentDoc}`;
export const XcNwDataFragmentDoc = gql`
    fragment XCNwData on DocumentType {
  id
  identifier
  displayName
  brandId
  disclaimers
  pages(editable: $isXcEditor) {
    ...EufePage
  }
  xcMediaLibrary @include(if: $isXcEditor) {
    ...XCMediaRef
  }
  inlineDisclaimers {
    ...XCDisclaimerInterface
  }
  externalLinkDisclaimerConfig {
    ...ExternalLinkDisclaimerConfig
  }
  xcTheme {
    ...XCTheme
  }
}
    ${EufePageFragmentDoc}
${XcMediaRefFragmentDoc}
${XcDisclaimerInterfaceFragmentDoc}
${ExternalLinkDisclaimerConfigFragmentDoc}
${XcThemeFragmentDoc}`;
export const ContentLandingPageProjectFragmentDoc = gql`
    fragment ContentLandingPageProject on ContentLandingPageProjectType {
  active @include(if: $isCufeApp)
  created @include(if: $isCufeApp)
  updated @include(if: $isCufeApp)
  name
  organizationId
  office {
    ...Office
  }
  xcTheme {
    ...XCTheme
  }
}
    ${OfficeFragmentDoc}
${XcThemeFragmentDoc}`;
export const ContentLandingPageFragmentDoc = gql`
    fragment ContentLandingPage on ContentLandingPageType {
  active @include(if: $isCufeApp)
  created @include(if: $isCufeApp)
  updated @include(if: $isCufeApp)
  document {
    ...XCNwData
  }
  project {
    ...ContentLandingPageProject
  }
  ctaBar {
    ...CtaBar
  }
}
    ${XcNwDataFragmentDoc}
${ContentLandingPageProjectFragmentDoc}
${CtaBarFragmentDoc}`;
export const UserAgentFragmentDoc = gql`
    fragment UserAgent on UserAgentType {
  uaString
  os
  browser
  device
  isTablet
  isMobile
  isTouchCapable
  isPc
  isEmailClient
  isBot
}
    `;
export const UpdateMemberSelfDocument = gql`
    mutation UpdateMemberSelf($memberInput: UpdateMemberSelfInput!) {
  updateMemberSelf(memberInput: $memberInput) {
    ...MemberProfile
  }
}
    ${MemberProfileFragmentDoc}`;
export type UpdateMemberSelfMutationFn = Apollo.MutationFunction<UpdateMemberSelfMutation, UpdateMemberSelfMutationVariables>;

/**
 * __useUpdateMemberSelfMutation__
 *
 * To run a mutation, you first call `useUpdateMemberSelfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberSelfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberSelfMutation, { data, loading, error }] = useUpdateMemberSelfMutation({
 *   variables: {
 *      memberInput: // value for 'memberInput'
 *   },
 * });
 */
export function useUpdateMemberSelfMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberSelfMutation, UpdateMemberSelfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberSelfMutation, UpdateMemberSelfMutationVariables>(UpdateMemberSelfDocument, options);
      }
export type UpdateMemberSelfMutationHookResult = ReturnType<typeof useUpdateMemberSelfMutation>;
export type UpdateMemberSelfMutationResult = Apollo.MutationResult<UpdateMemberSelfMutation>;
export type UpdateMemberSelfMutationOptions = Apollo.BaseMutationOptions<UpdateMemberSelfMutation, UpdateMemberSelfMutationVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($password: String!, $oldPassword: String) {
  setPassword(password: $password, oldPassword: $oldPassword) {
    ... on ErrorType {
      ...Error
    }
    ... on SuccessType {
      ...Success
    }
  }
}
    ${ErrorFragmentDoc}
${SuccessFragmentDoc}`;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      oldPassword: // value for 'oldPassword'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const SendPasswordResetEmailDocument = gql`
    mutation SendPasswordResetEmail {
  sendPasswordResetEmail
}
    `;
export type SendPasswordResetEmailMutationFn = Apollo.MutationFunction<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;

/**
 * __useSendPasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetEmailMutation, { data, loading, error }] = useSendPasswordResetEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendPasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, options);
      }
export type SendPasswordResetEmailMutationHookResult = ReturnType<typeof useSendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationResult = Apollo.MutationResult<SendPasswordResetEmailMutation>;
export type SendPasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>;
export const PublishDocumentDocument = gql`
    mutation PublishDocument($documentVersionId: ID!, $isXcEditor: Boolean = false, $isThemeEditor: Boolean = false) {
  publishDocument(documentVersionId: $documentVersionId) {
    ...XCNwData
    editVersionId
  }
}
    ${XcNwDataFragmentDoc}`;
export type PublishDocumentMutationFn = Apollo.MutationFunction<PublishDocumentMutation, PublishDocumentMutationVariables>;

/**
 * __usePublishDocumentMutation__
 *
 * To run a mutation, you first call `usePublishDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishDocumentMutation, { data, loading, error }] = usePublishDocumentMutation({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      isXcEditor: // value for 'isXcEditor'
 *      isThemeEditor: // value for 'isThemeEditor'
 *   },
 * });
 */
export function usePublishDocumentMutation(baseOptions?: Apollo.MutationHookOptions<PublishDocumentMutation, PublishDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishDocumentMutation, PublishDocumentMutationVariables>(PublishDocumentDocument, options);
      }
export type PublishDocumentMutationHookResult = ReturnType<typeof usePublishDocumentMutation>;
export type PublishDocumentMutationResult = Apollo.MutationResult<PublishDocumentMutation>;
export type PublishDocumentMutationOptions = Apollo.BaseMutationOptions<PublishDocumentMutation, PublishDocumentMutationVariables>;
export const DeletePageDocument = gql`
    mutation DeletePage($documentVersionId: ID!, $pageId: ID!) {
  deletePage(documentVersionId: $documentVersionId, pageId: $pageId)
}
    `;
export type DeletePageMutationFn = Apollo.MutationFunction<DeletePageMutation, DeletePageMutationVariables>;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      pageId: // value for 'pageId'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageMutation, DeletePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageDocument, options);
      }
export type DeletePageMutationHookResult = ReturnType<typeof useDeletePageMutation>;
export type DeletePageMutationResult = Apollo.MutationResult<DeletePageMutation>;
export type DeletePageMutationOptions = Apollo.BaseMutationOptions<DeletePageMutation, DeletePageMutationVariables>;
export const CreateOrUpdatePageDocument = gql`
    mutation CreateOrUpdatePage($data: PageInput!, $isXcEditor: Boolean = false) {
  createOrUpdatePage(data: $data) {
    ...EufePage
  }
}
    ${EufePageFragmentDoc}`;
export type CreateOrUpdatePageMutationFn = Apollo.MutationFunction<CreateOrUpdatePageMutation, CreateOrUpdatePageMutationVariables>;

/**
 * __useCreateOrUpdatePageMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdatePageMutation, { data, loading, error }] = useCreateOrUpdatePageMutation({
 *   variables: {
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdatePageMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdatePageMutation, CreateOrUpdatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdatePageMutation, CreateOrUpdatePageMutationVariables>(CreateOrUpdatePageDocument, options);
      }
export type CreateOrUpdatePageMutationHookResult = ReturnType<typeof useCreateOrUpdatePageMutation>;
export type CreateOrUpdatePageMutationResult = Apollo.MutationResult<CreateOrUpdatePageMutation>;
export type CreateOrUpdatePageMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdatePageMutation, CreateOrUpdatePageMutationVariables>;
export const MoveBlockDocument = gql`
    mutation MoveBlock($meta: BlockMetaInput!, $isXcEditor: Boolean = false) {
  moveBlock(meta: $meta) {
    ...Panel
  }
}
    ${PanelFragmentDoc}`;
export type MoveBlockMutationFn = Apollo.MutationFunction<MoveBlockMutation, MoveBlockMutationVariables>;

/**
 * __useMoveBlockMutation__
 *
 * To run a mutation, you first call `useMoveBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveBlockMutation, { data, loading, error }] = useMoveBlockMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useMoveBlockMutation(baseOptions?: Apollo.MutationHookOptions<MoveBlockMutation, MoveBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveBlockMutation, MoveBlockMutationVariables>(MoveBlockDocument, options);
      }
export type MoveBlockMutationHookResult = ReturnType<typeof useMoveBlockMutation>;
export type MoveBlockMutationResult = Apollo.MutationResult<MoveBlockMutation>;
export type MoveBlockMutationOptions = Apollo.BaseMutationOptions<MoveBlockMutation, MoveBlockMutationVariables>;
export const DeleteBlockDocument = gql`
    mutation DeleteBlock($blockId: ID!, $documentVersionId: ID!) {
  deleteBlock(blockId: $blockId, documentVersionId: $documentVersionId)
}
    `;
export type DeleteBlockMutationFn = Apollo.MutationFunction<DeleteBlockMutation, DeleteBlockMutationVariables>;

/**
 * __useDeleteBlockMutation__
 *
 * To run a mutation, you first call `useDeleteBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockMutation, { data, loading, error }] = useDeleteBlockMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *      documentVersionId: // value for 'documentVersionId'
 *   },
 * });
 */
export function useDeleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBlockMutation, DeleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBlockMutation, DeleteBlockMutationVariables>(DeleteBlockDocument, options);
      }
export type DeleteBlockMutationHookResult = ReturnType<typeof useDeleteBlockMutation>;
export type DeleteBlockMutationResult = Apollo.MutationResult<DeleteBlockMutation>;
export type DeleteBlockMutationOptions = Apollo.BaseMutationOptions<DeleteBlockMutation, DeleteBlockMutationVariables>;
export const CreateOrUpdateBlockDividerDocument = gql`
    mutation CreateOrUpdateBlockDivider($meta: BlockMetaInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockDivider(meta: $meta) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockDividerMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockDividerMutation, CreateOrUpdateBlockDividerMutationVariables>;

/**
 * __useCreateOrUpdateBlockDividerMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockDividerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockDividerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockDividerMutation, { data, loading, error }] = useCreateOrUpdateBlockDividerMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockDividerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockDividerMutation, CreateOrUpdateBlockDividerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockDividerMutation, CreateOrUpdateBlockDividerMutationVariables>(CreateOrUpdateBlockDividerDocument, options);
      }
export type CreateOrUpdateBlockDividerMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockDividerMutation>;
export type CreateOrUpdateBlockDividerMutationResult = Apollo.MutationResult<CreateOrUpdateBlockDividerMutation>;
export type CreateOrUpdateBlockDividerMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockDividerMutation, CreateOrUpdateBlockDividerMutationVariables>;
export const CreateOrUpdateBlockChapterOpenerDocument = gql`
    mutation CreateOrUpdateBlockChapterOpener($meta: BlockMetaInput!, $data: BlockChapterOpenerInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockChapterOpener(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockChapterOpenerMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockChapterOpenerMutation, CreateOrUpdateBlockChapterOpenerMutationVariables>;

/**
 * __useCreateOrUpdateBlockChapterOpenerMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockChapterOpenerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockChapterOpenerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockChapterOpenerMutation, { data, loading, error }] = useCreateOrUpdateBlockChapterOpenerMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockChapterOpenerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockChapterOpenerMutation, CreateOrUpdateBlockChapterOpenerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockChapterOpenerMutation, CreateOrUpdateBlockChapterOpenerMutationVariables>(CreateOrUpdateBlockChapterOpenerDocument, options);
      }
export type CreateOrUpdateBlockChapterOpenerMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockChapterOpenerMutation>;
export type CreateOrUpdateBlockChapterOpenerMutationResult = Apollo.MutationResult<CreateOrUpdateBlockChapterOpenerMutation>;
export type CreateOrUpdateBlockChapterOpenerMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockChapterOpenerMutation, CreateOrUpdateBlockChapterOpenerMutationVariables>;
export const CreateOrUpdateBlockRichTextDocument = gql`
    mutation CreateOrUpdateBlockRichText($meta: BlockMetaInput!, $data: BlockRichTextInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockRichText(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockRichTextMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockRichTextMutation, CreateOrUpdateBlockRichTextMutationVariables>;

/**
 * __useCreateOrUpdateBlockRichTextMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockRichTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockRichTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockRichTextMutation, { data, loading, error }] = useCreateOrUpdateBlockRichTextMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockRichTextMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockRichTextMutation, CreateOrUpdateBlockRichTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockRichTextMutation, CreateOrUpdateBlockRichTextMutationVariables>(CreateOrUpdateBlockRichTextDocument, options);
      }
export type CreateOrUpdateBlockRichTextMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockRichTextMutation>;
export type CreateOrUpdateBlockRichTextMutationResult = Apollo.MutationResult<CreateOrUpdateBlockRichTextMutation>;
export type CreateOrUpdateBlockRichTextMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockRichTextMutation, CreateOrUpdateBlockRichTextMutationVariables>;
export const CreateOrUpdateBlockVideoDocument = gql`
    mutation CreateOrUpdateBlockVideo($meta: BlockMetaInput!, $data: BlockVideoInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockVideo(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockVideoMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockVideoMutation, CreateOrUpdateBlockVideoMutationVariables>;

/**
 * __useCreateOrUpdateBlockVideoMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockVideoMutation, { data, loading, error }] = useCreateOrUpdateBlockVideoMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockVideoMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockVideoMutation, CreateOrUpdateBlockVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockVideoMutation, CreateOrUpdateBlockVideoMutationVariables>(CreateOrUpdateBlockVideoDocument, options);
      }
export type CreateOrUpdateBlockVideoMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockVideoMutation>;
export type CreateOrUpdateBlockVideoMutationResult = Apollo.MutationResult<CreateOrUpdateBlockVideoMutation>;
export type CreateOrUpdateBlockVideoMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockVideoMutation, CreateOrUpdateBlockVideoMutationVariables>;
export const CreateOrUpdateBlockVideoWithDescriptionDocument = gql`
    mutation CreateOrUpdateBlockVideoWithDescription($meta: BlockMetaInput!, $data: BlockVideoWithDescriptionInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockVideoWithDescription(
    meta: $meta
    data: $data
  ) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockVideoWithDescriptionMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockVideoWithDescriptionMutation, CreateOrUpdateBlockVideoWithDescriptionMutationVariables>;

/**
 * __useCreateOrUpdateBlockVideoWithDescriptionMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockVideoWithDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockVideoWithDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockVideoWithDescriptionMutation, { data, loading, error }] = useCreateOrUpdateBlockVideoWithDescriptionMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockVideoWithDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockVideoWithDescriptionMutation, CreateOrUpdateBlockVideoWithDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockVideoWithDescriptionMutation, CreateOrUpdateBlockVideoWithDescriptionMutationVariables>(CreateOrUpdateBlockVideoWithDescriptionDocument, options);
      }
export type CreateOrUpdateBlockVideoWithDescriptionMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockVideoWithDescriptionMutation>;
export type CreateOrUpdateBlockVideoWithDescriptionMutationResult = Apollo.MutationResult<CreateOrUpdateBlockVideoWithDescriptionMutation>;
export type CreateOrUpdateBlockVideoWithDescriptionMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockVideoWithDescriptionMutation, CreateOrUpdateBlockVideoWithDescriptionMutationVariables>;
export const CreateOrUpdateBlockMediaSingleImageDocument = gql`
    mutation CreateOrUpdateBlockMediaSingleImage($meta: BlockMetaInput!, $data: BlockMediaSingleImageInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockMediaSingleImage(
    meta: $meta
    data: $data
  ) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockMediaSingleImageMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockMediaSingleImageMutation, CreateOrUpdateBlockMediaSingleImageMutationVariables>;

/**
 * __useCreateOrUpdateBlockMediaSingleImageMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockMediaSingleImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockMediaSingleImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockMediaSingleImageMutation, { data, loading, error }] = useCreateOrUpdateBlockMediaSingleImageMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockMediaSingleImageMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockMediaSingleImageMutation, CreateOrUpdateBlockMediaSingleImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockMediaSingleImageMutation, CreateOrUpdateBlockMediaSingleImageMutationVariables>(CreateOrUpdateBlockMediaSingleImageDocument, options);
      }
export type CreateOrUpdateBlockMediaSingleImageMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockMediaSingleImageMutation>;
export type CreateOrUpdateBlockMediaSingleImageMutationResult = Apollo.MutationResult<CreateOrUpdateBlockMediaSingleImageMutation>;
export type CreateOrUpdateBlockMediaSingleImageMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockMediaSingleImageMutation, CreateOrUpdateBlockMediaSingleImageMutationVariables>;
export const CreateOrUpdateBlockMediaComparisonSliderDocument = gql`
    mutation CreateOrUpdateBlockMediaComparisonSlider($meta: BlockMetaInput!, $data: BlockMediaComparisonSliderInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockMediaComparisonSlider(
    meta: $meta
    data: $data
  ) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockMediaComparisonSliderMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockMediaComparisonSliderMutation, CreateOrUpdateBlockMediaComparisonSliderMutationVariables>;

/**
 * __useCreateOrUpdateBlockMediaComparisonSliderMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockMediaComparisonSliderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockMediaComparisonSliderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockMediaComparisonSliderMutation, { data, loading, error }] = useCreateOrUpdateBlockMediaComparisonSliderMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockMediaComparisonSliderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockMediaComparisonSliderMutation, CreateOrUpdateBlockMediaComparisonSliderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockMediaComparisonSliderMutation, CreateOrUpdateBlockMediaComparisonSliderMutationVariables>(CreateOrUpdateBlockMediaComparisonSliderDocument, options);
      }
export type CreateOrUpdateBlockMediaComparisonSliderMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockMediaComparisonSliderMutation>;
export type CreateOrUpdateBlockMediaComparisonSliderMutationResult = Apollo.MutationResult<CreateOrUpdateBlockMediaComparisonSliderMutation>;
export type CreateOrUpdateBlockMediaComparisonSliderMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockMediaComparisonSliderMutation, CreateOrUpdateBlockMediaComparisonSliderMutationVariables>;
export const CreateOrUpdateBlockMediaGalleryDocument = gql`
    mutation CreateOrUpdateBlockMediaGallery($meta: BlockMetaInput!, $data: BlockMediaGalleryInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockMediaGallery(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockMediaGalleryMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockMediaGalleryMutation, CreateOrUpdateBlockMediaGalleryMutationVariables>;

/**
 * __useCreateOrUpdateBlockMediaGalleryMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockMediaGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockMediaGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockMediaGalleryMutation, { data, loading, error }] = useCreateOrUpdateBlockMediaGalleryMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockMediaGalleryMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockMediaGalleryMutation, CreateOrUpdateBlockMediaGalleryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockMediaGalleryMutation, CreateOrUpdateBlockMediaGalleryMutationVariables>(CreateOrUpdateBlockMediaGalleryDocument, options);
      }
export type CreateOrUpdateBlockMediaGalleryMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockMediaGalleryMutation>;
export type CreateOrUpdateBlockMediaGalleryMutationResult = Apollo.MutationResult<CreateOrUpdateBlockMediaGalleryMutation>;
export type CreateOrUpdateBlockMediaGalleryMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockMediaGalleryMutation, CreateOrUpdateBlockMediaGalleryMutationVariables>;
export const CreateOrUpdateBlockAwardRowDocument = gql`
    mutation CreateOrUpdateBlockAwardRow($meta: BlockMetaInput!, $data: [BlockAwardInput!]!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockAwardRow(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockAwardRowMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockAwardRowMutation, CreateOrUpdateBlockAwardRowMutationVariables>;

/**
 * __useCreateOrUpdateBlockAwardRowMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockAwardRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockAwardRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockAwardRowMutation, { data, loading, error }] = useCreateOrUpdateBlockAwardRowMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockAwardRowMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockAwardRowMutation, CreateOrUpdateBlockAwardRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockAwardRowMutation, CreateOrUpdateBlockAwardRowMutationVariables>(CreateOrUpdateBlockAwardRowDocument, options);
      }
export type CreateOrUpdateBlockAwardRowMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockAwardRowMutation>;
export type CreateOrUpdateBlockAwardRowMutationResult = Apollo.MutationResult<CreateOrUpdateBlockAwardRowMutation>;
export type CreateOrUpdateBlockAwardRowMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockAwardRowMutation, CreateOrUpdateBlockAwardRowMutationVariables>;
export const CreateOrUpdateBlockAppDownloadDocument = gql`
    mutation CreateOrUpdateBlockAppDownload($meta: BlockMetaInput!, $data: BlockAppDownloadInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockAppDownload(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockAppDownloadMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockAppDownloadMutation, CreateOrUpdateBlockAppDownloadMutationVariables>;

/**
 * __useCreateOrUpdateBlockAppDownloadMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockAppDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockAppDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockAppDownloadMutation, { data, loading, error }] = useCreateOrUpdateBlockAppDownloadMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockAppDownloadMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockAppDownloadMutation, CreateOrUpdateBlockAppDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockAppDownloadMutation, CreateOrUpdateBlockAppDownloadMutationVariables>(CreateOrUpdateBlockAppDownloadDocument, options);
      }
export type CreateOrUpdateBlockAppDownloadMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockAppDownloadMutation>;
export type CreateOrUpdateBlockAppDownloadMutationResult = Apollo.MutationResult<CreateOrUpdateBlockAppDownloadMutation>;
export type CreateOrUpdateBlockAppDownloadMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockAppDownloadMutation, CreateOrUpdateBlockAppDownloadMutationVariables>;
export const CreateOrUpdateBlockHighlightDocument = gql`
    mutation CreateOrUpdateBlockHighlight($meta: BlockMetaInput!, $data: BlockHighlightInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockHighlight(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockHighlightMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockHighlightMutation, CreateOrUpdateBlockHighlightMutationVariables>;

/**
 * __useCreateOrUpdateBlockHighlightMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockHighlightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockHighlightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockHighlightMutation, { data, loading, error }] = useCreateOrUpdateBlockHighlightMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockHighlightMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockHighlightMutation, CreateOrUpdateBlockHighlightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockHighlightMutation, CreateOrUpdateBlockHighlightMutationVariables>(CreateOrUpdateBlockHighlightDocument, options);
      }
export type CreateOrUpdateBlockHighlightMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockHighlightMutation>;
export type CreateOrUpdateBlockHighlightMutationResult = Apollo.MutationResult<CreateOrUpdateBlockHighlightMutation>;
export type CreateOrUpdateBlockHighlightMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockHighlightMutation, CreateOrUpdateBlockHighlightMutationVariables>;
export const CreateOrUpdateBlockBannerDocument = gql`
    mutation CreateOrUpdateBlockBanner($meta: BlockMetaInput!, $data: BlockBannerInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockBanner(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockBannerMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockBannerMutation, CreateOrUpdateBlockBannerMutationVariables>;

/**
 * __useCreateOrUpdateBlockBannerMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockBannerMutation, { data, loading, error }] = useCreateOrUpdateBlockBannerMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockBannerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockBannerMutation, CreateOrUpdateBlockBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockBannerMutation, CreateOrUpdateBlockBannerMutationVariables>(CreateOrUpdateBlockBannerDocument, options);
      }
export type CreateOrUpdateBlockBannerMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockBannerMutation>;
export type CreateOrUpdateBlockBannerMutationResult = Apollo.MutationResult<CreateOrUpdateBlockBannerMutation>;
export type CreateOrUpdateBlockBannerMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockBannerMutation, CreateOrUpdateBlockBannerMutationVariables>;
export const CreateOrUpdateBlockKeyFactDocument = gql`
    mutation CreateOrUpdateBlockKeyFact($meta: BlockMetaInput!, $data: BlockKeyFactInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockKeyFact(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockKeyFactMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockKeyFactMutation, CreateOrUpdateBlockKeyFactMutationVariables>;

/**
 * __useCreateOrUpdateBlockKeyFactMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockKeyFactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockKeyFactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockKeyFactMutation, { data, loading, error }] = useCreateOrUpdateBlockKeyFactMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockKeyFactMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockKeyFactMutation, CreateOrUpdateBlockKeyFactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockKeyFactMutation, CreateOrUpdateBlockKeyFactMutationVariables>(CreateOrUpdateBlockKeyFactDocument, options);
      }
export type CreateOrUpdateBlockKeyFactMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockKeyFactMutation>;
export type CreateOrUpdateBlockKeyFactMutationResult = Apollo.MutationResult<CreateOrUpdateBlockKeyFactMutation>;
export type CreateOrUpdateBlockKeyFactMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockKeyFactMutation, CreateOrUpdateBlockKeyFactMutationVariables>;
export const CreateOrUpdateBlockKeyFactSmallDocument = gql`
    mutation CreateOrUpdateBlockKeyFactSmall($meta: BlockMetaInput!, $data: [BlockKeyFactSmallInput!]!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockKeyFactSmall(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockKeyFactSmallMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockKeyFactSmallMutation, CreateOrUpdateBlockKeyFactSmallMutationVariables>;

/**
 * __useCreateOrUpdateBlockKeyFactSmallMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockKeyFactSmallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockKeyFactSmallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockKeyFactSmallMutation, { data, loading, error }] = useCreateOrUpdateBlockKeyFactSmallMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockKeyFactSmallMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockKeyFactSmallMutation, CreateOrUpdateBlockKeyFactSmallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockKeyFactSmallMutation, CreateOrUpdateBlockKeyFactSmallMutationVariables>(CreateOrUpdateBlockKeyFactSmallDocument, options);
      }
export type CreateOrUpdateBlockKeyFactSmallMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockKeyFactSmallMutation>;
export type CreateOrUpdateBlockKeyFactSmallMutationResult = Apollo.MutationResult<CreateOrUpdateBlockKeyFactSmallMutation>;
export type CreateOrUpdateBlockKeyFactSmallMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockKeyFactSmallMutation, CreateOrUpdateBlockKeyFactSmallMutationVariables>;
export const CreateOrUpdateBlockKpiDocument = gql`
    mutation CreateOrUpdateBlockKpi($meta: BlockMetaInput!, $data: [BlockKpiInput!]!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockKpi(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockKpiMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockKpiMutation, CreateOrUpdateBlockKpiMutationVariables>;

/**
 * __useCreateOrUpdateBlockKpiMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockKpiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockKpiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockKpiMutation, { data, loading, error }] = useCreateOrUpdateBlockKpiMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockKpiMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockKpiMutation, CreateOrUpdateBlockKpiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockKpiMutation, CreateOrUpdateBlockKpiMutationVariables>(CreateOrUpdateBlockKpiDocument, options);
      }
export type CreateOrUpdateBlockKpiMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockKpiMutation>;
export type CreateOrUpdateBlockKpiMutationResult = Apollo.MutationResult<CreateOrUpdateBlockKpiMutation>;
export type CreateOrUpdateBlockKpiMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockKpiMutation, CreateOrUpdateBlockKpiMutationVariables>;
export const CreateOrUpdateBlockVehicleDataDocument = gql`
    mutation CreateOrUpdateBlockVehicleData($meta: BlockMetaInput!, $data: [BlockVehicleDataInput!]!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockVehicleData(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockVehicleDataMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockVehicleDataMutation, CreateOrUpdateBlockVehicleDataMutationVariables>;

/**
 * __useCreateOrUpdateBlockVehicleDataMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockVehicleDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockVehicleDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockVehicleDataMutation, { data, loading, error }] = useCreateOrUpdateBlockVehicleDataMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockVehicleDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockVehicleDataMutation, CreateOrUpdateBlockVehicleDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockVehicleDataMutation, CreateOrUpdateBlockVehicleDataMutationVariables>(CreateOrUpdateBlockVehicleDataDocument, options);
      }
export type CreateOrUpdateBlockVehicleDataMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockVehicleDataMutation>;
export type CreateOrUpdateBlockVehicleDataMutationResult = Apollo.MutationResult<CreateOrUpdateBlockVehicleDataMutation>;
export type CreateOrUpdateBlockVehicleDataMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockVehicleDataMutation, CreateOrUpdateBlockVehicleDataMutationVariables>;
export const CreateOrUpdateBlockButtonRowDocument = gql`
    mutation CreateOrUpdateBlockButtonRow($meta: BlockMetaInput!, $data: [BlockButtonInput!]!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockButtonRow(data: $data, meta: $meta) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockButtonRowMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockButtonRowMutation, CreateOrUpdateBlockButtonRowMutationVariables>;

/**
 * __useCreateOrUpdateBlockButtonRowMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockButtonRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockButtonRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockButtonRowMutation, { data, loading, error }] = useCreateOrUpdateBlockButtonRowMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockButtonRowMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockButtonRowMutation, CreateOrUpdateBlockButtonRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockButtonRowMutation, CreateOrUpdateBlockButtonRowMutationVariables>(CreateOrUpdateBlockButtonRowDocument, options);
      }
export type CreateOrUpdateBlockButtonRowMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockButtonRowMutation>;
export type CreateOrUpdateBlockButtonRowMutationResult = Apollo.MutationResult<CreateOrUpdateBlockButtonRowMutation>;
export type CreateOrUpdateBlockButtonRowMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockButtonRowMutation, CreateOrUpdateBlockButtonRowMutationVariables>;
export const CreateOrUpdateBlockExternalLinkDocument = gql`
    mutation CreateOrUpdateBlockExternalLink($meta: BlockMetaInput!, $data: BlockExternalLinkInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockExternalLink(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockExternalLinkMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockExternalLinkMutation, CreateOrUpdateBlockExternalLinkMutationVariables>;

/**
 * __useCreateOrUpdateBlockExternalLinkMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockExternalLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockExternalLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockExternalLinkMutation, { data, loading, error }] = useCreateOrUpdateBlockExternalLinkMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockExternalLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockExternalLinkMutation, CreateOrUpdateBlockExternalLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockExternalLinkMutation, CreateOrUpdateBlockExternalLinkMutationVariables>(CreateOrUpdateBlockExternalLinkDocument, options);
      }
export type CreateOrUpdateBlockExternalLinkMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockExternalLinkMutation>;
export type CreateOrUpdateBlockExternalLinkMutationResult = Apollo.MutationResult<CreateOrUpdateBlockExternalLinkMutation>;
export type CreateOrUpdateBlockExternalLinkMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockExternalLinkMutation, CreateOrUpdateBlockExternalLinkMutationVariables>;
export const CreateOrUpdateBlockAccordionDocument = gql`
    mutation CreateOrUpdateBlockAccordion($meta: BlockMetaInput!, $data: [BlockAccordionSectionInput!]!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockAccordion(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockAccordionMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockAccordionMutation, CreateOrUpdateBlockAccordionMutationVariables>;

/**
 * __useCreateOrUpdateBlockAccordionMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockAccordionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockAccordionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockAccordionMutation, { data, loading, error }] = useCreateOrUpdateBlockAccordionMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockAccordionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockAccordionMutation, CreateOrUpdateBlockAccordionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockAccordionMutation, CreateOrUpdateBlockAccordionMutationVariables>(CreateOrUpdateBlockAccordionDocument, options);
      }
export type CreateOrUpdateBlockAccordionMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockAccordionMutation>;
export type CreateOrUpdateBlockAccordionMutationResult = Apollo.MutationResult<CreateOrUpdateBlockAccordionMutation>;
export type CreateOrUpdateBlockAccordionMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockAccordionMutation, CreateOrUpdateBlockAccordionMutationVariables>;
export const CreateOrUpdateBlockKeyValueTableDocument = gql`
    mutation CreateOrUpdateBlockKeyValueTable($meta: BlockMetaInput!, $data: BlockKeyValueTableInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockKeyValueTable(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockKeyValueTableMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockKeyValueTableMutation, CreateOrUpdateBlockKeyValueTableMutationVariables>;

/**
 * __useCreateOrUpdateBlockKeyValueTableMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockKeyValueTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockKeyValueTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockKeyValueTableMutation, { data, loading, error }] = useCreateOrUpdateBlockKeyValueTableMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockKeyValueTableMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockKeyValueTableMutation, CreateOrUpdateBlockKeyValueTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockKeyValueTableMutation, CreateOrUpdateBlockKeyValueTableMutationVariables>(CreateOrUpdateBlockKeyValueTableDocument, options);
      }
export type CreateOrUpdateBlockKeyValueTableMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockKeyValueTableMutation>;
export type CreateOrUpdateBlockKeyValueTableMutationResult = Apollo.MutationResult<CreateOrUpdateBlockKeyValueTableMutation>;
export type CreateOrUpdateBlockKeyValueTableMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockKeyValueTableMutation, CreateOrUpdateBlockKeyValueTableMutationVariables>;
export const CreateOrUpdateBlockDataSheetDocument = gql`
    mutation CreateOrUpdateBlockDataSheet($meta: BlockMetaInput!, $data: BlockDataSheetInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockDataSheet(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockDataSheetMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockDataSheetMutation, CreateOrUpdateBlockDataSheetMutationVariables>;

/**
 * __useCreateOrUpdateBlockDataSheetMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockDataSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockDataSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockDataSheetMutation, { data, loading, error }] = useCreateOrUpdateBlockDataSheetMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockDataSheetMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockDataSheetMutation, CreateOrUpdateBlockDataSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockDataSheetMutation, CreateOrUpdateBlockDataSheetMutationVariables>(CreateOrUpdateBlockDataSheetDocument, options);
      }
export type CreateOrUpdateBlockDataSheetMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockDataSheetMutation>;
export type CreateOrUpdateBlockDataSheetMutationResult = Apollo.MutationResult<CreateOrUpdateBlockDataSheetMutation>;
export type CreateOrUpdateBlockDataSheetMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockDataSheetMutation, CreateOrUpdateBlockDataSheetMutationVariables>;
export const SetBlockLockDocument = gql`
    mutation SetBlockLock($documentVersionId: ID!, $blockId: ID!, $lockStatus: LockStatusInput) {
  setBlockLock(
    documentVersionId: $documentVersionId
    blockId: $blockId
    lockStatus: $lockStatus
  ) {
    ...LockStatus
  }
}
    ${LockStatusFragmentDoc}`;
export type SetBlockLockMutationFn = Apollo.MutationFunction<SetBlockLockMutation, SetBlockLockMutationVariables>;

/**
 * __useSetBlockLockMutation__
 *
 * To run a mutation, you first call `useSetBlockLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBlockLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBlockLockMutation, { data, loading, error }] = useSetBlockLockMutation({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      blockId: // value for 'blockId'
 *      lockStatus: // value for 'lockStatus'
 *   },
 * });
 */
export function useSetBlockLockMutation(baseOptions?: Apollo.MutationHookOptions<SetBlockLockMutation, SetBlockLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetBlockLockMutation, SetBlockLockMutationVariables>(SetBlockLockDocument, options);
      }
export type SetBlockLockMutationHookResult = ReturnType<typeof useSetBlockLockMutation>;
export type SetBlockLockMutationResult = Apollo.MutationResult<SetBlockLockMutation>;
export type SetBlockLockMutationOptions = Apollo.BaseMutationOptions<SetBlockLockMutation, SetBlockLockMutationVariables>;
export const SetPageLockDocument = gql`
    mutation SetPageLock($documentVersionId: ID!, $pageId: ID!, $lockStatus: LockStatusInput) {
  setPageLock(
    documentVersionId: $documentVersionId
    pageId: $pageId
    lockStatus: $lockStatus
  ) {
    ...LockStatus
  }
}
    ${LockStatusFragmentDoc}`;
export type SetPageLockMutationFn = Apollo.MutationFunction<SetPageLockMutation, SetPageLockMutationVariables>;

/**
 * __useSetPageLockMutation__
 *
 * To run a mutation, you first call `useSetPageLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPageLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPageLockMutation, { data, loading, error }] = useSetPageLockMutation({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      pageId: // value for 'pageId'
 *      lockStatus: // value for 'lockStatus'
 *   },
 * });
 */
export function useSetPageLockMutation(baseOptions?: Apollo.MutationHookOptions<SetPageLockMutation, SetPageLockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPageLockMutation, SetPageLockMutationVariables>(SetPageLockDocument, options);
      }
export type SetPageLockMutationHookResult = ReturnType<typeof useSetPageLockMutation>;
export type SetPageLockMutationResult = Apollo.MutationResult<SetPageLockMutation>;
export type SetPageLockMutationOptions = Apollo.BaseMutationOptions<SetPageLockMutation, SetPageLockMutationVariables>;
export const DeleteThemeDocument = gql`
    mutation DeleteTheme($themeId: ID!) {
  deleteTheme(themeId: $themeId)
}
    `;
export type DeleteThemeMutationFn = Apollo.MutationFunction<DeleteThemeMutation, DeleteThemeMutationVariables>;

/**
 * __useDeleteThemeMutation__
 *
 * To run a mutation, you first call `useDeleteThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThemeMutation, { data, loading, error }] = useDeleteThemeMutation({
 *   variables: {
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useDeleteThemeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThemeMutation, DeleteThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThemeMutation, DeleteThemeMutationVariables>(DeleteThemeDocument, options);
      }
export type DeleteThemeMutationHookResult = ReturnType<typeof useDeleteThemeMutation>;
export type DeleteThemeMutationResult = Apollo.MutationResult<DeleteThemeMutation>;
export type DeleteThemeMutationOptions = Apollo.BaseMutationOptions<DeleteThemeMutation, DeleteThemeMutationVariables>;
export const CreateOrUpdateThemeDocument = gql`
    mutation CreateOrUpdateTheme($themeId: ID, $data: ThemeInput!, $isThemeEditor: Boolean = false) {
  createOrUpdateTheme(themeId: $themeId, data: $data) {
    ...XCTheme
  }
}
    ${XcThemeFragmentDoc}`;
export type CreateOrUpdateThemeMutationFn = Apollo.MutationFunction<CreateOrUpdateThemeMutation, CreateOrUpdateThemeMutationVariables>;

/**
 * __useCreateOrUpdateThemeMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateThemeMutation, { data, loading, error }] = useCreateOrUpdateThemeMutation({
 *   variables: {
 *      themeId: // value for 'themeId'
 *      data: // value for 'data'
 *      isThemeEditor: // value for 'isThemeEditor'
 *   },
 * });
 */
export function useCreateOrUpdateThemeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateThemeMutation, CreateOrUpdateThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateThemeMutation, CreateOrUpdateThemeMutationVariables>(CreateOrUpdateThemeDocument, options);
      }
export type CreateOrUpdateThemeMutationHookResult = ReturnType<typeof useCreateOrUpdateThemeMutation>;
export type CreateOrUpdateThemeMutationResult = Apollo.MutationResult<CreateOrUpdateThemeMutation>;
export type CreateOrUpdateThemeMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateThemeMutation, CreateOrUpdateThemeMutationVariables>;
export const FileToJsonDocument = gql`
    mutation FileToJson($file: Upload!) {
  fileToJson(file: $file)
}
    `;
export type FileToJsonMutationFn = Apollo.MutationFunction<FileToJsonMutation, FileToJsonMutationVariables>;

/**
 * __useFileToJsonMutation__
 *
 * To run a mutation, you first call `useFileToJsonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFileToJsonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fileToJsonMutation, { data, loading, error }] = useFileToJsonMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useFileToJsonMutation(baseOptions?: Apollo.MutationHookOptions<FileToJsonMutation, FileToJsonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FileToJsonMutation, FileToJsonMutationVariables>(FileToJsonDocument, options);
      }
export type FileToJsonMutationHookResult = ReturnType<typeof useFileToJsonMutation>;
export type FileToJsonMutationResult = Apollo.MutationResult<FileToJsonMutation>;
export type FileToJsonMutationOptions = Apollo.BaseMutationOptions<FileToJsonMutation, FileToJsonMutationVariables>;
export const CreateDocumentXcMediaLibraryEntryDocument = gql`
    mutation CreateDocumentXcMediaLibraryEntry($collectionId: ID!, $documentId: ID!, $file: Upload!) {
  createDocumentXcMediaLibraryEntry(
    collectionId: $collectionId
    documentId: $documentId
    file: $file
  ) {
    ...XCMediaRef
  }
}
    ${XcMediaRefFragmentDoc}`;
export type CreateDocumentXcMediaLibraryEntryMutationFn = Apollo.MutationFunction<CreateDocumentXcMediaLibraryEntryMutation, CreateDocumentXcMediaLibraryEntryMutationVariables>;

/**
 * __useCreateDocumentXcMediaLibraryEntryMutation__
 *
 * To run a mutation, you first call `useCreateDocumentXcMediaLibraryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentXcMediaLibraryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentXcMediaLibraryEntryMutation, { data, loading, error }] = useCreateDocumentXcMediaLibraryEntryMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      documentId: // value for 'documentId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateDocumentXcMediaLibraryEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentXcMediaLibraryEntryMutation, CreateDocumentXcMediaLibraryEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentXcMediaLibraryEntryMutation, CreateDocumentXcMediaLibraryEntryMutationVariables>(CreateDocumentXcMediaLibraryEntryDocument, options);
      }
export type CreateDocumentXcMediaLibraryEntryMutationHookResult = ReturnType<typeof useCreateDocumentXcMediaLibraryEntryMutation>;
export type CreateDocumentXcMediaLibraryEntryMutationResult = Apollo.MutationResult<CreateDocumentXcMediaLibraryEntryMutation>;
export type CreateDocumentXcMediaLibraryEntryMutationOptions = Apollo.BaseMutationOptions<CreateDocumentXcMediaLibraryEntryMutation, CreateDocumentXcMediaLibraryEntryMutationVariables>;
export const CreateOrUpdateDocumentDocument = gql`
    mutation CreateOrUpdateDocument($data: CreateUpdateDocumentInput!) {
  createOrUpdateDocument(data: $data) {
    ...CmsCollectionDocument
  }
}
    ${CmsCollectionDocumentFragmentDoc}`;
export type CreateOrUpdateDocumentMutationFn = Apollo.MutationFunction<CreateOrUpdateDocumentMutation, CreateOrUpdateDocumentMutationVariables>;

/**
 * __useCreateOrUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateDocumentMutation, { data, loading, error }] = useCreateOrUpdateDocumentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateDocumentMutation, CreateOrUpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateDocumentMutation, CreateOrUpdateDocumentMutationVariables>(CreateOrUpdateDocumentDocument, options);
      }
export type CreateOrUpdateDocumentMutationHookResult = ReturnType<typeof useCreateOrUpdateDocumentMutation>;
export type CreateOrUpdateDocumentMutationResult = Apollo.MutationResult<CreateOrUpdateDocumentMutation>;
export type CreateOrUpdateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateDocumentMutation, CreateOrUpdateDocumentMutationVariables>;
export const CreateOrUpdateBlockIntegrationDocument = gql`
    mutation CreateOrUpdateBlockIntegration($meta: BlockMetaInput!, $data: BlockIntegrationInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockIntegration(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockIntegrationMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockIntegrationMutation, CreateOrUpdateBlockIntegrationMutationVariables>;

/**
 * __useCreateOrUpdateBlockIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockIntegrationMutation, { data, loading, error }] = useCreateOrUpdateBlockIntegrationMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockIntegrationMutation, CreateOrUpdateBlockIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockIntegrationMutation, CreateOrUpdateBlockIntegrationMutationVariables>(CreateOrUpdateBlockIntegrationDocument, options);
      }
export type CreateOrUpdateBlockIntegrationMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockIntegrationMutation>;
export type CreateOrUpdateBlockIntegrationMutationResult = Apollo.MutationResult<CreateOrUpdateBlockIntegrationMutation>;
export type CreateOrUpdateBlockIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockIntegrationMutation, CreateOrUpdateBlockIntegrationMutationVariables>;
export const CreateOrUpdateBlockDocumentHeaderDocument = gql`
    mutation CreateOrUpdateBlockDocumentHeader($meta: BlockMetaInput!, $data: BlockDocumentHeaderInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockDocumentHeader(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockDocumentHeaderMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockDocumentHeaderMutation, CreateOrUpdateBlockDocumentHeaderMutationVariables>;

/**
 * __useCreateOrUpdateBlockDocumentHeaderMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockDocumentHeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockDocumentHeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockDocumentHeaderMutation, { data, loading, error }] = useCreateOrUpdateBlockDocumentHeaderMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockDocumentHeaderMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockDocumentHeaderMutation, CreateOrUpdateBlockDocumentHeaderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockDocumentHeaderMutation, CreateOrUpdateBlockDocumentHeaderMutationVariables>(CreateOrUpdateBlockDocumentHeaderDocument, options);
      }
export type CreateOrUpdateBlockDocumentHeaderMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockDocumentHeaderMutation>;
export type CreateOrUpdateBlockDocumentHeaderMutationResult = Apollo.MutationResult<CreateOrUpdateBlockDocumentHeaderMutation>;
export type CreateOrUpdateBlockDocumentHeaderMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockDocumentHeaderMutation, CreateOrUpdateBlockDocumentHeaderMutationVariables>;
export const CreateOrUpdateBlockAutoplayDocument = gql`
    mutation CreateOrUpdateBlockAutoplay($meta: BlockMetaInput!, $data: BlockAutoplayInput!, $isXcEditor: Boolean = false) {
  createOrUpdateBlock: createOrUpdateBlockAutoplay(meta: $meta, data: $data) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;
export type CreateOrUpdateBlockAutoplayMutationFn = Apollo.MutationFunction<CreateOrUpdateBlockAutoplayMutation, CreateOrUpdateBlockAutoplayMutationVariables>;

/**
 * __useCreateOrUpdateBlockAutoplayMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateBlockAutoplayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateBlockAutoplayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateBlockAutoplayMutation, { data, loading, error }] = useCreateOrUpdateBlockAutoplayMutation({
 *   variables: {
 *      meta: // value for 'meta'
 *      data: // value for 'data'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useCreateOrUpdateBlockAutoplayMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateBlockAutoplayMutation, CreateOrUpdateBlockAutoplayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateBlockAutoplayMutation, CreateOrUpdateBlockAutoplayMutationVariables>(CreateOrUpdateBlockAutoplayDocument, options);
      }
export type CreateOrUpdateBlockAutoplayMutationHookResult = ReturnType<typeof useCreateOrUpdateBlockAutoplayMutation>;
export type CreateOrUpdateBlockAutoplayMutationResult = Apollo.MutationResult<CreateOrUpdateBlockAutoplayMutation>;
export type CreateOrUpdateBlockAutoplayMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateBlockAutoplayMutation, CreateOrUpdateBlockAutoplayMutationVariables>;
export const DeleteXcDisclaimerDocument = gql`
    mutation DeleteXcDisclaimer($disclaimerId: ID!) {
  deleteXcDisclaimer(disclaimerId: $disclaimerId)
}
    `;
export type DeleteXcDisclaimerMutationFn = Apollo.MutationFunction<DeleteXcDisclaimerMutation, DeleteXcDisclaimerMutationVariables>;

/**
 * __useDeleteXcDisclaimerMutation__
 *
 * To run a mutation, you first call `useDeleteXcDisclaimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteXcDisclaimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteXcDisclaimerMutation, { data, loading, error }] = useDeleteXcDisclaimerMutation({
 *   variables: {
 *      disclaimerId: // value for 'disclaimerId'
 *   },
 * });
 */
export function useDeleteXcDisclaimerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteXcDisclaimerMutation, DeleteXcDisclaimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteXcDisclaimerMutation, DeleteXcDisclaimerMutationVariables>(DeleteXcDisclaimerDocument, options);
      }
export type DeleteXcDisclaimerMutationHookResult = ReturnType<typeof useDeleteXcDisclaimerMutation>;
export type DeleteXcDisclaimerMutationResult = Apollo.MutationResult<DeleteXcDisclaimerMutation>;
export type DeleteXcDisclaimerMutationOptions = Apollo.BaseMutationOptions<DeleteXcDisclaimerMutation, DeleteXcDisclaimerMutationVariables>;
export const CreateOrUpdateXcDisclaimerDocument = gql`
    mutation CreateOrUpdateXcDisclaimer($data: DisclaimerInput!) {
  createOrUpdateXcDisclaimer(data: $data) {
    ...XCDisclaimerInterface
  }
}
    ${XcDisclaimerInterfaceFragmentDoc}`;
export type CreateOrUpdateXcDisclaimerMutationFn = Apollo.MutationFunction<CreateOrUpdateXcDisclaimerMutation, CreateOrUpdateXcDisclaimerMutationVariables>;

/**
 * __useCreateOrUpdateXcDisclaimerMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateXcDisclaimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateXcDisclaimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateXcDisclaimerMutation, { data, loading, error }] = useCreateOrUpdateXcDisclaimerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOrUpdateXcDisclaimerMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateXcDisclaimerMutation, CreateOrUpdateXcDisclaimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateXcDisclaimerMutation, CreateOrUpdateXcDisclaimerMutationVariables>(CreateOrUpdateXcDisclaimerDocument, options);
      }
export type CreateOrUpdateXcDisclaimerMutationHookResult = ReturnType<typeof useCreateOrUpdateXcDisclaimerMutation>;
export type CreateOrUpdateXcDisclaimerMutationResult = Apollo.MutationResult<CreateOrUpdateXcDisclaimerMutation>;
export type CreateOrUpdateXcDisclaimerMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateXcDisclaimerMutation, CreateOrUpdateXcDisclaimerMutationVariables>;
export const ExposeCtaCallbackDocument = gql`
    mutation ExposeCtaCallback($exposeFolderSlug: String!, $recordId: ID!, $data: CtaCallbackDataInput!) {
  exposeCtaCallback(
    exposeFolderSlug: $exposeFolderSlug
    recordId: $recordId
    data: $data
  )
}
    `;
export type ExposeCtaCallbackMutationFn = Apollo.MutationFunction<ExposeCtaCallbackMutation, ExposeCtaCallbackMutationVariables>;

/**
 * __useExposeCtaCallbackMutation__
 *
 * To run a mutation, you first call `useExposeCtaCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExposeCtaCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exposeCtaCallbackMutation, { data, loading, error }] = useExposeCtaCallbackMutation({
 *   variables: {
 *      exposeFolderSlug: // value for 'exposeFolderSlug'
 *      recordId: // value for 'recordId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExposeCtaCallbackMutation(baseOptions?: Apollo.MutationHookOptions<ExposeCtaCallbackMutation, ExposeCtaCallbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExposeCtaCallbackMutation, ExposeCtaCallbackMutationVariables>(ExposeCtaCallbackDocument, options);
      }
export type ExposeCtaCallbackMutationHookResult = ReturnType<typeof useExposeCtaCallbackMutation>;
export type ExposeCtaCallbackMutationResult = Apollo.MutationResult<ExposeCtaCallbackMutation>;
export type ExposeCtaCallbackMutationOptions = Apollo.BaseMutationOptions<ExposeCtaCallbackMutation, ExposeCtaCallbackMutationVariables>;
export const ExposeCtaResellCallbackDocument = gql`
    mutation ExposeCtaResellCallback($exposeFolderSlug: String!, $recordId: ID!, $data: CtaResellDataInput!) {
  exposeCtaResellCallback(
    exposeFolderSlug: $exposeFolderSlug
    recordId: $recordId
    data: $data
  )
}
    `;
export type ExposeCtaResellCallbackMutationFn = Apollo.MutationFunction<ExposeCtaResellCallbackMutation, ExposeCtaResellCallbackMutationVariables>;

/**
 * __useExposeCtaResellCallbackMutation__
 *
 * To run a mutation, you first call `useExposeCtaResellCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExposeCtaResellCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exposeCtaResellCallbackMutation, { data, loading, error }] = useExposeCtaResellCallbackMutation({
 *   variables: {
 *      exposeFolderSlug: // value for 'exposeFolderSlug'
 *      recordId: // value for 'recordId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useExposeCtaResellCallbackMutation(baseOptions?: Apollo.MutationHookOptions<ExposeCtaResellCallbackMutation, ExposeCtaResellCallbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExposeCtaResellCallbackMutation, ExposeCtaResellCallbackMutationVariables>(ExposeCtaResellCallbackDocument, options);
      }
export type ExposeCtaResellCallbackMutationHookResult = ReturnType<typeof useExposeCtaResellCallbackMutation>;
export type ExposeCtaResellCallbackMutationResult = Apollo.MutationResult<ExposeCtaResellCallbackMutation>;
export type ExposeCtaResellCallbackMutationOptions = Apollo.BaseMutationOptions<ExposeCtaResellCallbackMutation, ExposeCtaResellCallbackMutationVariables>;
export const RequestContactPersonCtaDocument = gql`
    mutation RequestContactPersonCta($inp: EufeRequestContactPersonCtaInput!, $exposeFolderRecordId: ID!) {
  eufeRequestContactPersonCta(
    inp: $inp
    exposeFolderRecordId: $exposeFolderRecordId
  ) {
    ... on ErrorType {
      ...Error
    }
    ... on SuccessType {
      ...Success
    }
  }
}
    ${ErrorFragmentDoc}
${SuccessFragmentDoc}`;
export type RequestContactPersonCtaMutationFn = Apollo.MutationFunction<RequestContactPersonCtaMutation, RequestContactPersonCtaMutationVariables>;

/**
 * __useRequestContactPersonCtaMutation__
 *
 * To run a mutation, you first call `useRequestContactPersonCtaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestContactPersonCtaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestContactPersonCtaMutation, { data, loading, error }] = useRequestContactPersonCtaMutation({
 *   variables: {
 *      inp: // value for 'inp'
 *      exposeFolderRecordId: // value for 'exposeFolderRecordId'
 *   },
 * });
 */
export function useRequestContactPersonCtaMutation(baseOptions?: Apollo.MutationHookOptions<RequestContactPersonCtaMutation, RequestContactPersonCtaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestContactPersonCtaMutation, RequestContactPersonCtaMutationVariables>(RequestContactPersonCtaDocument, options);
      }
export type RequestContactPersonCtaMutationHookResult = ReturnType<typeof useRequestContactPersonCtaMutation>;
export type RequestContactPersonCtaMutationResult = Apollo.MutationResult<RequestContactPersonCtaMutation>;
export type RequestContactPersonCtaMutationOptions = Apollo.BaseMutationOptions<RequestContactPersonCtaMutation, RequestContactPersonCtaMutationVariables>;
export const UserAgentDocument = gql`
    query UserAgent {
  userAgent {
    ...UserAgent
  }
}
    ${UserAgentFragmentDoc}`;

/**
 * __useUserAgentQuery__
 *
 * To run a query within a React component, call `useUserAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAgentQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAgentQuery(baseOptions?: Apollo.QueryHookOptions<UserAgentQuery, UserAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAgentQuery, UserAgentQueryVariables>(UserAgentDocument, options);
      }
export function useUserAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAgentQuery, UserAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAgentQuery, UserAgentQueryVariables>(UserAgentDocument, options);
        }
export function useUserAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserAgentQuery, UserAgentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserAgentQuery, UserAgentQueryVariables>(UserAgentDocument, options);
        }
export type UserAgentQueryHookResult = ReturnType<typeof useUserAgentQuery>;
export type UserAgentLazyQueryHookResult = ReturnType<typeof useUserAgentLazyQuery>;
export type UserAgentSuspenseQueryHookResult = ReturnType<typeof useUserAgentSuspenseQuery>;
export type UserAgentQueryResult = Apollo.QueryResult<UserAgentQuery, UserAgentQueryVariables>;
export const CurrentOfficeDocument = gql`
    query CurrentOffice($isThemeEditor: Boolean = false) {
  currentOffice @client {
    ...Office
  }
}
    ${OfficeFragmentDoc}`;

/**
 * __useCurrentOfficeQuery__
 *
 * To run a query within a React component, call `useCurrentOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentOfficeQuery({
 *   variables: {
 *      isThemeEditor: // value for 'isThemeEditor'
 *   },
 * });
 */
export function useCurrentOfficeQuery(baseOptions?: Apollo.QueryHookOptions<CurrentOfficeQuery, CurrentOfficeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentOfficeQuery, CurrentOfficeQueryVariables>(CurrentOfficeDocument, options);
      }
export function useCurrentOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentOfficeQuery, CurrentOfficeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentOfficeQuery, CurrentOfficeQueryVariables>(CurrentOfficeDocument, options);
        }
export function useCurrentOfficeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentOfficeQuery, CurrentOfficeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentOfficeQuery, CurrentOfficeQueryVariables>(CurrentOfficeDocument, options);
        }
export type CurrentOfficeQueryHookResult = ReturnType<typeof useCurrentOfficeQuery>;
export type CurrentOfficeLazyQueryHookResult = ReturnType<typeof useCurrentOfficeLazyQuery>;
export type CurrentOfficeSuspenseQueryHookResult = ReturnType<typeof useCurrentOfficeSuspenseQuery>;
export type CurrentOfficeQueryResult = Apollo.QueryResult<CurrentOfficeQuery, CurrentOfficeQueryVariables>;
export const CurrentContactPersonDocument = gql`
    query CurrentContactPerson {
  currentContactPerson @client {
    ...ContactPerson
  }
}
    ${ContactPersonFragmentDoc}`;

/**
 * __useCurrentContactPersonQuery__
 *
 * To run a query within a React component, call `useCurrentContactPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentContactPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentContactPersonQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentContactPersonQuery(baseOptions?: Apollo.QueryHookOptions<CurrentContactPersonQuery, CurrentContactPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentContactPersonQuery, CurrentContactPersonQueryVariables>(CurrentContactPersonDocument, options);
      }
export function useCurrentContactPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentContactPersonQuery, CurrentContactPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentContactPersonQuery, CurrentContactPersonQueryVariables>(CurrentContactPersonDocument, options);
        }
export function useCurrentContactPersonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentContactPersonQuery, CurrentContactPersonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentContactPersonQuery, CurrentContactPersonQueryVariables>(CurrentContactPersonDocument, options);
        }
export type CurrentContactPersonQueryHookResult = ReturnType<typeof useCurrentContactPersonQuery>;
export type CurrentContactPersonLazyQueryHookResult = ReturnType<typeof useCurrentContactPersonLazyQuery>;
export type CurrentContactPersonSuspenseQueryHookResult = ReturnType<typeof useCurrentContactPersonSuspenseQuery>;
export type CurrentContactPersonQueryResult = Apollo.QueryResult<CurrentContactPersonQuery, CurrentContactPersonQueryVariables>;
export const CurrentOrgIdDocument = gql`
    query CurrentOrgId {
  currentOrgId @client
}
    `;

/**
 * __useCurrentOrgIdQuery__
 *
 * To run a query within a React component, call `useCurrentOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentOrgIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentOrgIdQuery(baseOptions?: Apollo.QueryHookOptions<CurrentOrgIdQuery, CurrentOrgIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentOrgIdQuery, CurrentOrgIdQueryVariables>(CurrentOrgIdDocument, options);
      }
export function useCurrentOrgIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentOrgIdQuery, CurrentOrgIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentOrgIdQuery, CurrentOrgIdQueryVariables>(CurrentOrgIdDocument, options);
        }
export function useCurrentOrgIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentOrgIdQuery, CurrentOrgIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentOrgIdQuery, CurrentOrgIdQueryVariables>(CurrentOrgIdDocument, options);
        }
export type CurrentOrgIdQueryHookResult = ReturnType<typeof useCurrentOrgIdQuery>;
export type CurrentOrgIdLazyQueryHookResult = ReturnType<typeof useCurrentOrgIdLazyQuery>;
export type CurrentOrgIdSuspenseQueryHookResult = ReturnType<typeof useCurrentOrgIdSuspenseQuery>;
export type CurrentOrgIdQueryResult = Apollo.QueryResult<CurrentOrgIdQuery, CurrentOrgIdQueryVariables>;
export const IsLoggedInDocument = gql`
    query IsLoggedIn {
  isLoggedIn
}
    `;

/**
 * __useIsLoggedInQuery__
 *
 * To run a query within a React component, call `useIsLoggedInQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsLoggedInQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLoggedInQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsLoggedInQuery(baseOptions?: Apollo.QueryHookOptions<IsLoggedInQuery, IsLoggedInQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsLoggedInQuery, IsLoggedInQueryVariables>(IsLoggedInDocument, options);
      }
export function useIsLoggedInLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsLoggedInQuery, IsLoggedInQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsLoggedInQuery, IsLoggedInQueryVariables>(IsLoggedInDocument, options);
        }
export function useIsLoggedInSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsLoggedInQuery, IsLoggedInQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsLoggedInQuery, IsLoggedInQueryVariables>(IsLoggedInDocument, options);
        }
export type IsLoggedInQueryHookResult = ReturnType<typeof useIsLoggedInQuery>;
export type IsLoggedInLazyQueryHookResult = ReturnType<typeof useIsLoggedInLazyQuery>;
export type IsLoggedInSuspenseQueryHookResult = ReturnType<typeof useIsLoggedInSuspenseQuery>;
export type IsLoggedInQueryResult = Apollo.QueryResult<IsLoggedInQuery, IsLoggedInQueryVariables>;
export const MemberDataDocument = gql`
    query MemberData {
  memberSelf {
    ...Member
  }
}
    ${MemberFragmentDoc}`;

/**
 * __useMemberDataQuery__
 *
 * To run a query within a React component, call `useMemberDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberDataQuery(baseOptions?: Apollo.QueryHookOptions<MemberDataQuery, MemberDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberDataQuery, MemberDataQueryVariables>(MemberDataDocument, options);
      }
export function useMemberDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberDataQuery, MemberDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberDataQuery, MemberDataQueryVariables>(MemberDataDocument, options);
        }
export function useMemberDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberDataQuery, MemberDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberDataQuery, MemberDataQueryVariables>(MemberDataDocument, options);
        }
export type MemberDataQueryHookResult = ReturnType<typeof useMemberDataQuery>;
export type MemberDataLazyQueryHookResult = ReturnType<typeof useMemberDataLazyQuery>;
export type MemberDataSuspenseQueryHookResult = ReturnType<typeof useMemberDataSuspenseQuery>;
export type MemberDataQueryResult = Apollo.QueryResult<MemberDataQuery, MemberDataQueryVariables>;
export const MemberProfileDataDocument = gql`
    query MemberProfileData {
  memberSelf {
    ...MemberProfile
  }
}
    ${MemberProfileFragmentDoc}`;

/**
 * __useMemberProfileDataQuery__
 *
 * To run a query within a React component, call `useMemberProfileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberProfileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberProfileDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberProfileDataQuery(baseOptions?: Apollo.QueryHookOptions<MemberProfileDataQuery, MemberProfileDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberProfileDataQuery, MemberProfileDataQueryVariables>(MemberProfileDataDocument, options);
      }
export function useMemberProfileDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberProfileDataQuery, MemberProfileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberProfileDataQuery, MemberProfileDataQueryVariables>(MemberProfileDataDocument, options);
        }
export function useMemberProfileDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberProfileDataQuery, MemberProfileDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberProfileDataQuery, MemberProfileDataQueryVariables>(MemberProfileDataDocument, options);
        }
export type MemberProfileDataQueryHookResult = ReturnType<typeof useMemberProfileDataQuery>;
export type MemberProfileDataLazyQueryHookResult = ReturnType<typeof useMemberProfileDataLazyQuery>;
export type MemberProfileDataSuspenseQueryHookResult = ReturnType<typeof useMemberProfileDataSuspenseQuery>;
export type MemberProfileDataQueryResult = Apollo.QueryResult<MemberProfileDataQuery, MemberProfileDataQueryVariables>;
export const MemberMagicLinkDocument = gql`
    query MemberMagicLink {
  memberSelf {
    id
    permanentLoginMagicLink
  }
}
    `;

/**
 * __useMemberMagicLinkQuery__
 *
 * To run a query within a React component, call `useMemberMagicLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberMagicLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberMagicLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberMagicLinkQuery(baseOptions?: Apollo.QueryHookOptions<MemberMagicLinkQuery, MemberMagicLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberMagicLinkQuery, MemberMagicLinkQueryVariables>(MemberMagicLinkDocument, options);
      }
export function useMemberMagicLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberMagicLinkQuery, MemberMagicLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberMagicLinkQuery, MemberMagicLinkQueryVariables>(MemberMagicLinkDocument, options);
        }
export function useMemberMagicLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberMagicLinkQuery, MemberMagicLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberMagicLinkQuery, MemberMagicLinkQueryVariables>(MemberMagicLinkDocument, options);
        }
export type MemberMagicLinkQueryHookResult = ReturnType<typeof useMemberMagicLinkQuery>;
export type MemberMagicLinkLazyQueryHookResult = ReturnType<typeof useMemberMagicLinkLazyQuery>;
export type MemberMagicLinkSuspenseQueryHookResult = ReturnType<typeof useMemberMagicLinkSuspenseQuery>;
export type MemberMagicLinkQueryResult = Apollo.QueryResult<MemberMagicLinkQuery, MemberMagicLinkQueryVariables>;
export const CampaignsDocument = gql`
    query Campaigns {
  xcCampaigns {
    ...Campaign
  }
}
    ${CampaignFragmentDoc}`;

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export function useCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsSuspenseQueryHookResult = ReturnType<typeof useCampaignsSuspenseQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const CampaignAnalyticsDocument = gql`
    query CampaignAnalytics($analyticsFilter: XCCampaignAnalyticsFilterInput) {
  xcCampaignAnalytics(inp: $analyticsFilter) {
    avgDocumentScansPerFolder
    topDocumentScans(top: 3) {
      count
      car: mobRecord {
        ...Car
      }
    }
    weeklyBucketScans {
      ...AnalyticLV
    }
    hourlyBucketScans {
      ...AnalyticLV
    }
    dailyStats {
      ...AnalyticBucket
    }
    totalStats {
      ...AnalyticBucket
    }
  }
}
    ${CarFragmentDoc}
${AnalyticLvFragmentDoc}
${AnalyticBucketFragmentDoc}`;

/**
 * __useCampaignAnalyticsQuery__
 *
 * To run a query within a React component, call `useCampaignAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAnalyticsQuery({
 *   variables: {
 *      analyticsFilter: // value for 'analyticsFilter'
 *   },
 * });
 */
export function useCampaignAnalyticsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignAnalyticsQuery, CampaignAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignAnalyticsQuery, CampaignAnalyticsQueryVariables>(CampaignAnalyticsDocument, options);
      }
export function useCampaignAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignAnalyticsQuery, CampaignAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignAnalyticsQuery, CampaignAnalyticsQueryVariables>(CampaignAnalyticsDocument, options);
        }
export function useCampaignAnalyticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignAnalyticsQuery, CampaignAnalyticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignAnalyticsQuery, CampaignAnalyticsQueryVariables>(CampaignAnalyticsDocument, options);
        }
export type CampaignAnalyticsQueryHookResult = ReturnType<typeof useCampaignAnalyticsQuery>;
export type CampaignAnalyticsLazyQueryHookResult = ReturnType<typeof useCampaignAnalyticsLazyQuery>;
export type CampaignAnalyticsSuspenseQueryHookResult = ReturnType<typeof useCampaignAnalyticsSuspenseQuery>;
export type CampaignAnalyticsQueryResult = Apollo.QueryResult<CampaignAnalyticsQuery, CampaignAnalyticsQueryVariables>;
export const SingleCarDocument = gql`
    query SingleCar($carId: ID!, $featureId: ID!) {
  memberSelf {
    id
    feature(featureId: $featureId) {
      id
      collectionSe {
        id
        car: mobRecord(mobRecordId: $carId) {
          ...Car
        }
      }
    }
  }
}
    ${CarFragmentDoc}`;

/**
 * __useSingleCarQuery__
 *
 * To run a query within a React component, call `useSingleCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCarQuery({
 *   variables: {
 *      carId: // value for 'carId'
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useSingleCarQuery(baseOptions: Apollo.QueryHookOptions<SingleCarQuery, SingleCarQueryVariables> & ({ variables: SingleCarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCarQuery, SingleCarQueryVariables>(SingleCarDocument, options);
      }
export function useSingleCarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCarQuery, SingleCarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCarQuery, SingleCarQueryVariables>(SingleCarDocument, options);
        }
export function useSingleCarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleCarQuery, SingleCarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleCarQuery, SingleCarQueryVariables>(SingleCarDocument, options);
        }
export type SingleCarQueryHookResult = ReturnType<typeof useSingleCarQuery>;
export type SingleCarLazyQueryHookResult = ReturnType<typeof useSingleCarLazyQuery>;
export type SingleCarSuspenseQueryHookResult = ReturnType<typeof useSingleCarSuspenseQuery>;
export type SingleCarQueryResult = Apollo.QueryResult<SingleCarQuery, SingleCarQueryVariables>;
export const StockDocument = gql`
    query Stock($featureId: ID!) {
  seMobField0Mapping(featureId: $featureId) {
    ...Stock
  }
}
    ${StockFragmentDoc}`;

/**
 * __useStockQuery__
 *
 * To run a query within a React component, call `useStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockQuery({
 *   variables: {
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useStockQuery(baseOptions: Apollo.QueryHookOptions<StockQuery, StockQueryVariables> & ({ variables: StockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockQuery, StockQueryVariables>(StockDocument, options);
      }
export function useStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockQuery, StockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockQuery, StockQueryVariables>(StockDocument, options);
        }
export function useStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StockQuery, StockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StockQuery, StockQueryVariables>(StockDocument, options);
        }
export type StockQueryHookResult = ReturnType<typeof useStockQuery>;
export type StockLazyQueryHookResult = ReturnType<typeof useStockLazyQuery>;
export type StockSuspenseQueryHookResult = ReturnType<typeof useStockSuspenseQuery>;
export type StockQueryResult = Apollo.QueryResult<StockQuery, StockQueryVariables>;
export const CarFilterValuesDocument = gql`
    query CarFilterValues($filterStock: String, $kilometers: MinMaxInputIntType, $totalPrice: MinMaxInputIntType, $firstRegistration: MinMaxInputIntType, $fuelType: Int, $gearbox: Int, $carType: Int, $reducedCarType: ReducedCarType, $featureId: ID!) {
  memberSelf {
    id
    feature(featureId: $featureId) {
      id
      collectionSe {
        id
        filterSpec(
          filterStock: $filterStock
          filterComplex: {kilometer: $kilometers, totalPrice: $totalPrice, ez: $firstRegistration, kraftstoffart: $fuelType, getriebeart: $gearbox, carType: $carType, reducedCarType: $reducedCarType}
        )
        filterStats: mobRecordStats {
          kmMin
          kmMax
          priceMin
          priceMax
        }
      }
    }
  }
}
    `;

/**
 * __useCarFilterValuesQuery__
 *
 * To run a query within a React component, call `useCarFilterValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarFilterValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarFilterValuesQuery({
 *   variables: {
 *      filterStock: // value for 'filterStock'
 *      kilometers: // value for 'kilometers'
 *      totalPrice: // value for 'totalPrice'
 *      firstRegistration: // value for 'firstRegistration'
 *      fuelType: // value for 'fuelType'
 *      gearbox: // value for 'gearbox'
 *      carType: // value for 'carType'
 *      reducedCarType: // value for 'reducedCarType'
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useCarFilterValuesQuery(baseOptions: Apollo.QueryHookOptions<CarFilterValuesQuery, CarFilterValuesQueryVariables> & ({ variables: CarFilterValuesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarFilterValuesQuery, CarFilterValuesQueryVariables>(CarFilterValuesDocument, options);
      }
export function useCarFilterValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarFilterValuesQuery, CarFilterValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarFilterValuesQuery, CarFilterValuesQueryVariables>(CarFilterValuesDocument, options);
        }
export function useCarFilterValuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CarFilterValuesQuery, CarFilterValuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarFilterValuesQuery, CarFilterValuesQueryVariables>(CarFilterValuesDocument, options);
        }
export type CarFilterValuesQueryHookResult = ReturnType<typeof useCarFilterValuesQuery>;
export type CarFilterValuesLazyQueryHookResult = ReturnType<typeof useCarFilterValuesLazyQuery>;
export type CarFilterValuesSuspenseQueryHookResult = ReturnType<typeof useCarFilterValuesSuspenseQuery>;
export type CarFilterValuesQueryResult = Apollo.QueryResult<CarFilterValuesQuery, CarFilterValuesQueryVariables>;
export const CarListIdsDocument = gql`
    query CarListIds($filterStock: String, $filterModelComplex: ComplexModellFilterInputType, $kilometers: MinMaxInputIntType, $totalPrice: MinMaxInputIntType, $firstRegistration: MinMaxInputIntType, $fuelType: Int, $gearbox: Int, $carType: Int, $reducedCarType: ReducedCarType, $featureId: ID!) {
  memberSelf {
    id
    feature(featureId: $featureId) {
      id
      collectionSe {
        id
        carIds: mobRecordIds(
          filterStock: $filterStock
          filterComplex: {kilometer: $kilometers, totalPrice: $totalPrice, ez: $firstRegistration, kraftstoffart: $fuelType, getriebeart: $gearbox, carType: $carType, reducedCarType: $reducedCarType}
          filterModellComplex: $filterModelComplex
        )
      }
    }
  }
}
    `;

/**
 * __useCarListIdsQuery__
 *
 * To run a query within a React component, call `useCarListIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarListIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarListIdsQuery({
 *   variables: {
 *      filterStock: // value for 'filterStock'
 *      filterModelComplex: // value for 'filterModelComplex'
 *      kilometers: // value for 'kilometers'
 *      totalPrice: // value for 'totalPrice'
 *      firstRegistration: // value for 'firstRegistration'
 *      fuelType: // value for 'fuelType'
 *      gearbox: // value for 'gearbox'
 *      carType: // value for 'carType'
 *      reducedCarType: // value for 'reducedCarType'
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useCarListIdsQuery(baseOptions: Apollo.QueryHookOptions<CarListIdsQuery, CarListIdsQueryVariables> & ({ variables: CarListIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarListIdsQuery, CarListIdsQueryVariables>(CarListIdsDocument, options);
      }
export function useCarListIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarListIdsQuery, CarListIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarListIdsQuery, CarListIdsQueryVariables>(CarListIdsDocument, options);
        }
export function useCarListIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CarListIdsQuery, CarListIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarListIdsQuery, CarListIdsQueryVariables>(CarListIdsDocument, options);
        }
export type CarListIdsQueryHookResult = ReturnType<typeof useCarListIdsQuery>;
export type CarListIdsLazyQueryHookResult = ReturnType<typeof useCarListIdsLazyQuery>;
export type CarListIdsSuspenseQueryHookResult = ReturnType<typeof useCarListIdsSuspenseQuery>;
export type CarListIdsQueryResult = Apollo.QueryResult<CarListIdsQuery, CarListIdsQueryVariables>;
export const CarListDocument = gql`
    query CarList($documentIds: [ID!], $offset: Int = 0, $limit: Int = 20, $textSearch: String, $filterStock: String, $filterModelComplex: ComplexModellFilterInputType, $kilometers: MinMaxInputIntType, $totalPrice: MinMaxInputIntType, $firstRegistration: MinMaxInputIntType, $fuelType: Int, $gearbox: Int, $carType: Int, $reducedCarType: ReducedCarType, $featureId: ID!) {
  memberSelf {
    id
    feature(featureId: $featureId) {
      id
      collectionSe {
        id
        cars: mobRecords(
          documentIds: $documentIds
          offset: $offset
          limit: $limit
          textSearch: $textSearch
          filterStock: $filterStock
          filterComplex: {kilometer: $kilometers, totalPrice: $totalPrice, ez: $firstRegistration, kraftstoffart: $fuelType, getriebeart: $gearbox, carType: $carType, reducedCarType: $reducedCarType}
          filterModellComplex: $filterModelComplex
        ) {
          total
          items {
            ...Car
          }
        }
      }
    }
  }
}
    ${CarFragmentDoc}`;

/**
 * __useCarListQuery__
 *
 * To run a query within a React component, call `useCarListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarListQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      textSearch: // value for 'textSearch'
 *      filterStock: // value for 'filterStock'
 *      filterModelComplex: // value for 'filterModelComplex'
 *      kilometers: // value for 'kilometers'
 *      totalPrice: // value for 'totalPrice'
 *      firstRegistration: // value for 'firstRegistration'
 *      fuelType: // value for 'fuelType'
 *      gearbox: // value for 'gearbox'
 *      carType: // value for 'carType'
 *      reducedCarType: // value for 'reducedCarType'
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useCarListQuery(baseOptions: Apollo.QueryHookOptions<CarListQuery, CarListQueryVariables> & ({ variables: CarListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarListQuery, CarListQueryVariables>(CarListDocument, options);
      }
export function useCarListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarListQuery, CarListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarListQuery, CarListQueryVariables>(CarListDocument, options);
        }
export function useCarListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CarListQuery, CarListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarListQuery, CarListQueryVariables>(CarListDocument, options);
        }
export type CarListQueryHookResult = ReturnType<typeof useCarListQuery>;
export type CarListLazyQueryHookResult = ReturnType<typeof useCarListLazyQuery>;
export type CarListSuspenseQueryHookResult = ReturnType<typeof useCarListSuspenseQuery>;
export type CarListQueryResult = Apollo.QueryResult<CarListQuery, CarListQueryVariables>;
export const StockListDocument = gql`
    query StockList($featureId: ID!) {
  seMobField0Mapping(featureId: $featureId) {
    ...Stock
  }
}
    ${StockFragmentDoc}`;

/**
 * __useStockListQuery__
 *
 * To run a query within a React component, call `useStockListQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockListQuery({
 *   variables: {
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useStockListQuery(baseOptions: Apollo.QueryHookOptions<StockListQuery, StockListQueryVariables> & ({ variables: StockListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockListQuery, StockListQueryVariables>(StockListDocument, options);
      }
export function useStockListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockListQuery, StockListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockListQuery, StockListQueryVariables>(StockListDocument, options);
        }
export function useStockListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StockListQuery, StockListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StockListQuery, StockListQueryVariables>(StockListDocument, options);
        }
export type StockListQueryHookResult = ReturnType<typeof useStockListQuery>;
export type StockListLazyQueryHookResult = ReturnType<typeof useStockListLazyQuery>;
export type StockListSuspenseQueryHookResult = ReturnType<typeof useStockListSuspenseQuery>;
export type StockListQueryResult = Apollo.QueryResult<StockListQuery, StockListQueryVariables>;
export const EditDocumentDocument = gql`
    query EditDocument($documentVersionId: ID!, $isXcEditor: Boolean = false, $isThemeEditor: Boolean = false) {
  editDocument(documentVersionId: $documentVersionId) {
    ...XCNwData
  }
}
    ${XcNwDataFragmentDoc}`;

/**
 * __useEditDocumentQuery__
 *
 * To run a query within a React component, call `useEditDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditDocumentQuery({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      isXcEditor: // value for 'isXcEditor'
 *      isThemeEditor: // value for 'isThemeEditor'
 *   },
 * });
 */
export function useEditDocumentQuery(baseOptions: Apollo.QueryHookOptions<EditDocumentQuery, EditDocumentQueryVariables> & ({ variables: EditDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditDocumentQuery, EditDocumentQueryVariables>(EditDocumentDocument, options);
      }
export function useEditDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditDocumentQuery, EditDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditDocumentQuery, EditDocumentQueryVariables>(EditDocumentDocument, options);
        }
export function useEditDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditDocumentQuery, EditDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditDocumentQuery, EditDocumentQueryVariables>(EditDocumentDocument, options);
        }
export type EditDocumentQueryHookResult = ReturnType<typeof useEditDocumentQuery>;
export type EditDocumentLazyQueryHookResult = ReturnType<typeof useEditDocumentLazyQuery>;
export type EditDocumentSuspenseQueryHookResult = ReturnType<typeof useEditDocumentSuspenseQuery>;
export type EditDocumentQueryResult = Apollo.QueryResult<EditDocumentQuery, EditDocumentQueryVariables>;
export const XcMediaLibraryDocument = gql`
    query XCMediaLibrary($documentVersionId: ID!) {
  editDocument(documentVersionId: $documentVersionId) {
    id
    xcMediaLibrary {
      ...XCMediaRef
    }
  }
}
    ${XcMediaRefFragmentDoc}`;

/**
 * __useXcMediaLibraryQuery__
 *
 * To run a query within a React component, call `useXcMediaLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useXcMediaLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useXcMediaLibraryQuery({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *   },
 * });
 */
export function useXcMediaLibraryQuery(baseOptions: Apollo.QueryHookOptions<XcMediaLibraryQuery, XcMediaLibraryQueryVariables> & ({ variables: XcMediaLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<XcMediaLibraryQuery, XcMediaLibraryQueryVariables>(XcMediaLibraryDocument, options);
      }
export function useXcMediaLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<XcMediaLibraryQuery, XcMediaLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<XcMediaLibraryQuery, XcMediaLibraryQueryVariables>(XcMediaLibraryDocument, options);
        }
export function useXcMediaLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<XcMediaLibraryQuery, XcMediaLibraryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<XcMediaLibraryQuery, XcMediaLibraryQueryVariables>(XcMediaLibraryDocument, options);
        }
export type XcMediaLibraryQueryHookResult = ReturnType<typeof useXcMediaLibraryQuery>;
export type XcMediaLibraryLazyQueryHookResult = ReturnType<typeof useXcMediaLibraryLazyQuery>;
export type XcMediaLibrarySuspenseQueryHookResult = ReturnType<typeof useXcMediaLibrarySuspenseQuery>;
export type XcMediaLibraryQueryResult = Apollo.QueryResult<XcMediaLibraryQuery, XcMediaLibraryQueryVariables>;
export const LockStatusDocument = gql`
    query LockStatus($documentVersionId: ID!, $isXcEditor: Boolean = false) {
  editDocument(documentVersionId: $documentVersionId) {
    id
    pages(editable: $isXcEditor) {
      ...EufePageLockStatus
      panels {
        id
        blocks(editable: $isXcEditor) {
          ...XCNwBlockLockStatus
        }
      }
      nestedPanels {
        id
        blocks(editable: $isXcEditor) {
          ...XCNwBlockLockStatus
        }
      }
    }
  }
}
    ${EufePageLockStatusFragmentDoc}
${XcNwBlockLockStatusFragmentDoc}`;

/**
 * __useLockStatusQuery__
 *
 * To run a query within a React component, call `useLockStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useLockStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLockStatusQuery({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useLockStatusQuery(baseOptions: Apollo.QueryHookOptions<LockStatusQuery, LockStatusQueryVariables> & ({ variables: LockStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LockStatusQuery, LockStatusQueryVariables>(LockStatusDocument, options);
      }
export function useLockStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LockStatusQuery, LockStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LockStatusQuery, LockStatusQueryVariables>(LockStatusDocument, options);
        }
export function useLockStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LockStatusQuery, LockStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LockStatusQuery, LockStatusQueryVariables>(LockStatusDocument, options);
        }
export type LockStatusQueryHookResult = ReturnType<typeof useLockStatusQuery>;
export type LockStatusLazyQueryHookResult = ReturnType<typeof useLockStatusLazyQuery>;
export type LockStatusSuspenseQueryHookResult = ReturnType<typeof useLockStatusSuspenseQuery>;
export type LockStatusQueryResult = Apollo.QueryResult<LockStatusQuery, LockStatusQueryVariables>;
export const ThemeEditorFontsDocument = gql`
    query ThemeEditorFonts {
  fonts {
    ...KeyValue
  }
}
    ${KeyValueFragmentDoc}`;

/**
 * __useThemeEditorFontsQuery__
 *
 * To run a query within a React component, call `useThemeEditorFontsQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemeEditorFontsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemeEditorFontsQuery({
 *   variables: {
 *   },
 * });
 */
export function useThemeEditorFontsQuery(baseOptions?: Apollo.QueryHookOptions<ThemeEditorFontsQuery, ThemeEditorFontsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThemeEditorFontsQuery, ThemeEditorFontsQueryVariables>(ThemeEditorFontsDocument, options);
      }
export function useThemeEditorFontsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThemeEditorFontsQuery, ThemeEditorFontsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThemeEditorFontsQuery, ThemeEditorFontsQueryVariables>(ThemeEditorFontsDocument, options);
        }
export function useThemeEditorFontsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThemeEditorFontsQuery, ThemeEditorFontsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThemeEditorFontsQuery, ThemeEditorFontsQueryVariables>(ThemeEditorFontsDocument, options);
        }
export type ThemeEditorFontsQueryHookResult = ReturnType<typeof useThemeEditorFontsQuery>;
export type ThemeEditorFontsLazyQueryHookResult = ReturnType<typeof useThemeEditorFontsLazyQuery>;
export type ThemeEditorFontsSuspenseQueryHookResult = ReturnType<typeof useThemeEditorFontsSuspenseQuery>;
export type ThemeEditorFontsQueryResult = Apollo.QueryResult<ThemeEditorFontsQuery, ThemeEditorFontsQueryVariables>;
export const ThemeEditorThemesDocument = gql`
    query ThemeEditorThemes($isThemeEditor: Boolean = false) {
  memberSelf {
    id
    organization {
      id
      xcThemes {
        ...XCTheme
      }
    }
  }
}
    ${XcThemeFragmentDoc}`;

/**
 * __useThemeEditorThemesQuery__
 *
 * To run a query within a React component, call `useThemeEditorThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useThemeEditorThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThemeEditorThemesQuery({
 *   variables: {
 *      isThemeEditor: // value for 'isThemeEditor'
 *   },
 * });
 */
export function useThemeEditorThemesQuery(baseOptions?: Apollo.QueryHookOptions<ThemeEditorThemesQuery, ThemeEditorThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThemeEditorThemesQuery, ThemeEditorThemesQueryVariables>(ThemeEditorThemesDocument, options);
      }
export function useThemeEditorThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThemeEditorThemesQuery, ThemeEditorThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThemeEditorThemesQuery, ThemeEditorThemesQueryVariables>(ThemeEditorThemesDocument, options);
        }
export function useThemeEditorThemesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThemeEditorThemesQuery, ThemeEditorThemesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThemeEditorThemesQuery, ThemeEditorThemesQueryVariables>(ThemeEditorThemesDocument, options);
        }
export type ThemeEditorThemesQueryHookResult = ReturnType<typeof useThemeEditorThemesQuery>;
export type ThemeEditorThemesLazyQueryHookResult = ReturnType<typeof useThemeEditorThemesLazyQuery>;
export type ThemeEditorThemesSuspenseQueryHookResult = ReturnType<typeof useThemeEditorThemesSuspenseQuery>;
export type ThemeEditorThemesQueryResult = Apollo.QueryResult<ThemeEditorThemesQuery, ThemeEditorThemesQueryVariables>;
export const CheckMediaMd5Document = gql`
    query CheckMediaMd5($md5: String!) {
  checkMediaMd5(md5: $md5)
}
    `;

/**
 * __useCheckMediaMd5Query__
 *
 * To run a query within a React component, call `useCheckMediaMd5Query` and pass it any options that fit your needs.
 * When your component renders, `useCheckMediaMd5Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckMediaMd5Query({
 *   variables: {
 *      md5: // value for 'md5'
 *   },
 * });
 */
export function useCheckMediaMd5Query(baseOptions: Apollo.QueryHookOptions<CheckMediaMd5Query, CheckMediaMd5QueryVariables> & ({ variables: CheckMediaMd5QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckMediaMd5Query, CheckMediaMd5QueryVariables>(CheckMediaMd5Document, options);
      }
export function useCheckMediaMd5LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckMediaMd5Query, CheckMediaMd5QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckMediaMd5Query, CheckMediaMd5QueryVariables>(CheckMediaMd5Document, options);
        }
export function useCheckMediaMd5SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckMediaMd5Query, CheckMediaMd5QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckMediaMd5Query, CheckMediaMd5QueryVariables>(CheckMediaMd5Document, options);
        }
export type CheckMediaMd5QueryHookResult = ReturnType<typeof useCheckMediaMd5Query>;
export type CheckMediaMd5LazyQueryHookResult = ReturnType<typeof useCheckMediaMd5LazyQuery>;
export type CheckMediaMd5SuspenseQueryHookResult = ReturnType<typeof useCheckMediaMd5SuspenseQuery>;
export type CheckMediaMd5QueryResult = Apollo.QueryResult<CheckMediaMd5Query, CheckMediaMd5QueryVariables>;
export const CmsCollectionsDocument = gql`
    query CmsCollections {
  xcCmsCollections {
    ...CmsCollection
  }
}
    ${CmsCollectionFragmentDoc}`;

/**
 * __useCmsCollectionsQuery__
 *
 * To run a query within a React component, call `useCmsCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCmsCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<CmsCollectionsQuery, CmsCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsCollectionsQuery, CmsCollectionsQueryVariables>(CmsCollectionsDocument, options);
      }
export function useCmsCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsCollectionsQuery, CmsCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsCollectionsQuery, CmsCollectionsQueryVariables>(CmsCollectionsDocument, options);
        }
export function useCmsCollectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CmsCollectionsQuery, CmsCollectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CmsCollectionsQuery, CmsCollectionsQueryVariables>(CmsCollectionsDocument, options);
        }
export type CmsCollectionsQueryHookResult = ReturnType<typeof useCmsCollectionsQuery>;
export type CmsCollectionsLazyQueryHookResult = ReturnType<typeof useCmsCollectionsLazyQuery>;
export type CmsCollectionsSuspenseQueryHookResult = ReturnType<typeof useCmsCollectionsSuspenseQuery>;
export type CmsCollectionsQueryResult = Apollo.QueryResult<CmsCollectionsQuery, CmsCollectionsQueryVariables>;
export const CmsCollectionDocument = gql`
    query CmsCollection($collectionId: ID!) {
  xcCmsCollection(collectionId: $collectionId) {
    id
    editContent {
      ...CmsCollectionDocument
    }
    liveContent {
      ...CmsCollectionDocument
    }
  }
}
    ${CmsCollectionDocumentFragmentDoc}`;

/**
 * __useCmsCollectionQuery__
 *
 * To run a query within a React component, call `useCmsCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCmsCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCmsCollectionQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useCmsCollectionQuery(baseOptions: Apollo.QueryHookOptions<CmsCollectionQuery, CmsCollectionQueryVariables> & ({ variables: CmsCollectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CmsCollectionQuery, CmsCollectionQueryVariables>(CmsCollectionDocument, options);
      }
export function useCmsCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CmsCollectionQuery, CmsCollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CmsCollectionQuery, CmsCollectionQueryVariables>(CmsCollectionDocument, options);
        }
export function useCmsCollectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CmsCollectionQuery, CmsCollectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CmsCollectionQuery, CmsCollectionQueryVariables>(CmsCollectionDocument, options);
        }
export type CmsCollectionQueryHookResult = ReturnType<typeof useCmsCollectionQuery>;
export type CmsCollectionLazyQueryHookResult = ReturnType<typeof useCmsCollectionLazyQuery>;
export type CmsCollectionSuspenseQueryHookResult = ReturnType<typeof useCmsCollectionSuspenseQuery>;
export type CmsCollectionQueryResult = Apollo.QueryResult<CmsCollectionQuery, CmsCollectionQueryVariables>;
export const XcDisclaimersDocument = gql`
    query XCDisclaimers($collectionId: ID!) {
  xcDisclaimers(collectionId: $collectionId) {
    ...XCDisclaimerInterface
  }
}
    ${XcDisclaimerInterfaceFragmentDoc}`;

/**
 * __useXcDisclaimersQuery__
 *
 * To run a query within a React component, call `useXcDisclaimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useXcDisclaimersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useXcDisclaimersQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useXcDisclaimersQuery(baseOptions: Apollo.QueryHookOptions<XcDisclaimersQuery, XcDisclaimersQueryVariables> & ({ variables: XcDisclaimersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<XcDisclaimersQuery, XcDisclaimersQueryVariables>(XcDisclaimersDocument, options);
      }
export function useXcDisclaimersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<XcDisclaimersQuery, XcDisclaimersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<XcDisclaimersQuery, XcDisclaimersQueryVariables>(XcDisclaimersDocument, options);
        }
export function useXcDisclaimersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<XcDisclaimersQuery, XcDisclaimersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<XcDisclaimersQuery, XcDisclaimersQueryVariables>(XcDisclaimersDocument, options);
        }
export type XcDisclaimersQueryHookResult = ReturnType<typeof useXcDisclaimersQuery>;
export type XcDisclaimersLazyQueryHookResult = ReturnType<typeof useXcDisclaimersLazyQuery>;
export type XcDisclaimersSuspenseQueryHookResult = ReturnType<typeof useXcDisclaimersSuspenseQuery>;
export type XcDisclaimersQueryResult = Apollo.QueryResult<XcDisclaimersQuery, XcDisclaimersQueryVariables>;
export const ExposeFolderDocument = gql`
    query ExposeFolder($slug: String!, $isThemeEditor: Boolean = false) {
  exposeFolder(slug: $slug) {
    ... on ExposeFolderType {
      ...ExposeFolder
    }
    ... on ErrorType {
      ...Error
    }
  }
  userAgent {
    ...UserAgent
  }
}
    ${ExposeFolderFragmentDoc}
${ErrorFragmentDoc}
${UserAgentFragmentDoc}`;

/**
 * __useExposeFolderQuery__
 *
 * To run a query within a React component, call `useExposeFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposeFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposeFolderQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      isThemeEditor: // value for 'isThemeEditor'
 *   },
 * });
 */
export function useExposeFolderQuery(baseOptions: Apollo.QueryHookOptions<ExposeFolderQuery, ExposeFolderQueryVariables> & ({ variables: ExposeFolderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExposeFolderQuery, ExposeFolderQueryVariables>(ExposeFolderDocument, options);
      }
export function useExposeFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExposeFolderQuery, ExposeFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExposeFolderQuery, ExposeFolderQueryVariables>(ExposeFolderDocument, options);
        }
export function useExposeFolderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExposeFolderQuery, ExposeFolderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExposeFolderQuery, ExposeFolderQueryVariables>(ExposeFolderDocument, options);
        }
export type ExposeFolderQueryHookResult = ReturnType<typeof useExposeFolderQuery>;
export type ExposeFolderLazyQueryHookResult = ReturnType<typeof useExposeFolderLazyQuery>;
export type ExposeFolderSuspenseQueryHookResult = ReturnType<typeof useExposeFolderSuspenseQuery>;
export type ExposeFolderQueryResult = Apollo.QueryResult<ExposeFolderQuery, ExposeFolderQueryVariables>;
export const DocumentDocument = gql`
    query Document($identifier: UUID!, $isXcEditor: Boolean = false, $isThemeEditor: Boolean = false) {
  document(identifier: $identifier) {
    ... on DocumentType {
      ...XCNwData
    }
    ... on ErrorType {
      ...Error
    }
    ... on MobRecordType {
      ...ExposeData
    }
  }
}
    ${XcNwDataFragmentDoc}
${ErrorFragmentDoc}
${ExposeDataFragmentDoc}`;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      isXcEditor: // value for 'isXcEditor'
 *      isThemeEditor: // value for 'isThemeEditor'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions: Apollo.QueryHookOptions<DocumentQuery, DocumentQueryVariables> & ({ variables: DocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
      }
export function useDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
        }
export function useDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentSuspenseQueryHookResult = ReturnType<typeof useDocumentSuspenseQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export const ExposeFolderDetailsDocument = gql`
    query ExposeFolderDetails($slug: String!, $recordId: ID!, $isXcEditor: Boolean = false, $isThemeEditor: Boolean = false) {
  exposeFolderRecord(recordId: $recordId, slug: $slug) {
    ...XCRecord
  }
}
    ${XcRecordFragmentDoc}`;

/**
 * __useExposeFolderDetailsQuery__
 *
 * To run a query within a React component, call `useExposeFolderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposeFolderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposeFolderDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      recordId: // value for 'recordId'
 *      isXcEditor: // value for 'isXcEditor'
 *      isThemeEditor: // value for 'isThemeEditor'
 *   },
 * });
 */
export function useExposeFolderDetailsQuery(baseOptions: Apollo.QueryHookOptions<ExposeFolderDetailsQuery, ExposeFolderDetailsQueryVariables> & ({ variables: ExposeFolderDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExposeFolderDetailsQuery, ExposeFolderDetailsQueryVariables>(ExposeFolderDetailsDocument, options);
      }
export function useExposeFolderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExposeFolderDetailsQuery, ExposeFolderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExposeFolderDetailsQuery, ExposeFolderDetailsQueryVariables>(ExposeFolderDetailsDocument, options);
        }
export function useExposeFolderDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExposeFolderDetailsQuery, ExposeFolderDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExposeFolderDetailsQuery, ExposeFolderDetailsQueryVariables>(ExposeFolderDetailsDocument, options);
        }
export type ExposeFolderDetailsQueryHookResult = ReturnType<typeof useExposeFolderDetailsQuery>;
export type ExposeFolderDetailsLazyQueryHookResult = ReturnType<typeof useExposeFolderDetailsLazyQuery>;
export type ExposeFolderDetailsSuspenseQueryHookResult = ReturnType<typeof useExposeFolderDetailsSuspenseQuery>;
export type ExposeFolderDetailsQueryResult = Apollo.QueryResult<ExposeFolderDetailsQuery, ExposeFolderDetailsQueryVariables>;
export const IntegrationBlocksDocument = gql`
    query IntegrationBlocks($integrationType: OfficeIntegrationEnum!, $defaultValue: String, $isXcEditor: Boolean = false, $integrationInput: IntegrationQueryInput!) {
  integrationBlocks(
    defaultValue: $defaultValue
    integrationType: $integrationType
    integrationInput: $integrationInput
  ) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;

/**
 * __useIntegrationBlocksQuery__
 *
 * To run a query within a React component, call `useIntegrationBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationBlocksQuery({
 *   variables: {
 *      integrationType: // value for 'integrationType'
 *      defaultValue: // value for 'defaultValue'
 *      isXcEditor: // value for 'isXcEditor'
 *      integrationInput: // value for 'integrationInput'
 *   },
 * });
 */
export function useIntegrationBlocksQuery(baseOptions: Apollo.QueryHookOptions<IntegrationBlocksQuery, IntegrationBlocksQueryVariables> & ({ variables: IntegrationBlocksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationBlocksQuery, IntegrationBlocksQueryVariables>(IntegrationBlocksDocument, options);
      }
export function useIntegrationBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationBlocksQuery, IntegrationBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationBlocksQuery, IntegrationBlocksQueryVariables>(IntegrationBlocksDocument, options);
        }
export function useIntegrationBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationBlocksQuery, IntegrationBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationBlocksQuery, IntegrationBlocksQueryVariables>(IntegrationBlocksDocument, options);
        }
export type IntegrationBlocksQueryHookResult = ReturnType<typeof useIntegrationBlocksQuery>;
export type IntegrationBlocksLazyQueryHookResult = ReturnType<typeof useIntegrationBlocksLazyQuery>;
export type IntegrationBlocksSuspenseQueryHookResult = ReturnType<typeof useIntegrationBlocksSuspenseQuery>;
export type IntegrationBlocksQueryResult = Apollo.QueryResult<IntegrationBlocksQuery, IntegrationBlocksQueryVariables>;
export const ContentLandingPageDocument = gql`
    query ContentLandingPage($clpSlug: String!, $isCufeApp: Boolean = false, $isThemeEditor: Boolean = false, $isXcEditor: Boolean = false) {
  contentLandingPage(clpSlug: $clpSlug) {
    ...ContentLandingPage
  }
}
    ${ContentLandingPageFragmentDoc}`;

/**
 * __useContentLandingPageQuery__
 *
 * To run a query within a React component, call `useContentLandingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentLandingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentLandingPageQuery({
 *   variables: {
 *      clpSlug: // value for 'clpSlug'
 *      isCufeApp: // value for 'isCufeApp'
 *      isThemeEditor: // value for 'isThemeEditor'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useContentLandingPageQuery(baseOptions: Apollo.QueryHookOptions<ContentLandingPageQuery, ContentLandingPageQueryVariables> & ({ variables: ContentLandingPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentLandingPageQuery, ContentLandingPageQueryVariables>(ContentLandingPageDocument, options);
      }
export function useContentLandingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentLandingPageQuery, ContentLandingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentLandingPageQuery, ContentLandingPageQueryVariables>(ContentLandingPageDocument, options);
        }
export function useContentLandingPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentLandingPageQuery, ContentLandingPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentLandingPageQuery, ContentLandingPageQueryVariables>(ContentLandingPageDocument, options);
        }
export type ContentLandingPageQueryHookResult = ReturnType<typeof useContentLandingPageQuery>;
export type ContentLandingPageLazyQueryHookResult = ReturnType<typeof useContentLandingPageLazyQuery>;
export type ContentLandingPageSuspenseQueryHookResult = ReturnType<typeof useContentLandingPageSuspenseQuery>;
export type ContentLandingPageQueryResult = Apollo.QueryResult<ContentLandingPageQuery, ContentLandingPageQueryVariables>;
export const IsFolderItemAvailableDocument = gql`
    query IsFolderItemAvailable($slug: String!, $exposeFolderRecordId: ID!) {
  isFolderItemAvailable(exposeFolderRecordId: $exposeFolderRecordId, slug: $slug)
}
    `;

/**
 * __useIsFolderItemAvailableQuery__
 *
 * To run a query within a React component, call `useIsFolderItemAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsFolderItemAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsFolderItemAvailableQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      exposeFolderRecordId: // value for 'exposeFolderRecordId'
 *   },
 * });
 */
export function useIsFolderItemAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsFolderItemAvailableQuery, IsFolderItemAvailableQueryVariables> & ({ variables: IsFolderItemAvailableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsFolderItemAvailableQuery, IsFolderItemAvailableQueryVariables>(IsFolderItemAvailableDocument, options);
      }
export function useIsFolderItemAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsFolderItemAvailableQuery, IsFolderItemAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsFolderItemAvailableQuery, IsFolderItemAvailableQueryVariables>(IsFolderItemAvailableDocument, options);
        }
export function useIsFolderItemAvailableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsFolderItemAvailableQuery, IsFolderItemAvailableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsFolderItemAvailableQuery, IsFolderItemAvailableQueryVariables>(IsFolderItemAvailableDocument, options);
        }
export type IsFolderItemAvailableQueryHookResult = ReturnType<typeof useIsFolderItemAvailableQuery>;
export type IsFolderItemAvailableLazyQueryHookResult = ReturnType<typeof useIsFolderItemAvailableLazyQuery>;
export type IsFolderItemAvailableSuspenseQueryHookResult = ReturnType<typeof useIsFolderItemAvailableSuspenseQuery>;
export type IsFolderItemAvailableQueryResult = Apollo.QueryResult<IsFolderItemAvailableQuery, IsFolderItemAvailableQueryVariables>;
export const IsClpAvailableDocument = gql`
    query IsClpAvailable($clpSlug: String!) {
  isClpAvailable(clpSlug: $clpSlug)
}
    `;

/**
 * __useIsClpAvailableQuery__
 *
 * To run a query within a React component, call `useIsClpAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsClpAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsClpAvailableQuery({
 *   variables: {
 *      clpSlug: // value for 'clpSlug'
 *   },
 * });
 */
export function useIsClpAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsClpAvailableQuery, IsClpAvailableQueryVariables> & ({ variables: IsClpAvailableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsClpAvailableQuery, IsClpAvailableQueryVariables>(IsClpAvailableDocument, options);
      }
export function useIsClpAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsClpAvailableQuery, IsClpAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsClpAvailableQuery, IsClpAvailableQueryVariables>(IsClpAvailableDocument, options);
        }
export function useIsClpAvailableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsClpAvailableQuery, IsClpAvailableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsClpAvailableQuery, IsClpAvailableQueryVariables>(IsClpAvailableDocument, options);
        }
export type IsClpAvailableQueryHookResult = ReturnType<typeof useIsClpAvailableQuery>;
export type IsClpAvailableLazyQueryHookResult = ReturnType<typeof useIsClpAvailableLazyQuery>;
export type IsClpAvailableSuspenseQueryHookResult = ReturnType<typeof useIsClpAvailableSuspenseQuery>;
export type IsClpAvailableQueryResult = Apollo.QueryResult<IsClpAvailableQuery, IsClpAvailableQueryVariables>;
export const EditorBlockLockStatusDocument = gql`
    subscription EditorBlockLockStatus($documentVersionId: ID!) {
  editorBlockLockStatus(documentVersionId: $documentVersionId) {
    id
    lockStatus {
      ...LockStatus
    }
  }
}
    ${LockStatusFragmentDoc}`;

/**
 * __useEditorBlockLockStatusSubscription__
 *
 * To run a query within a React component, call `useEditorBlockLockStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEditorBlockLockStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorBlockLockStatusSubscription({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *   },
 * });
 */
export function useEditorBlockLockStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<EditorBlockLockStatusSubscription, EditorBlockLockStatusSubscriptionVariables> & ({ variables: EditorBlockLockStatusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EditorBlockLockStatusSubscription, EditorBlockLockStatusSubscriptionVariables>(EditorBlockLockStatusDocument, options);
      }
export type EditorBlockLockStatusSubscriptionHookResult = ReturnType<typeof useEditorBlockLockStatusSubscription>;
export type EditorBlockLockStatusSubscriptionResult = Apollo.SubscriptionResult<EditorBlockLockStatusSubscription>;
export const EditorPageLockStatusDocument = gql`
    subscription EditorPageLockStatus($documentVersionId: ID!) {
  editorPageLockStatus(documentVersionId: $documentVersionId) {
    id
    lockStatus {
      ...LockStatus
    }
  }
}
    ${LockStatusFragmentDoc}`;

/**
 * __useEditorPageLockStatusSubscription__
 *
 * To run a query within a React component, call `useEditorPageLockStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEditorPageLockStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorPageLockStatusSubscription({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *   },
 * });
 */
export function useEditorPageLockStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<EditorPageLockStatusSubscription, EditorPageLockStatusSubscriptionVariables> & ({ variables: EditorPageLockStatusSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EditorPageLockStatusSubscription, EditorPageLockStatusSubscriptionVariables>(EditorPageLockStatusDocument, options);
      }
export type EditorPageLockStatusSubscriptionHookResult = ReturnType<typeof useEditorPageLockStatusSubscription>;
export type EditorPageLockStatusSubscriptionResult = Apollo.SubscriptionResult<EditorPageLockStatusSubscription>;
export const EditorPagesDocument = gql`
    subscription EditorPages($documentVersionId: ID!, $isXcEditor: Boolean = false) {
  editorPages(documentVersionId: $documentVersionId) {
    ...EufePage
  }
}
    ${EufePageFragmentDoc}`;

/**
 * __useEditorPagesSubscription__
 *
 * To run a query within a React component, call `useEditorPagesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEditorPagesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorPagesSubscription({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useEditorPagesSubscription(baseOptions: Apollo.SubscriptionHookOptions<EditorPagesSubscription, EditorPagesSubscriptionVariables> & ({ variables: EditorPagesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EditorPagesSubscription, EditorPagesSubscriptionVariables>(EditorPagesDocument, options);
      }
export type EditorPagesSubscriptionHookResult = ReturnType<typeof useEditorPagesSubscription>;
export type EditorPagesSubscriptionResult = Apollo.SubscriptionResult<EditorPagesSubscription>;
export const EditorPanelsDocument = gql`
    subscription EditorPanels($documentVersionId: ID!, $isXcEditor: Boolean = false) {
  editorPanels(documentVersionId: $documentVersionId) {
    id
    blocks(editable: $isXcEditor) {
      ...XCNwBlock
    }
  }
}
    ${XcNwBlockFragmentDoc}`;

/**
 * __useEditorPanelsSubscription__
 *
 * To run a query within a React component, call `useEditorPanelsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEditorPanelsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorPanelsSubscription({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useEditorPanelsSubscription(baseOptions: Apollo.SubscriptionHookOptions<EditorPanelsSubscription, EditorPanelsSubscriptionVariables> & ({ variables: EditorPanelsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EditorPanelsSubscription, EditorPanelsSubscriptionVariables>(EditorPanelsDocument, options);
      }
export type EditorPanelsSubscriptionHookResult = ReturnType<typeof useEditorPanelsSubscription>;
export type EditorPanelsSubscriptionResult = Apollo.SubscriptionResult<EditorPanelsSubscription>;
export const EditorDocumentDocument = gql`
    subscription EditorDocument($documentVersionId: ID!, $isXcEditor: Boolean = false, $isThemeEditor: Boolean = false) {
  editorDocument(documentVersionId: $documentVersionId) {
    ...XCNwData
  }
}
    ${XcNwDataFragmentDoc}`;

/**
 * __useEditorDocumentSubscription__
 *
 * To run a query within a React component, call `useEditorDocumentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEditorDocumentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorDocumentSubscription({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      isXcEditor: // value for 'isXcEditor'
 *      isThemeEditor: // value for 'isThemeEditor'
 *   },
 * });
 */
export function useEditorDocumentSubscription(baseOptions: Apollo.SubscriptionHookOptions<EditorDocumentSubscription, EditorDocumentSubscriptionVariables> & ({ variables: EditorDocumentSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EditorDocumentSubscription, EditorDocumentSubscriptionVariables>(EditorDocumentDocument, options);
      }
export type EditorDocumentSubscriptionHookResult = ReturnType<typeof useEditorDocumentSubscription>;
export type EditorDocumentSubscriptionResult = Apollo.SubscriptionResult<EditorDocumentSubscription>;
export const EditorBlocksDocument = gql`
    subscription EditorBlocks($documentVersionId: ID!, $isXcEditor: Boolean = false) {
  editorBlocks(documentVersionId: $documentVersionId) {
    ...XCNwBlock
  }
}
    ${XcNwBlockFragmentDoc}`;

/**
 * __useEditorBlocksSubscription__
 *
 * To run a query within a React component, call `useEditorBlocksSubscription` and pass it any options that fit your needs.
 * When your component renders, `useEditorBlocksSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorBlocksSubscription({
 *   variables: {
 *      documentVersionId: // value for 'documentVersionId'
 *      isXcEditor: // value for 'isXcEditor'
 *   },
 * });
 */
export function useEditorBlocksSubscription(baseOptions: Apollo.SubscriptionHookOptions<EditorBlocksSubscription, EditorBlocksSubscriptionVariables> & ({ variables: EditorBlocksSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<EditorBlocksSubscription, EditorBlocksSubscriptionVariables>(EditorBlocksDocument, options);
      }
export type EditorBlocksSubscriptionHookResult = ReturnType<typeof useEditorBlocksSubscription>;
export type EditorBlocksSubscriptionResult = Apollo.SubscriptionResult<EditorBlocksSubscription>;